import React, { createContext, createRef, type FC, type ReactNode, useContext, useEffect, useRef, useState } from "react";
import * as ReactDOMServer from 'react-dom/server';
import AIODate from "../aio-date";
import { type AI_optionDetail, AITree, type AI_optionProp } from "../aio-input";
import ReactDOM from 'react-dom/client';
import { anime, $, Prism, Sortable, saveAs } from "aio-deps";
import usePopup from "../aio-popup";
import './index.css';
type I_dateObject = { year?: number, month?: number, day?: number, hour?: number, minute?: number };
export type I_Date = string | number | Date | I_dateObject | number[];
export function HasClass(e: any, className: string) {
    try {
        const target = ToJquery(e)
        return target.hasClass(className) || !!target.parents(`.${className}`).length
    }
    catch { return false }
}
export function GetAttr(e: any, attrName: string) {
    try { return ToJquery(e).closest('[' + attrName + ']').attr(attrName) || null; } catch { return null }
}
export function ToJquery(e: any): any {
    if (!e) return $();
    if (e instanceof Event) { return e.target === null ? $() : $(e.target as HTMLElement); }
    if ((e as any).jquery) { return e as any; }
    if (e.nodeType) { return $(e); }
    return $(e);
}
export function Ellipsis(text: string, length: number, position?: 'center' | 'end' | 'start') {
    if (text.length <= length) { return text }
    if (position === 'end') { return text.slice(0, length) + '...' }
    if (position === 'start') { return '...' + text.slice(text.length - length, text.length) }
    const startIndex = Math.floor(length / 2);
    const endIndex = text.length - Math.ceil(length / 2);
    const start = text.slice(0, startIndex)
    const end = text.slice(endIndex, text.length)
    return (start + ' ... ' + end)
}
export { anime }
type FileValue = File | {
    name: string;
    size: number;
    url: string;
    [key: string]: any;
};
export class FileClass {
    File2Url = async (file: File | string): Promise<string> => {
        if (typeof file === 'string') { return file }
        return new Promise((resolve, reject) => {
            try {
                let fr = new FileReader();
                fr.onload = function () { resolve(fr.result as string) }
                fr.readAsDataURL(file);
            }
            catch { reject('') }
        })
    }
    saveImageCordova = async (data: string | File, fileName?: string) => {
        try {
            const name = fileName || 'image_' + Date.now() + '.jpg';
            let blob: Blob;

            // ---- نوع داده ورودی ----
            if (data instanceof File) {
                blob = data;
            } else if (typeof data === 'string' && data.startsWith('data:image')) {
                const base64 = data.split(',')[1];
                const mime = data.split(';')[0].split(':')[1];
                const byteChars = atob(base64);
                const byteNums = new Array(byteChars.length);
                for (let i = 0; i < byteChars.length; i++) byteNums[i] = byteChars.charCodeAt(i);
                blob = new Blob([new Uint8Array(byteNums)], { type: mime });
            } else if (typeof data === 'string') {
                const res = await fetch(data);
                blob = await res.blob();
            } else {
                alert('❌ نوع داده پشتیبانی نمی‌شود');
                return;
            }

            // ---- اگر Cordova در دسترس بود ----
            const cordovaFile = (window as any).cordova?.file;
            if (cordovaFile) {
                const dir = cordovaFile.externalRootDirectory + 'Download/';
                alert('📁 مسیر ذخیره: ' + dir);

                (window as any).resolveLocalFileSystemURL(dir, (dirEntry: any) => {
                    dirEntry.getFile(name, { create: true, exclusive: false }, (fileEntry: any) => {
                        fileEntry.createWriter((writer: any) => {
                            writer.onwriteend = () => alert('✅ تصویر با موفقیت ذخیره شد!');
                            writer.onerror = (err: any) => alert('❌ خطا در نوشتن فایل: ' + err.toString());
                            writer.write(blob);
                        });
                    }, (err: any) => alert('❌ خطا در گرفتن فایل: ' + JSON.stringify(err)));
                }, (err: any) => alert('❌ خطا در دسترسی به مسیر دانلود: ' + JSON.stringify(err)));
            }
            // ---- حالت مرورگر/PWA ----
            else {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
                alert('✅ فایل با موفقیت دانلود شد (PWA حالت)');
            }

        } catch (err: any) {
            alert('❌ خطا: ' + err.message);
        }
    }

    GetDurationByUrl = async (url: string): Promise<number | null> => {
        return new Promise((resolve) => {
            const video = document.createElement("video");
            video.preload = "metadata";
            video.src = url;
            video.onloadedmetadata = () => { resolve(isNaN(video.duration) ? null : video.duration); video.remove(); };
            video.onerror = () => { resolve(null); video.remove(); };
        });
    }
    GetSizeByUrl = async (url: string): Promise<number | null> => {
        let size: number | null = null;
        try {
            const res = await fetch(url, { method: "HEAD" });
            const contentLength = res.headers.get("content-length");
            if (contentLength) size = parseInt(contentLength, 10);
        }
        catch (err) { }
        return size
    }
    GetNameByUrl = (url: string) => decodeURIComponent(url.split("/").pop()?.split("?")[0] || "unknown")
    GetFileDetailsByUrl = async (url: string): Promise<{ name: string, size: null | number, duration: null | number }> => {
        const name = this.GetNameByUrl(url);
        const size = await this.GetSizeByUrl(url)
        const duration = await this.GetDurationByUrl(url);
        return { name, size, duration };
    }
    FileToUrl = (file: any) => window.URL.createObjectURL(file)
    FileToBase64 = async (file: any): Promise<string | ArrayBuffer | null> => {
        return new Promise((resolve) => {
            const fileReader = new FileReader();
            fileReader.onload = () => resolve(fileReader.result);
            fileReader.readAsDataURL(file);
        })
    }
    base64ToBlob = (base64: string, mime: string) => {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mime });
    }
    FileToSrc = (file: File) => URL.createObjectURL(file)
    ExportToExcel = (rows: any[], config: any = {}) => {
        let { promptText = 'Inter Excel File Name' } = config;
        let o = {
            fixPersianAndArabicNumbers(str: string): string {
                if (typeof str !== 'string') { return str }
                let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
                    arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
                let i: number;
                for (i = 0; i < 10; i++) { str = str.replace(persianNumbers[i], i.toString()).replace(arabicNumbers[i], i.toString()); }
                return str;
            },
            getJSON(rows: any[]) {
                let result = [];
                for (let i = 0; i < rows.length; i++) {
                    let json = rows[i], fixedJson: any = {};
                    for (let prop in json) { fixedJson[prop] = this.fixPersianAndArabicNumbers(json[prop]) }
                    result.push(fixedJson);
                }
                return result;
            },
            export() {
                let name = window.prompt(promptText);
                if (!name || name === null || !name.length) { return };
                var data = this.getJSON(rows);
                var arrData = typeof data != "object" ? JSON.parse(data) : data;
                var CSV = ""; CSV += '\r\n\n';
                if (true) {
                    let row = "";
                    for (let index in arrData[0]) { row += index + ","; }
                    row = row.slice(0, -1); CSV += row + "\r\n";
                }
                for (var i = 0; i < arrData.length; i++) {
                    let row = "";
                    for (let index in arrData[i]) { row += '"' + arrData[i][index] + '",'; }
                    row.slice(0, row.length - 1); CSV += row + "\r\n";
                }
                if (CSV === "") { alert("Invalid data"); return; }
                var fileName = name.replace(/ /g, "_");
                var universalBOM = "\uFEFF";
                var uri = "data:text/csv;charset=utf-8," + encodeURIComponent(universalBOM + CSV);
                let link: any = document.createElement("a");
                link.href = uri;
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
        return o.export();
    }
    IsFileTypeValid = (file: any): boolean => {
        const fileTypes = ["image/apng", "image/bmp", "image/gif", "image/jpeg", "image/pjpeg", "image/png", "image/svg+xml", "image/tiff", "image/webp", "image/x-icon"];
        return fileTypes.includes(file.type);
    }
    SizeToString = (size: number) => {
        size = typeof size !== 'number' ? 0 : size
        let sizeString;
        let gb = size / (1024 * 1024 * 1024), mb = size / (1024 * 1024), kb = size / 1024;
        if (gb >= 1) { sizeString = gb.toFixed(2) + ' GB'; }
        else if (mb >= 1) { sizeString = mb.toFixed(2) + ' MB'; }
        else if (kb >= 1) { sizeString = kb.toFixed(2) + ' KB'; }
        else { sizeString = size + ' byte' }
        return sizeString
    }
    FilePreview = (file: any, attrs?: any): React.ReactNode => {
        if (!this.IsFileTypeValid(file)) { return null }
        let url: string = this.FileToUrl(file);
        return <img src={url} alt={file.name} title={file.name} objectFit='cover' {...attrs} />
    }
    IsFile = (file: any) => typeof file.slice === "function"
    IsLocalFile = (file: FileValue): boolean => file instanceof File
    handleFileName = (selectedName?: string) => selectedName || window.prompt('Please Enter File Name') || `file-${Date.now()}.json`
    generateFileName = (mimeType?: string) => {
        const map: Record<string, string> = {
            'application/json': 'file.json',
            'text/plain': 'file.txt',
            'text/html': 'file.html',
            'text/csv': 'file.csv',
            'application/pdf': 'file.pdf',
            'image/png': 'image.png',
            'image/jpeg': 'image.jpg',
            'image/webp': 'image.webp',
            'application/zip': 'archive.zip',
            'application/octet-stream': 'file.bin'
        };
        const base = map[mimeType || ''] || 'file.bin';
        const timestamp = Date.now();
        const [name, ext] = base.split('.');
        return `${name}-${timestamp}.${ext}`;
    };
    download = async (
        data: any,
        options?: {
            fileName?: string; beautify?: boolean;
            mimeType?: 'application/json' | 'text/plain' | 'text/html' | 'text/csv' | 'application/pdf' | 'image/png' | 'image/jpeg' | 'image/webp' | 'application/zip' | 'application/octet-stream';
        }
    ) => {
        try {
            const { beautify = true } = options || {};
            let blob: Blob;
            if (data instanceof File) { blob = data; }
            else if (data instanceof Blob) { blob = data; }
            else if (data instanceof ArrayBuffer) { blob = new Blob([data], { type: options?.mimeType || 'application/octet-stream' }); }
            else if (data instanceof Uint8Array) {
                const buffer = data.buffer instanceof ArrayBuffer ? data.buffer : new ArrayBuffer(data.byteLength);
                blob = new Blob([new Uint8Array(buffer)],{type:options?.mimeType || 'application/octet-stream'});
            }
            else if (typeof data === 'string') {
                blob = new Blob([data], { type: options?.mimeType || 'text/plain' });
            }
            else {
                blob = new Blob(
                    [JSON.stringify(data, null, beautify ? 2 : 0)],
                    { type: options?.mimeType || 'application/json' }
                );
            }
            let fileName = options?.fileName;
            if (!fileName && data instanceof File) { fileName = data.name; }
            if (!fileName) { fileName = this.generateFileName(blob.type); }
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
            return { success: true, fileName, mimeType: blob.type };
        }
        catch (err: any) {
            return { success: false, message: err?.message || 'download failed' };
        }
    };
    downloadFile = (file: any, options?: { fileName?: string }) => {
        const blob = new Blob([file], { type: 'application/octet-stream' });
        const fileName = this.handleFileName(options?.fileName);

        saveAs(blob, `${fileName}`);
    }
    filePicker = (p: { inputAttrs?: any, attrs?: any, text: ReactNode, onChange: (files: any[]) => void }) => {
        const inputAttrs = AddToAttrs(p.inputAttrs, { style: { display: 'none' } })
        return (<label {...p.attrs}><input {...inputAttrs} type="file" onChange={p.onChange} />{p.text}</label>)
    }
    // download = async (file: any) => {
    //     let name = file.name;
    //     const corsProxy = 'https://cors-anywhere.herokuapp.com/';
    //     const url = corsProxy + (file.url || this.FileToUrl(file));
    //     fetch(url)
    //         .then(resp => resp.blob())
    //         .then(blob => {
    //             let url = this.FileToUrl(blob);
    //             let a = document.createElement('a');
    //             a.style.display = 'none';
    //             a.href = url;
    //             a.download = name;
    //             document.body.appendChild(a);
    //             a.click();
    //             window.URL.revokeObjectURL(url);
    //         })
    //         .catch(() => alert('oh no!'));
    // }

    readTextFile = async (file: File): Promise<any> => {
        return new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = () => {
                try { const result = JSON.parse(fr.result as string); resolve(result); }
                catch (error: any) { reject(new Error('Error parsing JSON: ' + error.message)); }
            };
            fr.onerror = () => reject(new Error('Error reading file.'));
            fr.readAsText(file);
        });
    }
    toFile = (image: File | Blob | string): Promise<HTMLImageElement> => {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => resolve(img);
            img.onerror = (err) => reject(err);

            if (typeof image === "string") {
                // string می‌تونه url یا base64 یا import باشه
                img.src = image;
            } else {
                // File یا Blob
                const reader = new FileReader();
                reader.onload = () => {
                    img.src = reader.result as string;
                };
                reader.onerror = reject;
                reader.readAsDataURL(image);
            }
        });
    }
}
export const IsNetworkDisconnected = async (errorResponse: any): Promise<boolean> => {
    // if (!errorResponse) {
    //     if (typeof navigator !== "undefined" && !navigator.onLine) {
    //         return true;
    //     }

    //     function checkInternetWithImage(timeout = 3000): Promise<boolean> {
    //         return new Promise((resolve) => {
    //             const img = new Image();
    //             const timer = setTimeout(() => resolve(false), timeout);

    //             img.onload = () => { clearTimeout(timer); resolve(true); };
    //             img.onerror = () => { clearTimeout(timer); resolve(false); };

    //             // آدرس سبک و قابل اطمینان (favicon گوگل)
    //             img.src = `https://www.google.com/favicon.ico?_=${Date.now()}`;
    //         });
    //     }

    //     const connected = await checkInternetWithImage();
    //     return !connected; // اینترنت قطعه وقتی تصویر لود نشه
    // }

    // وقتی ارور پاس شده → بررسی نوع ارور
    const msg = typeof errorResponse.message === "string" ? errorResponse.message : "";

    if (msg.includes("Failed to fetch")) return true;
    if (errorResponse.isAxiosError && msg === "Network Error") return true;
    if (errorResponse.request && !errorResponse.response) return true;
    if (msg.includes("ERR_INTERNET_DISCONNECTED") || msg.includes("ERR_NETWORK_CHANGED")) return true;
    if (typeof navigator !== "undefined" && !navigator.onLine) return true;

    return false;
}
export async function Stall(stallTime: number = 3000) {
    await new Promise(resolve => setTimeout(resolve, stallTime));
}
export function Float(num: number): { int: number, float: number, floatString: string, floatLength: number, round: number } {
    // Convert the number to a string
    num = typeof num !== 'number' ? 0 : num;
    const numberString = num.toString();
    const decimalIndex = numberString.indexOf('.');
    const int = num < 0 ? Math.ceil(num) : Math.floor(num);
    const round = Math.round(num)
    if (decimalIndex === -1) { return { int, floatString: '', float: 0, floatLength: 0, round } }
    const floatString = numberString.slice(decimalIndex, numberString.length);
    const float = +floatString;
    const floatLength = numberString.length - decimalIndex - 1;
    return { floatString, float, floatLength, int, round }
}
export function HandleBackButton(callback: () => void = () => { }) {
    window.history.pushState({}, '')
    window.history.pushState({}, '')
    window.onpopstate = function () {
        window.history.pushState({}, '');
        callback()
    };
}
export function SortArray<T>(
    arr: T[],
    sorts: { getValue?: (v: T, dir: 'inc' | 'dec') => any; dir?: "inc" | "dec", isDate?: boolean }[]
): T[] {
    const DATE = new AIODate();
    return arr.slice().sort((a, b) => {
        for (const { getValue = (a: any) => a, dir = "inc", isDate } of sorts) {
            let va = getValue(a, dir), vb = getValue(b, dir);

            let cmp = isDate
                ? DATE.getTime(va) - DATE.getTime(vb)
                : (typeof va === "number" && typeof vb === "number")
                    ? va - vb
                    : String(va).localeCompare(String(vb));

            if (cmp !== 0) return dir === "inc" ? cmp : -cmp;
        }
        return 0;
    });
}
export function ParseString(str: string): any {
    // Check if the string starts and ends with a quote character
    try {
        if (str.startsWith("{") || str.startsWith('[')) { return JSON.parse(str); }
        else if ((str.startsWith("'") && str.endsWith("'")) || (str.startsWith('"') && str.endsWith('"'))) { return str.slice(1, -1); }
        else { let res = parseFloat(str); return isNaN(res) ? str : res }
    }
    catch { return str }
}
type I_reOrder = (data: any[], dragIndex: number, dropIndex: number) => any[]
export const ReOrder: I_reOrder = (data, dragIndex, dropIndex) => {
    if (!Array.isArray(data)) { console.error('reOrder first parameter(data) should be array') }
    if (typeof dragIndex !== 'number') { console.error('reOrder second parameter(dragIndex) should be array') }
    if (typeof dropIndex !== 'number') { console.error('reOrder third parameter(dropIndex) should be array') }
    let from = data[dragIndex];
    let newData = data.filter((o, i) => {
        if (o) { return i !== dragIndex }
        else { return false }
    });
    newData.splice(dropIndex, 0, from)
    return newData;
}
export type I_useDrag = ReturnType<typeof useDrag>
type I_drag = { index: number | undefined, dom: any, width: number } | false
export const useDrag = (
    callback: (dragData: any, dropData: any, reOrder: (data: any[], dragIndex: number, dropIndex: number) => any[]) => void,
    cardClassName: string
): {
    reOrder: (data: any[], fromIndex: number, toIndex: number) => any[];
    getDragAttrs: (dragData: any) => any;
    getDropAttrs: (dropData: any) => any;
} => {
    useEffect(() => {
        $('html').css({ overflow: 'hidden' })
        $('body').css({ overflow: 'hidden' })
    }, [])
    const dragRef = useRef<I_drag>(false);
    const changeDrag = (v: I_drag) => dragRef.current = v
    const isTouch = IsTouch()
    const getTouchDetail = (e: any): false | { index: number, dom: any } => {
        const touch = e.changedTouches[0];
        const dropTarget = document.elementFromPoint(touch.clientX, touch.clientY);
        if (dropTarget) {
            const targetCard = dropTarget.closest('.' + cardClassName);
            if (targetCard) { return { index: Array.from(document.querySelectorAll('.' + cardClassName)).indexOf(targetCard), dom: targetCard }; }
        }
        return false
    }
    const toggleParent = (state: boolean) => {
        const card = $('.' + cardClassName), cls = 'dragging-parent-overflow-hidden';
        if (state) { card.parents().addClass(cls) }
        else { card.parents().removeClass(cls) }
    }
    const onDragStart = (dragIndex: number) => changeDrag({ index: dragIndex, dom: undefined, width: 0 })
    const onDragOver = (e: any) => e.preventDefault();
    const onDrop = (dropIndex: number) => {
        if (dragRef.current === false) return;
        callback(dragRef.current.index, dropIndex, ReOrder)
        changeDrag(false)
    }
    const onTouchStart = (e: any) => {
        const res = getTouchDetail(e);
        if (res === false) { changeDrag(false); return }
        const { index, dom } = res;
        if (index === -1) { changeDrag(false); }
        else {
            const elem = $(dom)
            toggleParent(true)
            const width = elem.width() || 0
            elem.addClass('dragging')
            changeDrag({ index, dom, width })
            moveDragged(e)
        }
    }
    const onTouchMove = (e: any) => {
        if (dragRef.current === false) return;
        const res = getTouchDetail(e);
        if (res === false) { return }
        effectDrop(res.dom)
        moveDragged(e)
    }
    const onTouchEnd = (e: any) => {
        toggleParent(false)
        if (dragRef.current === false) return;
        const res = getTouchDetail(e);
        if (res === false) { return }
        callback(dragRef.current.index, res.index, ReOrder)
        const card = $('.' + cardClassName)
        card.removeClass('dragging')
        card.css({ width: '100%', zIndex: 0 })
        changeDrag(false)
        effectDrop(-1)

    }
    const moveDragged = (e: any) => {
        if (dragRef.current === false) { return }
        const { dom, width } = dragRef.current
        if (!dom) { return }
        const client = GetClient(e, true)
        $(dom).css({ width, zIndex: 10, top: (client.y - 22) + 'px' });
    }
    const getDragAttrsTouch = () => ({ draggble: false, onTouchStart });
    const getDragAttrsMouse = (dragIndex: number) => ({ onDragStart: () => onDragStart(dragIndex), onDragOver, draggable: true, })
    const effectDrop = (index: number) => {
        $('.' + cardClassName).css({ opacity: 1 })
        if (index !== -1) {
            $('.' + cardClassName).css({ opacity: 1 })
            $('.' + cardClassName).eq(index).css({ opacity: 0.5 })
        }
    }
    const getDragAttrs = (dragIndex: number) => isTouch ? getDragAttrsTouch() : getDragAttrsMouse(dragIndex)
    const getDropAttrsTouch = () => ({ onTouchEnd, onTouchMove });
    const getDropAttrsMouse = (dropIndex: number) => ({ onDragOver, onDrop: () => onDrop(dropIndex), 'data-drop': 'true' })
    const getDropAttrs = (dropIndex: number) => isTouch ? getDropAttrsTouch() : getDropAttrsMouse(dropIndex);
    return { reOrder: ReOrder, getDragAttrs, getDropAttrs };
};
export function GetClient(e: any, scroll?: boolean): { x: number, y: number } {
    const isTouch = IsTouch()
    const scrollLeft = scroll ? e.target.scrollLeft : 0
    const scrollTop = scroll ? e.target.scrollTop : 0
    if (isTouch && e.changedTouches) { return { x: e.changedTouches[0].clientX + scrollLeft - window.pageXOffset, y: e.changedTouches[0].clientY + scrollTop - window.pageYOffset } }
    return { x: e.clientX, y: e.clientY }
}
export function SplitNumber(price: number | string, p?: { count?: number, splitter?: string, toFixed?: number }): string {
    if (price === 0) { return "0" }
    if (!price) { return '' }
    const { count = 3, splitter = ',', toFixed } = p || {}

    let str = price.toString()
    const isNeg = str[0] === '-'
    if (isNeg) { str = str.slice(1, str.length) }
    let dotIndex = str.indexOf('.');
    let per = ''
    if (dotIndex !== -1) {
        per = `${str.slice(dotIndex, str.length)}`;
        if (toFixed === 0) {
            per = ''
        }
        else if (toFixed) {
            if (per.length - 1 > toFixed) {
                per = per.slice(0, toFixed + 1)
            }
        }
        str = str.slice(0, dotIndex);
    }
    let res = ''
    let index = 0;
    for (let i = str.length - 1; i >= 0; i--) {
        res = str[i] + res;
        if (index === count - 1) {
            index = 0;
            if (i > 0) { res = splitter + res; }
        }
        else { index++ }
    }
    return (isNeg ? '-' : '') + res + per
}
export function EventHandler(selector: string, event: 'mousedown' | 'mousemove' | 'mouseup' | 'click', action: any, type?: 'bind' | 'unbind') {
    type = type || 'bind';
    var me = { mousedown: "touchstart", mousemove: "touchmove", mouseup: "touchend", click: 'click' };
    let touch = 'ontouchstart' in document.documentElement
    let fixedEvent = touch ? me[event] : event;
    var element: any = typeof selector === "string" ? (selector === "window" ? $(window) : $(selector)) : selector;
    element.unbind(fixedEvent, action);
    if (type === 'bind') { element.bind(fixedEvent, action) }
}
export function getValueByStep(p: { value: number, start: number, step: number, end: number }) {
    let { value, start, step, end } = p;
    let res = Math.round((value - start) / step) * step + start;
    if (res < start) { res = start }
    if (res > end) { res = end }
    return res;
}
export function GetPercentByValue(start: number, end: number, value: number): number { return ((100 * (value - start)) / (end - start)) }
export function URLToJSON(url: string): { [key: string]: any } {
    try { return JSON.parse(`{"${decodeURI(url.split('?')[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`) }
    catch { return {} }
}
export const JSXToHTML = (jsx: any): string => ReactDOMServer.renderToStaticMarkup(jsx)
export const Copy = async (text: any) => window.navigator.clipboard.writeText(text)
export const IsTouch = (): boolean => "ontouchstart" in document.documentElement
export const Get2Digit = (n: number) => { let ns: string = n.toString(); return ns.length === 1 ? '0' + ns : ns }
export async function Paste() {
    try { return window.navigator.clipboard.read() }
    catch (err: any) { console.log(err.message) }
}
export function Search(items: any[], searchValue: string, getValue: (item: any, index: number) => any = (o) => o): any[] {
    if (!searchValue) { return items }
    function isMatch(keys: string[], value: string) {
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (value.indexOf(key) === -1) { return false }
        }
        return true
    }
    let keys = searchValue.split(' ');
    return items.filter((o, i) => isMatch(keys, getValue(o, i)))
}
export function GenerateComponsition(p: { level?: number, length?: number, childsField?: string, fields: { [key: string]: (p: { index: number, indexes: number[], isLeaf: boolean }) => any } }) {
    let { level: maxLevel = 4, length = 4, childsField = 'childs', fields = {} } = p;
    const generate = (level?: number, index?: string, indexes?: number[]) => {
        level = level || 0; index = index || ''; indexes = indexes || []
        if (level >= maxLevel) { return [] }
        const isLeaf = level === maxLevel
        let res = []
        for (let i = 0; i < length; i++) {
            let newIndex = index + '-' + i;
            let newItem: any = {
                id: 'aa' + Math.round(Math.random() * 10000),
                [childsField]: generate(level + 1, newIndex, [...indexes, i])
            }
            for (let prop in fields) { newItem[prop] = fields[prop]({ index: i, indexes, isLeaf }) }
            res.push(newItem)
        }
        return res
    }
    const result = generate()
    return result
}
export function CalculateDistance(pos1: number[], pos2: number[], unit: 'km' | 'm', round?: boolean) {
    const R = 6371; // Radius of the Earth in kilometers
    const [lat1, lng1] = pos1
    const [lat2, lng2] = pos2
    const dLat = toRadians(lat2 - lat1);
    const dLng = toRadians(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    let res = distance;
    if (unit === 'm') {
        return res = distance * 1000;
    }
    return round ? Math.round(res) : res
}
export const FilterTree = (p: { data: { [key: string]: any }, checkNode: (node: { [key: string]: any }) => boolean, getChilds: (row: any) => any, setChilds: (row: any, childs: any) => any }) => {
    const { getChilds, setChilds, checkNode, data } = p;
    const visibilityMap = new WeakMap();
    function isMatch(node: any, parents: any[] = []): boolean {
        const matched = checkNode(node);
        const childs = getChilds(node) || [];
        let childMatched = false;
        for (let child of childs) {
            if (isMatch(child, [...parents, node])) { childMatched = true; }
        }
        const isVisible = matched || childMatched;
        visibilityMap.set(node, isVisible);
        if (isVisible) { parents.forEach((parent) => visibilityMap.set(parent, true)); }
        return isVisible;
    }
    function filterTree(node: any): any {
        if (!visibilityMap.get(node)) { return null; }
        const filteredNode = { ...node };
        const childs = getChilds(node);
        if (childs) { setChilds(filteredNode, childs.map(filterTree).filter((child: any) => child !== null)) }
        return filteredNode;
    }
    isMatch(data);
    return filterTree(data);
};
export function getEventAttrs(eventType: 'onMouseDown' | 'onMouseMove' | 'onMouseUp', callback: (e: any) => void) {
    let touch = IsTouch()
    let fixedEvent: string;
    if (touch) { fixedEvent = { 'onMouseDown': 'onTouchStart', 'onMouseMove': 'onTouchMove', 'onMouseUp': 'onTouchEnd' }[eventType]; }
    else { fixedEvent = eventType }
    return { [fixedEvent]: callback }
}
function toRadians(degree: number) {
    return degree * (Math.PI / 180);
}
export function classListToString(classes: any[]) {
    let list: string[] = [];
    const getClasses = (cls: any): string[] => {
        if (Array.isArray(cls)) {
            return cls.filter((o) => !!o && typeof o === 'string')
        }
        if (typeof cls === 'string') { return cls.split(' ') }
        return []
    }
    for (let i = 0; i < classes.length; i++) {
        const cls = classes[i];
        list = [...list, ...getClasses(cls)]
    }
    return list.length ? list.join(' ') : ''
}
export function AddToAttrs(attrs: any, p: any) {
    attrs = attrs || {};
    let { style } = p;
    const className = classListToString([attrs.className, p.className])
    let newStyle = { ...attrs.style, ...style };
    return { ...attrs, className, style: newStyle, ...p.attrs }
}
export function GetCities() {
    return {
        "آذربایجان شرقی": ["اسکو", "اهر", "ایلخچی", "آبش احمد", "آذرشهر", "آقکند", "باسمنج", "بخشایش", "بستان آباد", "بناب", "بناب جدید", "تبریز", "ترک", "ترکمانچای", "تسوج", "تیکمه داش", "جلفا", "خاروانا", "خامنه", "خراجو", "خسروشهر", "خضرلو", "خمارلو", "خواجه", "دوزدوزان", "زرنق", "زنوز", "سراب", "سردرود", "سهند", "سیس", "سیه رود", "شبستر", "شربیان", "شرفخانه", "شندآباد", "صوفیان", "عجب شیر", "قره آغاج", "کشکسرای", "کلوانق", "کلیبر", "کوزه کنان", "گوگان", "لیلان", "مراغه", "مرند", "ملکان", "ملک کیان", "ممقان", "مهربان", "میانه", "نظرکهریزی", "هادی شهر", "هرگلان", "هریس", "هشترود", "هوراند", "وایقان", "ورزقان", "یامچی"],
        "آذربایجان غربی": ["ارومیه", "اشنویه", "ایواوغلی", "آواجیق", "باروق", "بازرگان", "بوکان", "پلدشت", "پیرانشهر", "تازه شهر", "تکاب", "چهاربرج", "خوی", "دیزج دیز", "ربط", "سردشت", "سرو", "سلماس", "سیلوانه", "سیمینه", "سیه چشمه", "شاهین دژ", "شوط", "فیرورق", "قره ضیاءالدین", "قطور", "قوشچی", "کشاورز", "گردکشانه", "ماکو", "محمدیار", "محمودآباد", "مهاباد", "میاندوآب", "میرآباد", "نالوس", "نقده", "نوشین"],
        "اردبیل": ["اردبیل", "اصلاندوز", "آبی بیگلو", "بیله سوار", "پارس آباد", "تازه کند", "تازه کندانگوت", "جعفرآباد", "خلخال", "رضی", "سرعین", "عنبران", "فخرآباد", "کلور", "کوراییم", "گرمی", "گیوی", "لاهرود", "مشگین شهر", "نمین", "نیر", "هشتجین", "هیر"],
        "اصفهان": ["ابریشم", "ابوزیدآباد", "اردستان", "اژیه", "اصفهان", "افوس", "انارک", "ایمانشهر", "آران وبیدگل", "بادرود", "باغ بهادران", "بافران", "برزک", "برف انبار", "بهاران شهر", "بهارستان", "بوئین و میاندشت", "پیربکران", "تودشک", "تیران", "جندق", "جوزدان", "جوشقان و کامو", "چادگان", "چرمهین", "چمگردان", "حبیب آباد", "حسن آباد", "حنا", "خالدآباد", "خمینی شهر", "خوانسار", "خور", "خورزوق", "داران", "دامنه", "درچه", "دستگرد", "دهاقان", "دهق", "دولت آباد", "دیزیچه", "رزوه", "رضوانشهر", "زاینده رود", "زرین شهر", "زواره", "زیباشهر", "سده لنجان", "سفیدشهر", "سگزی", "سمیرم", "شاهین شهر", "شهرضا", "طالخونچه", "عسگران", "علویجه", "فرخی", "فریدونشهر", "فلاورجان", "فولادشهر", "قمصر", "قهجاورستان", "قهدریجان", "کاشان", "کرکوند", "کلیشاد و سودرجان", "کمشچه", "کمه", "کهریزسنگ", "کوشک", "کوهپایه", "گرگاب", "گزبرخوار", "گلپایگان", "گلدشت", "گلشهر", "گوگد", "لای بید", "مبارکه", "مجلسی", "محمدآباد", "مشکات", "منظریه", "مهاباد", "میمه", "نائین", "نجف آباد", "نصرآباد", "نطنز", "نوش آباد", "نیاسر", "نیک آباد", "هرند", "ورزنه", "ورنامخواست", "وزوان", "ونک"],
        "البرز": ["اسارا", "اشتهارد", "تنکمان", "تهران دشت", "چهارباغ", "ساوجبلاغ", "سعید آباد", "شهر جدید هشتگرد", "طالقان", "فردیس", "کرج", "کردان", "کمال شهر", "کوهسار", "گرمدره", "گلبهار", "ماهدشت", "محمدشهر", "مشکین دشت", "نظرآباد", "هشتگرد"],
        "ایلام": ["ارکواز", "ایلام", "ایوان", "آبدانان", "آسمان آباد", "بدره", "پهله", "توحید", "چوار", "دره شهر", "دلگشا", "دهلران", "زرنه", "سراب باغ", "سرابله", "صالح آباد", "لومار", "مهران", "مورموری", "موسیان", "میمه"],
        "بوشهر": ["امام حسن", "انارستان", "اهرم", "آب پخش", "آبدان", "برازجان", "بردخون", "بندردیر", "بندردیلم", "بندرریگ", "بندرکنگان", "بندرگناوه", "بنک", "بوشهر", "تنگ ارم", "جم", "چغادک", "خارک", "خورموج", "دالکی", "دلوار", "ریز", "سعدآباد", "سیراف", "شبانکاره", "شنبه", "عسلویه", "کاکی", "کلمه", "نخل تقی", "وحدتیه"],
        "تهران": ["ارجمند", "اسلامشهر", "اندیشه", "آبسرد", "آبعلی", "باغستان", "باقرشهر", "بومهن", "پاکدشت", "پردیس", "پرند", "پیشوا", "تهران", "جوادآباد", "چهاردانگه", "حسن آباد", "دماوند", "دیزین", "شهر ری", "رباط کریم", "رودهن", "شاهدشهر", "شریف آباد", "شمشک", "شهریار", "صالح آباد", "صباشهر", "صفادشت", "فردوسیه", "فشم", "فیروزکوه", "قدس", "قرچک", "قیامدشت", "کهریزک", "کیلان", "گلستان", "لواسان", "مارلیک", "ملارد", "میگون", "نسیم شهر", "نصیرآباد", "وحیدیه", "ورامین"],
        "چهارمحال و بختیاری": ["اردل", "آلونی", "باباحیدر", "بروجن", "بلداجی", "بن", "جونقان", "چلگرد", "سامان", "سفیددشت", "سودجان", "سورشجان", "شلمزار", "شهرکرد", "طاقانک", "فارسان", "فرادنبه", "فرخ شهر", "کیان", "گندمان", "گهرو", "لردگان", "مال خلیفه", "ناغان", "نافچ", "نقنه", "هفشجان"],
        "خراسان جنوبی": ["ارسک", "اسدیه", "اسفدن", "اسلامیه", "آرین شهر", "آیسک", "بشرویه", "بیرجند", "حاجی آباد", "خضری دشت بیاض", "خوسف", "زهان", "سرایان", "سربیشه", "سه قلعه", "شوسف", "طبس ", "فردوس", "قاین", "قهستان", "محمدشهر", "مود", "نهبندان", "نیمبلوک"],
        "خراسان رضوی": ["احمدآباد صولت", "انابد", "باجگیران", "باخرز", "بار", "بایگ", "بجستان", "بردسکن", "بیدخت", "بینالود", "تایباد", "تربت جام", "تربت حیدریه", "جغتای", "جنگل", "چاپشلو", "چکنه", "چناران", "خرو", "خلیل آباد", "خواف", "داورزن", "درگز", "در رود", "دولت آباد", "رباط سنگ", "رشتخوار", "رضویه", "روداب", "ریوش", "سبزوار", "سرخس", "سفیدسنگ", "سلامی", "سلطان آباد", "سنگان", "شادمهر", "شاندیز", "ششتمد", "شهرآباد", "شهرزو", "صالح آباد", "طرقبه", "عشق آباد", "فرهادگرد", "فریمان", "فیروزه", "فیض آباد", "قاسم آباد", "قدمگاه", "قلندرآباد", "قوچان", "کاخک", "کاریز", "کاشمر", "کدکن", "کلات", "کندر", "گلمکان", "گناباد", "لطف آباد", "مزدآوند", "مشهد", "ملک آباد", "نشتیفان", "نصرآباد", "نقاب", "نوخندان", "نیشابور", "نیل شهر", "همت آباد", "یونسی"],
        "خراسان شمالی": ["اسفراین", "ایور", "آشخانه", "بجنورد", "پیش قلعه", "تیتکانلو", "جاجرم", "حصارگرمخان", "درق", "راز", "سنخواست", "شوقان", "شیروان", "صفی آباد", "فاروج", "قاضی", "گرمه", "لوجلی"],
        "خوزستان": ["اروندکنار", "الوان", "امیدیه", "اندیمشک", "اهواز", "ایذه", "آبادان", "آغاجاری", "باغ ملک", "بستان", "بندرامام خمینی", "بندرماهشهر", "بهبهان", "ترکالکی", "جایزان", "چمران", "چویبده", "حر", "حسینیه", "حمزه", "حمیدیه", "خرمشهر", "دارخوین", "دزآب", "دزفول", "دهدز", "رامشیر", "رامهرمز", "رفیع", "زهره", "سالند", "سردشت", "سوسنگرد", "شادگان", "شاوور", "شرافت", "شوش", "شوشتر", "شیبان", "صالح شهر", "صفی آباد", "صیدون", "قلعه تل", "قلعه خواجه", "گتوند", "لالی", "مسجدسلیمان", "ملاثانی", "میانرود", "مینوشهر", "هفتگل", "هندیجان", "هویزه", "ویس"],
        "زنجان": ["ابهر", "ارمغان خانه", "آب بر", "چورزق", "حلب", "خرمدره", "دندی", "زرین آباد", "زرین رود", "زنجان", "سجاس", "سلطانیه", "سهرورد", "صائین قلعه", "قیدار", "گرماب", "ماه نشان", "هیدج"],
        "سمنان": ["امیریه", "ایوانکی", "آرادان", "بسطام", "بیارجمند", "دامغان", "درجزین", "دیباج", "سرخه", "سمنان", "شاهرود", "شهمیرزاد", "کلاته خیج", "گرمسار", "مجن", "مهدی شهر", "میامی"],
        "سیستان و بلوچستان": ["ادیمی", "اسپکه", "ایرانشهر", "بزمان", "بمپور", "بنت", "بنجار", "پیشین", "جالق", "چابهار", "خاش", "دوست محمد", "راسک", "زابل", "زابلی", "زاهدان", "زهک", "سراوان", "سرباز", "سوران", "سیرکان", "علی اکبر", "فنوج", "قصرقند", "کنارک", "گشت", "گلمورتی", "محمدان", "محمدآباد", "محمدی", "میرجاوه", "نصرت آباد", "نگور", "نوک آباد", "نیک شهر", "هیدوچ"],
        "فارس": ["اردکان", "ارسنجان", "استهبان", "اشکنان", "افزر", "اقلید", "امام شهر", "اهل", "اوز", "ایج", "ایزدخواست", "آباده", "آباده طشک", "باب انار", "بالاده", "بنارویه", "بهمن", "بوانات", "بیرم", "بیضا", "جنت شهر", "جهرم", "جویم", "زرین دشت", "حسن آباد", "خان زنیان", "خاوران", "خرامه", "خشت", "خنج", "خور", "داراب", "داریان", "دبیران", "دژکرد", "دهرم", "دوبرجی", "رامجرد", "رونیز", "زاهدشهر", "زرقان", "سده", "سروستان", "سعادت شهر", "سورمق", "سیدان", "ششده", "شهرپیر", "شهرصدرا", "شیراز", "صغاد", "صفاشهر", "علامرودشت", "فدامی", "فراشبند", "فسا", "فیروزآباد", "قائمیه", "قادرآباد", "قطب آباد", "قطرویه", "قیر", "کارزین (فتح آباد)", "کازرون", "کامفیروز", "کره ای", "کنارتخته", "کوار", "گراش", "گله دار", "لار", "لامرد", "لپویی", "لطیفی", "مبارک آباددیز", "مرودشت", "مشکان", "مصیری", "مهر", "میمند", "نوبندگان", "نوجین", "نودان", "نورآباد", "نی ریز", "وراوی"],
        "قزوین": ["ارداق", "اسفرورین", "اقبالیه", "الوند", "آبگرم", "آبیک", "آوج", "بوئین زهرا", "بیدستان", "تاکستان", "خاکعلی", "خرمدشت", "دانسفهان", "رازمیان", "سگزآباد", "سیردان", "شال", "شریفیه", "ضیاآباد", "قزوین", "کوهین", "محمدیه", "محمودآباد نمونه", "معلم کلایه", "نرجه"],
        "قم": ["جعفریه", "دستجرد", "سلفچگان", "قم", "قنوات", "کهک"],
        "کردستان": ["آرمرده", "بابارشانی", "بانه", "بلبان آباد", "بوئین سفلی", "بیجار", "چناره", "دزج", "دلبران", "دهگلان", "دیواندره", "زرینه", "سروآباد", "سریش آباد", "سقز", "سنندج", "شویشه", "صاحب", "قروه", "کامیاران", "کانی دینار", "کانی سور", "مریوان", "موچش", "یاسوکند"],
        "کرمان": ["اختیارآباد", "ارزوئیه", "امین شهر", "انار", "اندوهجرد", "باغین", "بافت", "بردسیر", "بروات", "بزنجان", "بم", "بهرمان", "پاریز", "جبالبارز", "جوپار", "جوزم", "جیرفت", "چترود", "خاتون آباد", "خانوک", "خورسند", "درب بهشت", "دهج", "رابر", "راور", "راین", "رفسنجان", "رودبار", "ریحان شهر", "زرند", "زنگی آباد", "زیدآباد", "سیرجان", "شهداد", "شهربابک", "صفائیه", "عنبرآباد", "فاریاب", "فهرج", "قلعه گنج", "کاظم آباد", "کرمان", "کشکوئیه", "کهنوج", "کوهبنان", "کیانشهر", "گلباف", "گلزار", "لاله زار", "ماهان", "محمدآباد", "محی آباد", "مردهک", "مس سرچشمه", "منوجان", "نجف شهر", "نرماشیر", "نظام شهر", "نگار", "نودژ", "هجدک", "یزدان شهر"],
        "کرمانشاه": ["ازگله", "اسلام آباد غرب", "باینگان", "بیستون", "پاوه", "تازه آباد", "جوان رود", "حمیل", "ماهیدشت", "روانسر", "سرپل ذهاب", "سرمست", "سطر", "سنقر", "سومار", "شاهو", "صحنه", "قصرشیرین", "کرمانشاه", "کرندغرب", "کنگاور", "کوزران", "گهواره", "گیلانغرب", "میان راهان", "نودشه", "نوسود", "هرسین", "هلشی"],
        "کهگیلویه و بویراحمد": ["باشت", "پاتاوه", "چرام", "چیتاب", "دهدشت", "دوگنبدان", "دیشموک", "سوق", "سی سخت", "قلعه رئیسی", "گراب سفلی", "لنده", "لیکک", "مادوان", "مارگون", "یاسوج"],
        "گلستان": ["انبارآلوم", "اینچه برون", "آزادشهر", "آق قلا", "بندرترکمن", "بندرگز", "جلین", "خان ببین", "دلند", "رامیان", "سرخنکلاته", "سیمین شهر", "علی آباد کتول", "فاضل آباد", "کردکوی", "کلاله", "گالیکش", "گرگان", "گمیش تپه", "گنبدکاووس", "مراوه", "مینودشت", "نگین شهر", "نوده خاندوز", "نوکنده"],
        "لرستان": ["ازنا", "اشترینان", "الشتر", "الیگودرز", "بروجرد", "پلدختر", "چالانچولان", "چغلوندی", "چقابل", "خرم آباد", "درب گنبد", "دورود", "زاغه", "سپیددشت", "سراب دوره", "فیروزآباد", "کونانی", "کوهدشت", "گراب", "معمولان", "مومن آباد", "نورآباد", "ویسیان"],
        "گیلان": ["احمدسرگوراب", "اسالم", "اطاقور", "املش", "آستارا", "آستانه اشرفیه", "بازار جمعه", "بره سر", "بندرانزلی", "پره سر", "پیربازار", "تالش", "توتکابن", "جیرنده", "چابکسر", "چاف و چمخاله", "چوبر", "حویق", "خشکبیجار", "خمام", "دیلمان", "زیباکنار", "رانکوه", "رحیم آباد", "رستم آباد", "رشت", "رضوانشهر", "رودبار", "رودبنه", "رودسر", "سنگر", "سیاهکل", "شفت", "شلمان", "صومعه سرا", "فومن", "کلاچای", "کوچصفهان", "کومله", "کیاشهر", "گوراب زرمیخ", "لاهیجان", "لشت نشا", "لنگرود", "لوشان", "لولمان", "لوندویل", "لیسار", "ماسال", "ماسوله", "مرجقل", "منجیل", "واجارگاه"],
        "مازندران": ["امیرکلا", "ایزدشهر", "آلاشت", "آمل", "بابل", "بابلسر", "بلده", "بهشهر", "بهنمیر", "پل سفید", "تنکابن", "جویبار", "چالوس", "چمستان", "خرم آباد", "خلیل شهر", "خوش رودپی", "دابودشت", "رامسر", "رستمکلا", "رویان", "رینه", "زرگرمحله", "زیرآب", "سادات شهر", "ساری", "سرخرود", "سلمان شهر", "سورک", "شیرگاه", "شیرود", "عباس آباد", "فریدونکنار", "فریم", "قائم شهر", "کتالم", "کلارآباد", "کلاردشت", "کله بست", "کوهی خیل", "کیاسر", "کیاکلا", "گتاب", "گزنک", "گلوگاه", "محمودآباد", "مرزن آباد", "مرزیکلا", "نشتارود", "نکا", "نور", "نوشهر"],
        "مرکزی": ["اراک", "آستانه", "آشتیان", "پرندک", "تفرش", "توره", "جاورسیان", "خشکرود", "خمین", "خنداب", "داودآباد", "دلیجان", "رازقان", "زاویه", "ساروق", "ساوه", "سنجان", "شازند", "غرق آباد", "فرمهین", "قورچی باشی", "کرهرود", "کمیجان", "مامونیه", "محلات", "مهاجران", "میلاجرد", "نراق", "نوبران", "نیمور", "هندودر"],
        "هرمزگان": ["ابوموسی", "بستک", "بندرجاسک", "بندرچارک", "بندرخمیر", "بندرعباس", "بندرلنگه", "بیکا", "پارسیان", "تخت", "جناح", "حاجی آباد", "درگهان", "دهبارز", "رویدر", "زیارتعلی", "سردشت", "سندرک", "سوزا", "سیریک", "فارغان", "فین", "قشم", "قلعه قاضی", "کنگ", "کوشکنار", "کیش", "گوهران", "میناب", "هرمز", "هشتبندی"],
        "همدان": ["ازندریان", "اسدآباد", "برزول", "بهار", "تویسرکان", "جورقان", "جوکار", "دمق", "رزن", "زنگنه", "سامن", "سرکان", "شیرین سو", "صالح آباد", "فامنین", "فرسفج", "فیروزان", "قروه درجزین", "قهاوند", "کبودر آهنگ", "گل تپه", "گیان", "لالجین", "مریانج", "ملایر", "نهاوند", "همدان"],
        "یزد": ["ابرکوه", "احمدآباد", "اردکان", "اشکذر", "بافق", "بفروئیه", "بهاباد", "تفت", "حمیدیا", "خضرآباد", "دیهوک", "رضوانشهر", "زارچ", "شاهدیه", "طبس", "عقدا", "مروست", "مهردشت", "مهریز", "میبد", "ندوشن", "نیر", "هرات", "یزد"]
    }
}
function svgArcRange(centerX: number, centerY: number, radius: number, angleInDegrees: number) {
    let angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
    };
}
export function svgArc(x: number, y: number, radius: number, startAngle: number, endAngle: number) {
    if (startAngle === endAngle || endAngle - startAngle === 360) { startAngle = 0; endAngle = 360 }
    if (startAngle === 360) { startAngle = 359.99 }
    if (endAngle === 360) { endAngle = 359.99 }
    let start = svgArcRange(x, y, radius, endAngle);
    let end = svgArcRange(x, y, radius, startAngle);
    let largeArcFlag;
    if (endAngle - startAngle < -180) { largeArcFlag = '0' }
    else if (endAngle - startAngle < 0) { largeArcFlag = '1' }
    else if (endAngle - startAngle <= 180) { largeArcFlag = '0' }
    else if (endAngle - startAngle <= 360) { largeArcFlag = '1' }
    else { largeArcFlag = '0' }
    return ["M", start.x, start.y, "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(" ");
}
export function getValueByField(data: any, field: string, def?: any): any {
    if (!data || !field) return def;
    try {
        const parts = field.split(".");
        let result: any = data;
        for (const part of parts) {
            if (/^\d+$/.test(part)) {
                const index = parseInt(part, 10);
                if (!Array.isArray(result)) return def;
                result = result[index];
            } else {
                if (result == null || !(part in result)) return def;
                result = result[part];
            }
        }
        return result === undefined ? def : result;
    }
    catch { return def; }
}
export function setValueByField(data: any = {}, field: string, value: any) {
    try { field = field.replace(/\[/g, '.').replace(/\]/g, '') }
    catch { }
    let fields = field.split('.');
    let node = data;
    for (let i = 0; i < fields.length - 1; i++) {
        let f = fields[i];
        if (!f) { continue }
        if (node[f] === undefined || node[f] === null) {
            if (isNaN(+fields[i + 1])) { node[f] = {} }
            else { node[f] = []; }
            node = node[f];
        }
        else { node = node[f]; }
    }
    node[fields[fields.length - 1]] = value;
    return data;
}
export function GetArray(count: number, fn?: (index: number) => any, step?: number) {
    fn = fn || ((index) => index)
    if (step) {
        const arr = new Array(count).fill(0);
        const res = [];
        for (let i = 0; i < arr.length; i++) {
            if (i % step !== 0) { continue }
            res.push(fn(i))
        }
        return res
    }
    return new Array(count).fill(0).map((_, i) => fn ? fn(i) : i)
}
export function GetRandomNumber(from: number, to: number) { return from + Math.round(Math.random() * (to - from)) }
type I_storage_model = { [key: string]: { value: any, saveTime: number, expiredIn: number } }

export class Storage {
    private model: I_storage_model;
    id: string;

    constructor(id: string, context?: any) {
        this.model = {};
        this.id = id;

        // اگر context پاس داده شده و initialCache وجود دارد، مستقیم hydrate انجام بده
        if (context?.query?.initialCache?.__CACHE__) {
            const initialCache = context.query.initialCache.__CACHE__;
            let myCacheData: I_storage_model = initialCache['storageClass' + this.id];
            if (!myCacheData) { myCacheData = {}; }
            this.setModel(myCacheData);
        } else {
            this.init(); // حالت معمول client (localStorage)
        }
    }

    private copy = (v: any) => JSON.parse(JSON.stringify(v));

    private setModel = (model: I_storage_model): I_storage_model => {
        this.model = model;
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('storageClass' + this.id, JSON.stringify(model));
        }
        return this.copy(model);
    }

    private getNow = () => new Date().getTime();

    init = () => {
        if (typeof localStorage === 'undefined') return;
        let storage: any = localStorage.getItem('storageClass' + this.id);
        const model = storage ? JSON.parse(storage) : {};
        this.setModel(this.removeExpireds(model));
    }

    save = (field: string, value: any, expiredIn?: number): I_storage_model => {
        if (value === undefined) return this.copy(this.model);
        const newModel = { ...this.model };
        newModel[field] = { value, saveTime: this.getNow(), expiredIn: expiredIn ?? Infinity };
        return this.setModel(newModel);
    }

    remove = (field: string): I_storage_model => {
        const newModel: I_storage_model = {};
        for (let prop in this.model) {
            if (prop !== field) newModel[prop] = this.model[prop];
        }
        return this.setModel(newModel);
    }

    isExpired = (field: string, model?: I_storage_model): boolean => {
        model = model || this.model;
        if (!model[field]) return true;
        if (typeof model[field].expiredIn !== 'number') return false;
        return model[field].expiredIn < this.getNow();
    }

    removeExpireds = (model: I_storage_model) => {
        const res: I_storage_model = {};
        for (let field in model) {
            if (!this.isExpired(field, model)) res[field] = model[field];
        }
        return res;
    }

    load = (field: string, def?: any, expiredIn?: number) => {
        const obj = this.model[field];
        if (!obj) { if (def !== undefined) this.save(field, def, expiredIn); return def; }
        if (this.isExpired(field)) { this.save(field, def, expiredIn); return def; }
        return obj.value;
    }
    clear = (): I_storage_model => this.setModel({});
    getKeys = (): string[] => Object.keys(this.model);
    getList = () => this.getKeys().map((key) => this.model[key].value);
    dump = () => {
        const key = 'storageClass' + this.id;
        const data = this.copy(this.model);
        return { __CACHE__: { [key]: data } };
    }
    update = (data: any) => { if (data) this.setModel(data); }
}
export function DisabledContextMenu() { window.addEventListener(`contextmenu`, (e) => e.preventDefault()); }
type I_color = any
type I_color_type = 'rgb' | 'hex' | 'array'
export class AIOColors {
    number_to_hex: (number: number) => string;
    getType: (c: I_color) => I_color_type;
    to_array: (c: I_color) => number[];
    between: (c1: I_color, c2: I_color, count: number) => string[];
    getBetween: (v: (string | number)[]) => I_color[]
    to_dark: (c: I_color, percent: number) => I_color;
    to_light: (c: I_color, percent: number) => I_color;
    brightness: (c: I_color, percent: number) => I_color;
    to_hex: (c: I_color) => string;
    to_rgb: (c: I_color) => string;
    log: (c: I_color[]) => void;
    getRandomRGB: (c1?: I_color, c2?: I_color) => string;
    reverse: (c: I_color) => I_color;
    constructor() {
        this.number_to_hex = (num) => {
            const str = num.toString(16); return str.length === 1 ? "0" + str : str;
        }
        this.getType = (c) => {
            if (Array.isArray(c)) { return 'array' }
            return c.indexOf('rgb') !== -1 ? 'rgb' : 'hex';
        }
        this.to_array = (c) => {
            if (Array.isArray(c)) { return c }
            if (c.indexOf('rgb(') === 0) {
                return c.slice(c.indexOf('(') + 1, c.indexOf(')')).split(',').map((o: string) => +o);
            }
            c = c.substr(1);
            let values = c.split(''), r, g, b;
            if (c.length === 3) {
                r = parseInt(values[0] + values[0], 16);
                g = parseInt(values[1] + values[1], 16);
                b = parseInt(values[2] + values[2], 16);
            }
            else if (c.length === 6) {
                r = parseInt(values[0] + values[1], 16);
                g = parseInt(values[2] + values[3], 16);
                b = parseInt(values[4] + values[5], 16);
            }
            return [r, g, b];
        }
        this.between = (c1, c2, count) => {
            let [r1, g1, b1] = this.to_array(c1);
            let [r2, g2, b2] = this.to_array(c2);
            let rDelta = (r2 - r1) / (count - 1);
            let gDelta = (g2 - g1) / (count - 1);
            let bDelta = (b2 - b1) / (count - 1);
            let colors = [];
            for (var i = 0; i < count; i++) {
                let color = `rgb(${Math.round(r1 + rDelta * i)},${Math.round(g1 + gDelta * i)},${Math.round(b1 + bDelta * i)})`;
                colors.push(color)
            }
            return colors;
        }
        this.getBetween = (array) => {
            let res: I_color[] = [];
            let colors: I_color[] = []
            let counts: number[] = []
            for (let i = 0; i < array.length; i++) {
                let a = array[i];
                let b = Array.isArray(a) ? this.to_rgb(a) : a
                if (typeof b === 'string') { colors.push(b) }
                else if (typeof b === 'number') { counts.push(b) }
            }
            for (let i = 0; i < colors.length - 1; i++) {
                const c1 = colors[i];
                const c2 = colors[i + 1];
                const count = counts[i];
                res = [...res, this.between(c1, c2, count)]
            }
            return res
        }
        this.to_dark = (c, percent) => {
            let [r, g, b] = this.to_array(c);
            r = Math.round(r - (r * (percent / 100)))
            g = Math.round(g - (g * (percent / 100)))
            b = Math.round(b - (b * (percent / 100)))
            const type: I_color_type = this.getType(c)
            const key = 'to_' + type as 'to_array' | 'to_hex' | 'to_rgb'
            const fn: any = (this as any)[key]
            return fn([r, g, b])
        }
        this.to_light = (c, percent) => {
            let [r, g, b] = this.to_array(c);
            r = Math.round(r + ((255 - r) * (percent / 100)))
            g = Math.round(g + ((255 - g) * (percent / 100)))
            b = Math.round(b + ((255 - b) * (percent / 100)))
            const type: I_color_type = this.getType(c)
            const key = 'to_' + type as 'to_array' | 'to_hex' | 'to_rgb'
            const fn: any = (this as any)[key]
            return fn([r, g, b])
        }
        this.to_hex = (c) => { return `#${this.to_array(c).map((o) => this.number_to_hex(o)).join('')}`; }
        this.to_rgb = (c) => { return `rgb(${this.to_array(c).toString()})`; }
        this.brightness = (c, percent) => {
            if (percent === 0) { return c }
            if (percent < 0) { return this.to_dark(c, percent * -1) }
            if (percent > 0) { return this.to_light(c, percent) }
        }
        this.log = (c) => {
            for (let i = 0; i < c.length; i++) {
                let color = this.to_rgb(c[i]);
                console.log(`%c ${this.reverse(color)}`, 'background: ' + color + '; color: #000');
            }
        }
        this.getRandomRGB = (c1 = '#000', c2 = '#fff') => {
            const array1 = this.to_array(c1)
            const array2 = this.to_array(c2)
            let r = GetRandomNumber(array1[0], array2[0]);
            let g = GetRandomNumber(array1[1], array2[1]);
            let b = GetRandomNumber(array1[2], array2[2]);
            return this.to_rgb([r, g, b])
        }
        this.reverse = (c) => { return (this as any)['to_' + this.getType(c)](this.to_array(c).map((o) => 255 - o)) }
    }
}
export class getRandomByPriority {
    private list: any[];
    private idField: string;
    constructor(p: { list: any[], priorityField: string, idField: string }) {
        this.idField = p.idField
        this.list = this.getList(p.list, p.priorityField);
    }
    private getList = (list: any[], priorityField: string) => {
        const newList = [];
        for (let i = 0; i < list.length; i++) {
            const row = list[i];
            const priority = row[priorityField] || 1;
            if (!priority) { continue }
            for (let j = 0; j < priority; j++) {
                newList.push(row);
            }
        }
        return newList
    }
    private remove = (index: number, type?: 'remove one' | 'remove all') => {
        if (!type) { return }
        const id = this.list[index][this.idField]
        if (type === 'remove one') { this.list.splice(index, 1) }
        else { this.list = this.list.filter((o) => o[this.idField] !== id) }
    }
    getItem = (type?: 'remove one' | 'remove all') => {
        const randomIndex = GetRandomNumber(0, this.list.length - 1);
        const item = this.list[randomIndex]
        this.remove(item, type)
        return item;
    }
}
export function FakeName(p: { type: 'firstname' | 'lastname' | 'fullname', gender?: 'male' | 'female', lang: 'en' | 'fa' }) {
    const names = {
        firstname_male_fa: [
            'آرمان', 'آرمین', 'آراد', 'آریا', 'آرشام', 'آمین', 'آرتین',
            'ابراهیم', 'اردلان', 'ارستو', 'ارسلان', 'ارشاد', 'اسماعیل', 'اهورا', 'ایمان', 'ایلیا', 'احمد', 'احمد رضا', 'امیر', 'امیر علی', 'امیر رضا', 'امیر حسین', 'امیر مسعود', 'امیر محمد', 'امین', 'اسفندیار', 'اکبر', 'اصفر', 'احسان',
            'بهمن', 'باقر', 'بردیا', 'برنا', 'باراد', 'بهروز', 'بیژن', 'بهادر', 'بهنام', 'بهرنگ', 'بهداد',
            'پویا', 'پوریا', 'پیمان', 'پدرام', 'پارسا', 'پرهام', 'پویان', 'حسن', 'حسین', 'حامد', 'حمید', 'حافظ', 'حسام',
            'خشایار', 'داریوش', 'داوود', 'دانیال', 'رضا', 'رامین', 'رحمت', 'رحمان', 'رحیم', 'رایبد', 'رادمان', 'رادین', 'رضوان', 'ساسان', 'سامان', 'سینا', 'سعید', 'سپهر', 'سجاد', 'سورنا', 'سیروس', 'سالار', 'شریف', 'شهاب', 'شاهین', 'شایان', 'شاهد', 'شهریار', 'صادق', 'عادل', 'علی', 'عباس', 'عماد', 'عرفان', 'علی رضا', 'علی محمد',
            'فرخ', 'فرهاد', 'فرشاد', 'فرشید', 'فرید', 'فربد', 'فرامرز', 'فرزین', 'فراز', 'فاضل', 'کاظم', 'کوروش', 'کریم',
            'مجید', 'محمد', 'محمود', 'مصطفی', 'محسن', 'مهران', 'مهدی', 'مهبد', 'ماهور', 'ماهان', 'محمد رضا', 'محمد مهدی', 'مجید رضا', 'محمد حسین', 'مهیار',
            'نیما', 'وحید', 'هادی', 'هامون', 'یوسف'
        ],
        firstname_female_fa: [
            'الناز', 'المیرا', 'الهام', 'السا', 'احترام', 'بهار', 'باران', 'بیتا', 'بهناز', 'بهاره', 'بنفشه', 'بهاره', 'پارمیدا', 'پانته آ', 'پریا', 'پروین', 'پرستو', 'پرنیا', 'پریماه', 'پریناز', 'پریسا', 'تهمینه', 'تارا', 'تینا', 'ترنم', 'ترمه', 'جمیله', 'جیران', 'جانان',
            'حمیده', 'حسنی', 'حسنا', 'حمیرا', 'دینا', 'دلارام', 'رها', 'رویا', 'ریما', 'ریحانه', 'راضیه', 'ژیلا', 'ژینا', 'ژاله', 'سمانه', 'ساحل', 'سمیرا', 'سارا', 'سوسن', 'ساناز', 'سیما', 'سهیلا', 'سحر', 'شیما', 'شهلا', 'شهره', 'شهرزاد', 'شیلا',
            'عاطفه', 'عطیه', 'غزل', 'غزاله', 'فرهناز', 'فریده', 'فروزنده', 'فرزانه', 'فرگل', 'فهیمه', 'فرناز', 'فرنگیس', 'فاطمه', 'فرخنده', 'فریماه', 'فرشته', 'کتایون', 'کیمیا', 'کیانا', 'مهنوش', 'مهسا', 'مهناز', 'مهشاد', 'مهشید', 'مینا', 'منا', 'مهرنوش'
        ],
        lastname_fa: [
            'احمدی', 'اردستانی', 'امینی', 'الهی', 'احسانی', 'اشتیاق', 'ابوالحسنی', 'اسماعیلی', 'اختیاری', 'اشراقی', 'اثباتی', 'بقایی', 'براتی', 'بینا', 'باقری', 'بهرامی', 'پیروز', 'پرویزی', 'پهلوانی', 'پیروی', 'پور غلامی', 'پور صمیمی', 'پازوکی', 'پاشایی', 'ترابی', 'تیموری', 'تشکری', 'جمالی', 'جهرمی', 'جلالی', 'جبلی', 'جباری',
            'چنگیزی', 'حمیدی', 'حسنی', 'حسینی', 'حبیبی', 'حیدری', 'خالقی', 'خندان', 'خسروی', 'خاقانی', 'خراسانی', 'دارابی', 'دهنوی', 'دشتی', 'دهستانی', 'زمانی', 'زواری', 'زرندی', 'زنگنه', 'سامانی', 'سلیمانی', 'سپهری', 'سزاوار', 'سرمد', 'سرافراز', 'رضایی', 'رمضانی', 'رحمانی', 'رحمتی', 'رضوانی', 'ربیعی', 'رادمهر', 'ریحانی', 'رستمی', 'رواقی', 'رشیدی', 'رشادی', 'رضوی', 'رفیعی',
            'فقیهی', 'فریدونی', 'فردوسی', 'فرامرزی', 'فرید نیا', 'فرحی', 'فرهمند', 'فرهودی', 'فهیمی', 'فراهانی', 'فاضلی', 'قهرمانی', 'قریبی', 'قوامی', 'قاسمی', 'کاظمی', 'کلهر', 'کرمی', 'کریمی', 'کوچک زاده', 'کمالی', 'کیوانی', 'کلاهدوز', 'کاملی', 'کامیاب', 'گودرزی', 'گرشاسبی', 'گایینی', 'لسانی', 'لرستانی', 'لقمانی', 'لشکری',
            'محمدی', 'مرندی', 'محسنی', 'مجیدی', 'میثاقی', 'مروتی', 'مردانی', 'محمودی', 'مسجد جامعی', 'مصطفوی', 'محلوجی', 'مرادی', 'مهستانی', 'مرودشتی', 'مشکاتی', 'مرتضوی', 'مسعودی', 'مقصودی', 'منافی', 'مطلق', 'منطقی', 'نریمانی', 'نیشابوری', 'نیستانی', 'نبوی', 'ناصری', 'نیمایی', 'ناسوتی', 'ناطقی', 'نشتارودی', 'نوری', 'نور محمدی', 'نوایی', 'نهری', 'نامی', 'نامدار', 'نایینی',
            'وحیدی', 'واسقی', 'ورامینی', 'واصلی', 'واحدی', 'وحدت', 'ورعی', 'والایی', 'وزیری', 'هادیان', 'همراه', 'همایونی', 'هویدا', 'هدایتی', 'هاتفی', 'هشترودی', 'هاشمی', 'یحیوی', 'یاسری', 'یادگار', 'یثربی', 'یونسی', 'یوسفی', 'یارمحمدی', 'یداللهی',
            'درخشنده', 'درخشان', 'داوودی', 'دهقان', 'دقیقی', 'بهمنیار', 'بهادری', 'شیخ بهایی', 'شیخی', 'ساعدی', 'پور کرمی', 'ساجدی', 'لواسانی', 'بوشهری', 'باستانی', 'بستانی', 'زرین اقبال', 'اقبالی', 'امین پور', 'امانی', 'معتمدی', 'اعتمادی',
            'اخلاقی', 'توتونچی', 'برازنده', 'چراغی', 'شاهمرادی', 'شاه محمدی',
            'ثابت', 'سماواتی', 'شاکری', 'سالمی', 'نعیمی', 'همایونفر', 'مفیدی', 'شهیدی', 'صابری', 'امامی', 'اطمینان', 'گنابادی', 'پروری', 'خادم', 'بارانی', 'پیردوست',
            'شهیدزاده', 'سهیلی', 'انصاری', 'صادقی', 'برقعی', 'محمد پور', 'اسفندیاری', 'فاطمی', 'فیروز آبادی', 'شیری', 'شیرودی', 'شفیعی', 'ثقفی', 'نجفی', 'نجف زاده', 'خوشبخت', 'وطن پرست', 'صارمی',
            'طارمی', 'حاتمی', 'قمی', 'مدیری', 'اصغری', 'آذری', 'شهابی', 'داوودخانی', 'شهسواری', 'رسایی', 'همزه ای', 'دشتستانی', 'شریفی', 'کیانی', 'کی نژاد', 'نیکو سرشت', 'ساداتی', 'سروش', 'مازندرانی', 'گیلانی', 'کاردان', 'کارامد', 'فاضلیان', 'فرنیا'
        ],
        firstname_male_en: [],
        firstname_female_en: [],
        lastname_en: []
    }
    const getfirstnames = () => {
        if (p.gender === 'male') { return names[`firstname_male_${p.lang}`] }
        else if (p.gender === 'female') { return names[`firstname_female_${p.lang}`] }
        else { return [...names[`firstname_male_${p.lang}`], ...names[`firstname_female_${p.lang}`]] }
    }
    const getfirstname = () => {
        const firstnames = getfirstnames()
        const index = GetRandomNumber(0, firstnames.length - 1);
        return firstnames[index];
    }
    const getlastname = () => {
        const lastnames = names[`lastname_${p.lang}`]
        const index = GetRandomNumber(0, lastnames.length - 1);
        return lastnames[index]
    }
    if (p.type === "firstname") { return getfirstname() }
    if (p.type === "lastname") { return getlastname() }
    return `${getfirstname()} ${getlastname()}`
}
export function StyleObjectToString(styleObject: any) {
    return Object.entries(styleObject)
        .map(([key, value]) => {
            // تبدیل camelCase به kebab-case
            const kebabKey = key.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`);
            return `${kebabKey}:${value}`;
        })
        .join(';');
}
export function Normalize(str: string, trim?: boolean) {
    const res = str.replace(/\u200C/g, '').normalize()
    return trim ? res.trim() : res
}
type I_os = 'Macintosh' | 'MacIntel' | 'MacPPC' | 'Mac68K' | 'Win32' | 'Win64' | 'Windows' | 'WinCE' | 'iPhone' | 'iPad' | 'iPod' | 'macOS' | 'iOS' | 'Windows' | 'Android' | 'Linux' | 'Unknown'
export const DetectOS = (): I_os => {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os: any = null;
    if (macosPlatforms.includes(platform)) { os = 'macOS'; }
    else if (iosPlatforms.includes(platform)) { os = 'iOS'; }
    else if (windowsPlatforms.includes(platform)) { os = 'Windows'; }
    else if (/Android/.test(userAgent)) { os = 'Android'; }
    else if (/Linux/.test(platform)) { os = 'Linux'; }
    else { os = 'Unknown'; }
    return os;
}
export function ArrayToObject<T>(keys: T[], fn: (key: T) => any) {
    return Object.assign({}, ...keys.map((key: T) => ({ [key as string]: fn(key) })))
}
export function keyboard_filter(value: string | number, p: { filter?: (string | 'symbol' | 'string' | 'number')[], maxLength?: number, toPersian?: boolean }): string {
    value = value.toString();
    if (!value) { return '' }
    if (p.toPersian) {
        let res: string = '';
        let dic: any = { "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9", 'ي': 'ی', 'ك': 'ک', 'ة': 'ه', 'ى': 'ی' }
        for (let i = 0; i < value.length; i++) {
            res += dic[value[i]] || value[i];
        }
        value = res;
    }
    const { maxLength = Infinity } = p;
    if (value.length > maxLength) { return value.slice(0, maxLength) }
    if (!Array.isArray(p.filter) || !p.filter.length) { return value }
    let lastChar = value[value.length - 1];
    const isNumber = !isNaN(+lastChar);
    let isOk = false;
    for (let i = 0; i < p.filter.length; i++) {
        let char = '';
        try { char = p.filter[i].toString() } catch { continue }
        if (char.length > 1 && char[0] === '!') {
            if (char[1] === lastChar) { isOk = false; break; }
        }
        if (char === 'symbol') { if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(lastChar)) { isOk = true; } }
        else if (char === 'number') { if (isNumber) { isOk = true } }
        else if (char === 'string') { if (!isNumber) { isOk = true } }
        else { if (char === lastChar) { isOk = true } }
    }
    if (!isOk) { value = value.slice(0, value.length - 1) }
    return value
}
export type I_dline = [number, number, number]//x,y,dip
export type I_dip = number
export type I_arc = { x: number, y: number, r: number, slice?: number[] }
export type I_rect = [[number, number], [number, number]]
export class Geo {
    getAngle = (l: [[number, number], [number, number]] | I_dline): number => {
        let line: [[number, number], [number, number]] = this.getLineType(l) === 'DLine' ? this.getLineByDLine(l as I_dline) : (l as [[number, number], [number, number]])
        let [p1, p2] = line;
        let deltaX = p2[0] - p1[0];
        let deltaY = p2[1] - p1[1];
        let length = this.getLength([[0, 0], [deltaX, deltaY]]);
        let angle = Math.acos(deltaX / length) / Math.PI * 180;
        angle = Math.sign(deltaY) < 0 ? 360 - angle : angle;
        const res = parseFloat(angle.toFixed(4));
        return isNaN(res) ? 0 : res
    }
    getLineType = (line: I_dline | [[number, number], [number, number]]): 'DLine' | 'Line' => Array.isArray(line[0]) ? 'Line' : 'DLine'
    getLine = (l: I_dline | [[number, number], [number, number]]): [[number, number], [number, number]] => this.getLineType(l) === 'Line' ? l as [[number, number], [number, number]] : this.getLineByDLine(l as I_dline)
    getDLine = (l: I_dline | [[number, number], [number, number]]): I_dline => this.getLineType(l) === 'DLine' ? l as I_dline : this.getDLineByLine(l as [[number, number], [number, number]])
    getDipAngle = (dip: I_dip): number => this.getAngle([0, 0, dip])
    getLength = (line: [[number, number], [number, number]]): number => Math.sqrt(Math.pow(line[0][0] - line[1][0], 2) + Math.pow(line[0][1] - line[1][1], 2))
    getPrepDip = (dip: I_dip): number => -1 / dip
    getDip = (l: [[number, number], [number, number]] | I_dline): I_dip => {
        let line: [[number, number], [number, number]] = this.getLine(l);
        const x1 = line[0][0];
        const x2 = line[1][0];
        const y1 = line[0][1];
        const y2 = line[1][1];
        return (y1 - y2) / (x1 - x2)
    }
    getLineByDLine = (dline: I_dline): [[number, number], [number, number]] => {
        let [x, y] = dline;
        let X = this.getXOnLineByY(dline, y + 10)
        let Y = this.getYOnLineByX(dline, X)
        return [[x, y], [X, Y]]
    }
    getYOnLineByX = (l: I_dline | [[number, number], [number, number]], X: number): number => { // get {x,line} or {x,point,dip}
        let [x, y, dip] = this.getDLine(l);
        if (dip === Infinity) { return y - 10 }
        if (dip === -Infinity) { return y + 10 }
        return dip * (X - x) + y;
    }
    getXOnLineByY = (l: I_dline | [[number, number], [number, number]], Y: number): number => { // get {y,line} or {y,point,dip}
        let [x, y, dip] = this.getDLine(l);
        if (dip === 0) { return 0 }
        if (dip === Infinity || dip === -Infinity) { return x }
        return (Y - y) / dip + x;
    }
    getPrepFromLine = (l: I_dline | [[number, number], [number, number]], point: [number, number], offset: number): [number, number] => {
        if (!offset) { return point; }
        let dline = this.getDLine(l);
        let angle: number = this.getAngle(dline);
        return this.getLineBySLA(point, offset, angle - 90)[1]
    }
    getPrepToLine = (l: I_dline | [[number, number], [number, number]], point: [number, number]): [number, number] | false => {
        let dline = this.getDLine(l);
        let prepLine: I_dline = [point[0], point[1], this.getPrepDip(dline[2])]
        return this.getMeet(dline, prepLine);
    }
    getLineBySLA = (p1: [number, number], length: number, angle: number): [[number, number], [number, number]] => {
        if (!length) { return [p1, p1] }
        const cos = this.tri('cos', angle)
        const sin = this.tri('sin', angle)
        const dx = cos * length
        const dy = sin * length
        const p2: [number, number] = [p1[0] + dx, p1[1] + dy]
        return [p1, p2];
    }
    getArcByPoints = (arcPoints: [number, number][], height?: number): any => {
        var points = [];
        var stringPoints = [];
        for (var i = 0; i < arcPoints.length; i++) {
            if (i === 3) { break; }
            var point = arcPoints[i];
            var stringPoint = point.toString();
            if (stringPoints.indexOf(stringPoint) !== -1) { continue }
            stringPoints.push(stringPoint);
            points.push(point)
        }
        var p1 = points[0], p2 = points[1], p3 = points[2];
        var changeObject: I_arc = { x: 0, y: 0, r: 0 };
        if (points.length === 1) { changeObject = { r: height || 0, x: p1[0], y: p1[1] } }
        else if (points.length === 2) {
            let avg = this.getAvg([p1, p2]);
            let pm = this.getPrepFromLine([p2, p1], avg, height || 0);
            if (height) { changeObject = this.getArcBy3Points(p1, pm, p2); }
            else { changeObject = { r: this.getLength([p1, p2]) / 2, x: avg[0], y: avg[1] } }
        }
        else { changeObject = this.getArcBy3Points(p1, p2, p3); }
        return changeObject
    }
    getAvg = (list: [number, number][]): [number, number] => {
        var x = 0, y = 0, length = list.length;
        for (var i = 0; i < length; i++) { x += list[i][0]; y += list[i][1]; }
        return [x / length, y / length]
    }
    getArcBy3Points = (p1: [number, number], p2: [number, number], p3: [number, number]): I_arc => {
        const d1 = this.getDip([p1, p2])
        const d2 = this.getDip([p2, p3])
        let dip1: I_dip = this.getPrepDip(d1);
        let dip2: I_dip = this.getPrepDip(d2);
        let point1: [number, number] = this.getAvg([p1, p2]);
        let point2: [number, number] = this.getAvg([p2, p3])
        let dline1: I_dline = [point1[0], point1[1], dip1]
        let dline2: I_dline = [point2[0], point2[1], dip2]
        let meet = this.getMeet(dline1, dline2);
        if (!meet) { return { x: 0, y: 0, r: 0 }; }
        let x = meet[0], y = meet[1];
        let a1 = this.getAngle([meet, p1]),
            a2 = this.getAngle([meet, p2]),
            a3 = this.getAngle([meet, p3]);
        let slice;
        if (a1 < a2 && a2 < a3) { slice = [a1, a3]; }
        else if (a2 < a3 && a3 < a1) { slice = [a1, a3]; }
        else if (a3 < a1 && a1 < a2) { slice = [a1, a3]; }
        else if (a3 < a2 && a2 < a1) { slice = [a3, a1]; }
        else if (a1 < a3 && a3 < a2) { slice = [a3, a1]; }
        else if (a2 < a1 && a1 < a3) {
            slice = [a3, a1];
        } else { slice = [0, 0]; }
        let arc: I_arc = { x, y, r: this.getLength([p1, [x, y]]), slice };
        return arc
    }
    getDLineByLine = (line: [[number, number], [number, number]]): I_dline => {
        let [p1] = line;
        return [p1[0], p1[1], this.getDip(line)]
    }
    getMeet = (l1: I_dline | [[number, number], [number, number]], l2: I_dline | [[number, number], [number, number]]): [number, number] | false => { //get {line1,line2} or {point1,point2,dip1,dip2}
        let dline1 = this.getDLine(l1);
        let dline2 = this.getDLine(l2);
        let [p1x, p1y, dip1] = dline1;
        let [p2x, p2y, dip2] = dline2;
        if (dip1 === dip2) { return false }
        if (Math.abs(dip1) === Infinity) { return [p1x, this.getYOnLineByX(dline2, p1x)] }
        if (Math.abs(dip2) === Infinity) { return [p2x, this.getYOnLineByX(dline1, p2x)] }
        var x = ((dip1 * p1x) - (dip2 * p2x) + p2y - p1y) / (dip1 - dip2);
        var y = dip1 * (x - p1x) + p1y;
        return [x, y]
    }
    getInnerMeet = (line1: [[number, number], [number, number]], line2: [[number, number], [number, number]]): false | [number, number] => {
        let meet = this.getMeet(line1, line2);
        if (meet === false) { return false }
        if (line2[0][0] < line2[1][0]) {
            if (meet[0] < line2[0][0] || meet[0] > line2[1][0]) { return false }
        }
        else {
            if (meet[0] < line2[1][0] || meet[0] > line2[0][0]) { return false }
        }
        if (line2[0][1] < line2[1][1]) {
            if (meet[1] < line2[0][1] || meet[1] > line2[1][1]) { return false }
        }
        else {
            if (meet[1] < line2[1][1] || meet[1] > line2[0][1]) { return false }
        }
        if (line1[0][0] < line1[1][0]) {
            if (meet[0] < line1[0][0] || meet[0] > line1[1][0]) { return false }
        }
        else {
            if (meet[0] < line1[1][0] || meet[0] > line1[0][0]) { return false }
        }
        if (line1[0][1] < line1[1][1]) {
            if (meet[1] < line1[0][1] || meet[1] > line1[1][1]) { return false }
        }
        else {
            if (meet[1] < line1[1][1] || meet[1] > line1[0][1]) { return false }
        }
        return meet;
    }

    tri = (type: 'sin' | 'cos', teta: number): number => {
        const rad = teta * Math.PI / 180;
        const val = Math[type](rad);
        const EPS = 1e-10;
        return Math.abs(val) < EPS ? 0 : val;
    }
    getPointsByNGon = (radius: number, count: number, corner: number): [number, number][] => {
        let ang = (180 - (360 / count));
        let w = +(this.tri('cos', ang / 2) * radius).toFixed(6) * 2;
        let h = +(this.tri('sin', ang / 2) * radius).toFixed(6);
        let p1: any = [0, -h, corner];
        let p2: any = [0 + w / 2, -h, corner];
        let points: [number, number][] = [p1, p2];
        let a = 360 / count;
        for (let i = 0; i < count - 1; i++) {
            let p: any = [points[i + 1][0] + (this.tri('cos', a) * w), points[i + 1][1] + (this.tri('sin', a) * w), corner];
            a += 360 / count;
            points.push(p)
        }
        points.push(p1);
        return points
    }
    setLineByLength = (line: [[number, number], [number, number]], length: number, side?: 'center' | 'start' | 'end'): [[number, number], [number, number]] => {
        let p1: [number, number] = [0, 0], p2: [number, number] = [0, 0], angle = this.getAngle(line);
        if (side === 'center') {
            let center = this.getAvg(line);
            let line1 = this.getLineBySLA(center, length / 2, angle + 180);
            let line2 = this.getLineBySLA(center, length / 2, angle);
            p1 = line1[1]; p2 = line2[1];
        }
        else if (side === 'start') {
            p2 = line[1];
            let newLine = this.getLineBySLA(p2, length, angle + 180);
            p1 = newLine[1]
        }
        else {
            p1 = line[0];
            let newLine = this.getLineBySLA(p1, length, angle);
            p2 = newLine[1];
        }
        return [p1, p2];
    }
    setLineByStep = (line: [[number, number], [number, number]], step: number, side?: 'center' | 'start' | 'end'): { line: [[number, number], [number, number]], length: number } => {
        let length = this.getLength(line);
        length = this.getNumberByStep(length, step)
        return { line: this.setLineByLength(line, length, side), length }
    }
    getParallelLine = (points: [number, number][], offset: number): [number, number][] => {
        let lines: [[number, number], [number, number]][] = [];
        let length = points.length;
        if (length === 2) {
            let p1 = this.getPrepFromLine([points[0], points[1]], points[0], offset);
            let p2 = this.getPrepFromLine([points[0], points[1]], points[1], offset);
            return [p1, p2];
        }
        for (var i = 1; i <= length; i++) {
            var point = points[i];
            if (i === length) { break; }
            var beforePoint = points[i - 1];
            var p1 = this.getPrepFromLine([beforePoint, point], beforePoint, offset);
            var p2 = this.getPrepFromLine([beforePoint, point], point, offset);
            lines.push([p1, p2]);
        }
        let res: [number, number][] = [];
        length = lines.length;
        for (let i = 0; i < length; i++) {
            let line = lines[i];
            let beforeLine = lines[i - 1];
            if (i === 0) {
                res.push([line[0][0], line[0][1]]);
                continue
            }
            let meet = this.getMeet(beforeLine, line);
            if (meet) { res.push(meet); }
            if (i === length - 1) { res.push([line[1][0], line[1][1]]); }
        }
        return res;
    }
    getPointsByDivide = (points: [number, number][], divide: number): [number, number][] => {
        let [p1, p2] = points;
        let deltaX = this.fix(p2[0] - p1[0]), deltaY = this.fix(p2[1] - p1[1]);
        let uX = deltaX / divide, uY = deltaY / divide;
        let ps: [number, number][] = [];
        for (let i = 1; i < divide; i++) {
            ps.push([p1[0] + i * uX, p1[1] + i * uY])
        }
        return ps;
    }
    fix = (value: number): number => { return parseFloat(value.toFixed(6)) }
    setLineByAngle = (line: [[number, number], [number, number]], angle: number): [[number, number], [number, number]] => {
        let length = this.getLength(line);
        if (!length) { return line }
        angle = angle % 360;
        return this.getLineBySLA([line[0][0], line[0][1]], length, angle);
    }
    getNumberByStep = (number: number, step: number): number => Math.round(number / step) * step
    setLineByOrtho = (line: [[number, number], [number, number]], ortho: number): { line: [[number, number], [number, number]], angle: number } => {
        const angle = this.getNumberByStep(this.getAngle(line), ortho)
        const newLine = this.setLineByAngle(line, angle)
        return { line: newLine, angle }
    }
    rotateSpline = (points: [number, number][], angle: number, center: [number, number]): [number, number][] => {
        let Points: [number, number][] = JSON.parse(JSON.stringify(points));
        for (var i = 0; i < Points.length; i++) {
            let p = Points[i];
            let line: [[number, number], [number, number]] = [[...center], [p[0], p[1]]];
            let lineAngle: number = this.getAngle(line);
            line = this.setLineByAngle(line, angle + lineAngle);
            p[0] = line[1][0];
            p[1] = line[1][1];
        }
        return Points;
    }
    getLineDistanceFromPoint = (line: [[number, number], [number, number]], point: [number, number]) => {
        const prep = this.getPrepToLine(line, point);
        if (prep === false) { return 0 }
        return this.getLength([point, prep])
    }
    getLineAlongPoint = (line: [[number, number], [number, number]], point: [number, number], offset: number): [[number, number], [number, number]] => {
        const distance = this.getLineDistanceFromPoint(line, point)
        const prep1 = this.getPrepFromLine(line, line[0], distance);
        const prep2 = this.getPrepFromLine(line, line[0], -distance);
        const prep = this.getLength([line[0], prep1]) < this.getLength([line[0], prep2]) ? prep1 : prep2
        const dx = prep[0] - line[0][0];
        const dy = prep[1] - line[0][1];
        const p1: [number, number] = [line[0][0] + dx, line[0][1] + dy]
        const p2: [number, number] = [line[1][0] + dx, line[1][1] + dy]
        const a = this.getPrepFromLine([p1, p2], p1, offset)
        const dx1 = a[0] - p1[0]
        const dy1 = a[1] - p1[1];
        const pp1: [number, number] = [p1[0] + dx1, p1[1] + dy1]
        const pp2: [number, number] = [p2[0] + dx1, p2[1] + dy1]
        return [pp1, pp2]
    }
    isPointInPath = (points: [number, number][], point: [number, number]): boolean => {
        let meets = 0;
        for (let i = 0; i < points.length; i++) {
            let curentPoint = points[i], nextPoint;
            if (i === points.length - 1) { nextPoint = points[0] }
            else { nextPoint = points[i + 1] }
            let meet = this.getInnerMeet([[point[0], point[1]], [9999999999, point[1]]], [[curentPoint[0], curentPoint[1]], [nextPoint[0], nextPoint[1]]]);
            if (meet !== false) { meets++ }
        }
        return meets % 2 !== 0;
    }
    smooth = (points: [number, number][], angle: number): [number, number][] => {
        let p1: [number, number] | undefined, p2: [number, number] | undefined, p3: [number, number] | undefined;
        let res: [number, number][] = [];
        let type;
        for (let i = 0; i < points.length; i++) {
            const point = points[i];
            if (i === 0) { res.push([point[0], point[1]]); }
            if (!p1) { p1 = [point[0], point[1]]; continue; }
            if (!p2) { p2 = [point[0], point[1]]; continue; }
            if (!p3) { p3 = [point[0], point[1]]; continue; }
            const ang1 = this.getAngle([p1, p2]);
            const ang2 = this.getAngle([p2, p3]);
            const isSmooth: boolean = Math.abs(ang1 - ang2) < angle;
            if (isSmooth) {
                p2 = [p3[0], p3[1]];
                p3 = [point[0], point[1]];
                type = 0
            } else {
                res.push(p2);
                p1 = [p2[0], p2[1]];
                p2 = [p3[0], p3[1]];
                p3 = [point[0], point[1]];
                type = 1
            }
            if (i === points.length - 1) {
                if (type === 1) {
                    res.push([p2[0], p2[1]]);
                }
                res.push([point[0], point[1]]);
            }
        }
        return res;
    }
    getStarPoints = (x: number, y: number, count: number, r1: number, r2: number, round?: number) => {
        const teta = 360 / count;
        round = round || 0;
        const { width, height } = this.getTriangleWidthAndHeightByEdgeAndTeta(r1, teta)
        const start1: any = [x - width / 2, y - height, round];
        const start2: any = [x, y - r2, round]
        const res = [start1, start2];
        for (let i = 1; i < count; i++) {
            const p1 = this.rotatePoint([x, y], start1, teta * i);
            const p2 = this.rotatePoint([x, y], start2, teta * i);
            res.push([...p1, round], [...p2, round]);
        }
        return [...res, start1]
    }
    getTriangleWidthAndHeightByEdgeAndTeta = (edge: number, teta: number) => {
        const width = this.tri('sin', teta / 2) * edge * 2;
        const height = this.tri('cos', teta / 2) * edge;
        return { width, height }
    }

    rotatePoint = (center: [number, number], point: [number, number], angleDeg: number) => {
        const [cx, cy] = center;
        const [px, py] = point;
        const dx = px - cx;
        const dy = py - cy;
        const x = cx + dx * this.tri('cos', angleDeg) - dy * this.tri('sin', angleDeg);
        const y = cy + dx * this.tri('sin', angleDeg) + dy * this.tri('cos', angleDeg);
        const fix = (n: number) => Math.abs(n) < 1e-12 ? 0 : n;
        return [fix(x), fix(y)];
    }
    fixAngle = (angle: number) => {
        angle = angle % 360;
        if (angle > 360) { angle = angle % 360 }
        if (angle < 0) { }
    }
    toDXF = (p: { lines: { points: { x: number, y: number }[], close: boolean }[], arcs: { x: number, y: number, radius: number, slice: [number, number] }[] }) => {
        const header = `0
SECTION
2
HEADER
0
ENDSEC
0
SECTION
2
ENTITIES
`;

        const footer = `0
ENDSEC
0
EOF`;

        const entities: string[] = [];

        // --- Lines -> LWPOLYLINE ---
        for (const l of p.lines) {
            if (!l.points?.length) continue;

            let e = `0
LWPOLYLINE
100
AcDbEntity
8
0
100
AcDbPolyline
90
${l.points.length}
70
${l.close ? 1 : 0}
`;

            for (const { x, y } of l.points) {
                e += `10
${x}
20
${y}
`;
            }

            entities.push(e);
        }

        // --- Arcs -> ARC ---
        for (const a of p.arcs) {
            if (!a || a.radius <= 0) continue;

            const [start, end] = a.slice;

            const e = `0
ARC
100
AcDbEntity
8
0
100
AcDbCircle
10
${a.x}
20
${a.y}
30
0
40
${a.radius}
100
AcDbArc
50
${start}
51
${end}
`;

            entities.push(e);
        }

        return header + entities.join("") + footer;
    };
    getDXF = (list: { arcs?: I_arc[], rects?: I_rect[], lines?: [[number, number], [number, number]][] }) => {
        const getLine = (line: [[number, number], [number, number]]) => {
            let [p1, p2] = line;
            let res = '';
            res +=
                "LINE" + "\r\n" +
                "8" + "\r\n" +
                "1" + "\r\n" +
                "62" + "\r\n" +
                "0" + "\r\n" +
                "10" + "\r\n" +
                (p1[0]) + "\r\n" +
                "20" + "\r\n" +
                (p1[1]) * -1 + "\r\n" +
                "30" + "\r\n" +
                "0.0" + "\r\n" +
                "11" + "\r\n" +
                (p2[0]) + "\r\n" +
                "21" + "\r\n" +
                (p2[1]) * -1 + "\r\n" +
                "31" + "\r\n" +
                "0.0" + "\r\n" +
                "0" + "\r\n";
            return res;
        }
        const getRect = (rect: I_rect) => {
            let [p1, p2] = rect;
            var rectangle = '';
            rectangle += getLine([[p1[0], p1[1]], [p2[0], p2[1]]]);
            rectangle += getLine([[p2[0], p1[1]], [p2[0], p2[1]]]);
            rectangle += getLine([[p2[0], p2[1]], [p1[0], p2[1]]]);
            rectangle += getLine([[p1[0], p2[1]], [p1[0], p1[1]]]);
            return rectangle;
        }
        const getArc = (arc: I_arc) => {
            let { x, y, r, slice = [0, 360] } = arc
            let res = '';
            res +=
                "ARC" + "\r\n" +
                "8" + "\r\n" +
                "1" + "\r\n" +
                "62" + "\r\n" +
                "0" + "\r\n" +
                "10" + "\r\n" +
                (x) + "\r\n" +
                "20" + "\r\n" +
                (y) * -1 + "\r\n" +
                "30" + "\r\n" +
                "0.0" + "\r\n" +
                "40" + "\r\n" +
                (r) + "\r\n" +
                "50" + "\r\n" +
                (slice[0]) + "\r\n" +
                "51" + "\r\n" +
                (slice[1]) + "\r\n" +
                "0" + "\r\n";
            return arc;
        }
        let entities = '';
        const arcs = list.arcs || []
        const rects = list.rects || []
        const lines = list.lines || []
        for (let i = 0; i < arcs.length; i++) {
            var arc = arcs[i];
            entities += getArc(arc)
        }
        for (let i = 0; i < rects.length; i++) {
            var rect = rects[i];
            entities += getRect(rect)
        }
        for (let i = 0; i < lines.length; i++) {
            var line = lines[i];
            entities += getLine(line)
        }
        var dxfText =
            "0" + "\r\n" +
            "SECTION" + "\r\n" +
            "2" + "\r\n" +
            "ENTITIES" + "\r\n" +
            "0" + "\r\n";
        dxfText += entities;
        dxfText +=
            "ENDSEC" + "\r\n" +
            "0" + "\r\n" +
            "EOF";
        return dxfText;
    }

}

export function ShuffleArray(array: any[]) {
    let shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1));
        [shuffledArray[i], shuffledArray[randomIndex]] = [shuffledArray[randomIndex], shuffledArray[i]];
    }
    return shuffledArray;
}
export type I_Swip_mousePosition = { x: number, y: number, xp: number, yp: number, clientX: number, clientY: number, centerAngle: number, centerDistance: number };
export type I_Swip_change = {
    x: number, y: number,
    dx: number, dy: number,
    dist: number,
    angle: number,
    deltaCenterAngle: number,
    dir?: 'h' | 'v'
}
export type I_Swip_parameter = {
    change: I_Swip_change, mousePosition: I_Swip_mousePosition, domLimit: I_Swip_domLimit, parentLimit: I_Swip_domLimit, event: any, selectRect?: I_Swip_selectRect,
    isInSelectRect?: I_Swip_isInSelectRect, index: number
}
type I_Swip_selectRect_config = { color?: string, enable: () => boolean }
export type I_Swip = {
    dom: string | (() => any),
    parent?: string | (() => any),
    onClick?: (p: I_Swip_parameter) => void,
    page?: () => any,
    start?: (p: I_Swip_parameter) => number[] | false,
    move?: (p: I_Swip_parameter) => void,
    end?: (p: I_Swip_parameter) => void,
    selectRect?: I_Swip_selectRect_config,
    speedX?: number,
    speedY?: number,
    stepX?: number | boolean,
    stepY?: number | boolean,
    reverseY?: boolean,
    reverseX?: boolean,
    minY?: number,
    maxY?: number,
    minX?: number,
    maxX?: number,
    insideX?: boolean,
    insideY?: boolean,
    maxCenterDistance?: number
}
export type I_Swip_domLimit = {
    width: number, height: number, left: number, top: number, centerX: number, centerY: number, right: number, bottom: number
}
type I_Swip_isInSelectRect = (x: number, y: number) => boolean
type I_Swip_getIsInSelectrect = (selectRect: I_Swip_selectRect) => I_Swip_isInSelectRect
export type I_Swip_selectRect = { left: number, top: number, width: number, height: number };
export type I_Swip_tempSelectRect = { left: number, top: number };
export class Swip {
    p: I_Swip;
    geo: Geo = new Geo();
    defaultLimit: I_Swip_domLimit = { width: 0, height: 0, left: 0, top: 0, right: 0, bottom: 0, centerX: 0, centerY: 0 };
    timeout: any = undefined;
    count: number = 0;
    domLimit: I_Swip_domLimit = this.defaultLimit;
    parentLimit: I_Swip_domLimit = this.defaultLimit;
    getDom: () => any = () => typeof this.p.dom === 'string' ? $(this.p.dom) : this.p.dom();
    getParent: () => any = () => typeof this.p.parent === 'string' ? $(this.p.parent) : (this.p.parent ? this.p.parent() : undefined);
    dist: number = 0;
    change: I_Swip_change = { x: 0, y: 0, dx: 0, dy: 0, dist: 0, angle: 0, deltaCenterAngle: 0 };
    isMoving: boolean = false;
    centerAngle: number = 0;
    selectRect?: I_Swip_selectRect_config;
    defaultChange: I_Swip_change = { x: 0, y: 0, dx: 0, dy: 0, dist: 0, angle: 0, deltaCenterAngle: 0 };
    dx: number = 0;
    dy: number = 0;
    cx: number = 0;
    cy: number = 0;
    index: number = 0;
    so: { client?: { x: number, y: number }, x?: number, y?: number, sr?: I_Swip_selectRect, tsr?: I_Swip_tempSelectRect } = {};
    senseDir: false | 'h' | 'v' = false
    sentMove?: string
    constructor(p: I_Swip) {
        let { selectRect } = p;
        if (selectRect) {
            let { color = '#96a9bc' } = selectRect;
            this.selectRect = { ...selectRect, color };
        }
        this.p = p;
        this.init()
    }
    init = () => {
        this.count++;
        if (this.count > 10) { clearTimeout(this.timeout); return }
        let res = this.getDom();
        if (!res.length) { this.timeout = setTimeout(() => this.init(), 400) }
        else {
            clearTimeout(this.timeout);
            EventHandler(this.getDom(), 'mousedown', $.proxy(this.mouseDown, this));
        }
    }
    getPercentByValue = (value: number, start: number, end: number): number => { return 100 * (value - start) / (end - start) }
    getPage = () => {
        let { page } = this.p;
        return page ? page() : $(window);
    }
    getMousePosition = (e: any): I_Swip_mousePosition => {
        this.domLimit = this.getDOMLimit('dom');
        let { left, top, centerX, centerY, width, height } = this.domLimit;
        let page = this.getPage(), client = GetClient(e), x = client.x - left + page.scrollLeft(), y = client.y - top + page.scrollTop();
        const line: [[number, number], [number, number]] = [[centerX, centerY], [client.x, client.y]]
        let centerAngle = this.geo.getAngle(line)
        const centerDistance = this.geo.getLength(line)
        if (this.p.maxCenterDistance && centerDistance > this.p.maxCenterDistance) {
            const center: [number, number] = [width / 2, height / 2]
            const [newX, newY] = this.geo.getLineBySLA(center, this.p.maxCenterDistance, centerAngle)[1]
            x = newX; y = newY
        }
        return {
            clientX: client.x, clientY: client.y, x, y, centerAngle, centerDistance,
            xp: this.getPercentByValue(x, 0, width), yp: this.getPercentByValue(y, 0, height)
        }
    }
    getDOMLimit = (type: 'dom' | 'parent'): I_Swip_domLimit => {
        let dom = type === 'dom' ? this.getDom() : this.getParent();
        let offset = dom.offset();
        let DOM: any;
        try {
            DOM = {
                width: dom.width(),
                height: dom.height(),
                left: offset.left,
                top: offset.top,
                centerX: 0,
                centerY: 0
            }
        }
        catch {
            let dom = type === 'dom' ? this.getDom() : this.getParent();
            const width = dom.width()
            DOM = {
                width,
                height: dom.height(),
                left: offset.left,
                top: offset.top,
                centerX: 0,
                centerY: 0
            };
        }
        return {
            ...DOM,
            centerX: DOM.left + DOM.width / 2,
            centerY: DOM.top + DOM.height / 2,
            right: DOM.left + DOM.width,
            bottom: DOM.top + DOM.height
        }
    }
    changeIsMoving = (moving: boolean) => {
        this.isMoving = moving
    }
    getIndex = (e: any) => {
        if (!e.target || e.target === null) { return 0 }
        let indexStr = GetAttr($(e.target), 'data-index')
        return typeof indexStr === 'string' ? +indexStr : 0;
    }
    click = (e: any) => {
        if (!this.p.onClick) { return }
        this.domLimit = this.getDOMLimit('dom');
        this.parentLimit = this.p.parent ? this.getDOMLimit('parent') : this.defaultLimit;
        let mousePosition = this.getMousePosition(e)
        this.index = this.getIndex(e)
        let clickParams: I_Swip_parameter = {
            mousePosition, domLimit: this.domLimit, parentLimit: this.parentLimit, event: e,
            change: this.defaultChange, index: this.index
        }
        if (this.p.onClick) { this.p.onClick(clickParams) }
    }
    mouseDown = (e: any) => {
        //e.stopPropagation();
        this.index = this.getIndex(e)
        this.changeIsMoving(false);
        this.domLimit = this.getDOMLimit('dom');
        this.parentLimit = this.p.parent ? this.getDOMLimit('parent') : this.defaultLimit;
        let mousePosition = this.getMousePosition(e)
        this.centerAngle = mousePosition.centerAngle;
        this.cx = mousePosition.clientX;
        this.cy = mousePosition.clientY;
        this.so = {
            client: { x: mousePosition.clientX, y: mousePosition.clientY }
        };
        this.addSelectRect(mousePosition.x, mousePosition.y);
        let startParams: I_Swip_parameter = { index: this.index, mousePosition, domLimit: this.domLimit, parentLimit: this.parentLimit, event: e, change: this.defaultChange }
        let res = (this.p.start || (() => [0, 0]))(startParams);
        if (res === false) { return }
        if (!Array.isArray(res)) { return; }
        let x = res[0], y = res[1];
        this.so = { ...this.so, x, y }
        this.senseDir = false
        EventHandler('window', 'mousemove', $.proxy(this.mouseMove, this));
        EventHandler('window', 'mouseup', $.proxy(this.mouseUp, this))
    }
    mouseMove = (e: any) => {
        e.stopPropagation();
        let { speedX = 1, speedY = 1, stepX = 1, stepY = 1, reverseX, reverseY, insideX, insideY } = this.p;
        let mousePosition = this.getMousePosition(e), client = GetClient(e);
        let dx = client.x - this.cx, dy = client.y - this.cy;
        dx = Math.round(dx * speedX) * (reverseX ? -1 : 1)
        dy = Math.round(dy * speedY) * (reverseY ? -1 : 1)
        let deltaCenterAngle = mousePosition.centerAngle - this.centerAngle;
        //if(deltaCenterAngle < 0){deltaCenterAngle += 360}
        if (typeof stepX === 'number') {
            dx = Math.round(dx / stepX) * stepX;
        }
        if (typeof stepY === 'number') {
            dy = Math.round(dy / stepY) * stepY;
        }
        if (dx === this.dx && dy === this.dy) { return }
        const dist = Math.round(Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)))
        if (!this.isMoving && dist < 3) { return }
        this.changeIsMoving(true);
        this.dx = dx; this.dy = dy;
        this.dist = dist;
        let angle = this.geo.getAngle([[this.cx, this.cy], [client.x, client.y]])
        this.setSelectRect(dx, dy);
        let x: number = 0, y: number = 0;
        if (this.so.x !== undefined && this.so.y !== undefined) {
            x = this.so.x + dx; y = this.so.y + dy;
            let { minX, minY, maxX, maxY } = this.p;
            if (minX !== undefined && x < minX) { x = minX }
            if (maxX !== undefined && x > maxX) { x = maxX }
            if (minY !== undefined && y < minY) { y = minY }
            if (maxY !== undefined && y > maxY) { y = maxY }
        }
        if (stepX === true) {
            x = Math.round(x / this.domLimit.width) * this.domLimit.width;
        }
        if (stepY === true) {
            y = Math.round(y / this.domLimit.height) * this.domLimit.height;
        }
        if (insideX) {
            if (this.parentLimit) {
                if (x > this.parentLimit.width - this.domLimit.width) { x = this.parentLimit.width - this.domLimit.width }
                if (x < 0) { x = 0 }
            }
            else {
                alert('Swip error => you set insideX prop but missing parent props')
            }
        }
        if (insideY) {
            if (this.parentLimit) {
                if (y > this.parentLimit.height - this.domLimit.height) { y = this.parentLimit.height - this.domLimit.height }
                if (y < 0) { y = 0 }
            }
            else {
                alert('Swip error => you set insideY prop but missing parent props')
            }
        }

        this.change = { x, y, dx, dy, dist: this.dist, angle, deltaCenterAngle, dir: this.senseDir === false ? undefined : this.senseDir }
        if (this.senseDir === false) {
            const dist = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2))
            if (dist > 8) {
                if (Math.abs(dx) > Math.abs(dy)) { this.senseDir = 'h' }
                else { this.senseDir = 'v' }
                this.change.dir = this.senseDir
            }
        }

        let p: I_Swip_parameter = {
            index: this.index,
            change: this.change,
            mousePosition,
            domLimit: this.domLimit,
            parentLimit: this.parentLimit,
            event: e,
            selectRect: this.so.sr,
            isInSelectRect: this.getIsInSelectRect(this.so.sr || { left: 0, top: 0, width: 0, height: 0 })

        }
        if (this.p.move) {
            if (!this.sentMove) { this.sentMove = JSON.stringify(this.change) }
            else if (JSON.stringify(this.change) !== this.sentMove) { this.p.move(p); }
        }
    }
    mouseUp = (e: any) => {
        e.stopPropagation();
        this.senseDir = false
        EventHandler('window', 'mousemove', this.mouseMove, 'unbind');
        EventHandler('window', 'mouseup', this.mouseUp, 'unbind');
        //chon click bad az mouseUp call mishe mouseUp isMoving ro zoodtar false mikone (pas nemitoone jeloye click bad az harekat ro begire), pas bayad in amal ba yek vaghfe anjam beshe
        //jeloye clicke bad az harekat ro migirim ta bad az drag kardan function click call nashe
        let mousePosition = this.getMousePosition(e);
        this.removeSelectRect();
        let p: I_Swip_parameter = {
            index: this.index,
            change: this.change,
            event: e,
            domLimit: this.domLimit,
            parentLimit: this.parentLimit,
            mousePosition,
            selectRect: this.so.sr,
            isInSelectRect: this.getIsInSelectRect(this.so.sr || { left: 0, top: 0, width: 0, height: 0 })
        }
        if (this.isMoving) {
            if (this.p.end) { this.p.end(p) }
        }
        else { this.click(e) }
        this.changeIsMoving(false)

    }
    getIsInSelectRect: I_Swip_getIsInSelectrect = (selectRect) => {
        let { left, top, width, height } = selectRect;
        return (x: number, y: number) => {
            if (x < left) { return false }
            if (y < top) { return false }
            if (x > left + width) { return false }
            if (y > top + height) { return false }
            return true
        }
    }
    addSelectRect = (left: number, top: number) => {
        if (!this.selectRect || !this.selectRect.enable()) { return }
        let { color } = this.selectRect;
        let dom = this.getDom();
        this.so.tsr = { left, top };
        this.removeSelectRect();
        dom.append(`<div class="swip-select-rect" style="border:1px dashed ${color};background:${color + '30'};left:${left}px;top:${top}px;position:absolute;width:0;height:0"></div>`)
    }
    setSelectRect = (width: number, height: number) => {
        if (!this.selectRect || !this.selectRect.enable()) { return }
        let dom = this.getDom();
        let SR = dom.find('.swip-select-rect');
        let { tsr = { left: 0, top: 0 } } = this.so || {};
        let left = tsr.left;
        let top = tsr.top;
        if (width < 0) {
            left = left + width;
            width = Math.abs(width)
        }
        if (height < 0) {
            top = top + height;
            height = Math.abs(height)
        }
        let newSelectRect: I_Swip_selectRect = { left, top, width, height }
        this.so.sr = newSelectRect;
        SR.css(newSelectRect)
    }
    removeSelectRect = () => {
        if (!this.selectRect || !this.selectRect.enable()) { return }
        let dom = this.getDom();
        let selectRect = dom.find('.swip-select-rect');
        selectRect.remove();
    }
}
export function getLeftAndTopByCenterAngleLength(center: [number, number], angle: number, length: number): { left: number, top: number } {
    const line: [[number, number], [number, number]] = new Geo().getLineBySLA(center, length, angle);
    const [left, top] = line[1]
    return { left, top }
}
export type I_mockMethod = (p: { body?: any, queryParams?: any }) => { status: number, data: any }
export function FixUrl(base_url: string, path: string) {
    if (base_url[base_url.length - 1] === '/') { base_url = base_url.slice(0, base_url.length - 1) }
    if (path[0] === '/') { path = path.slice(1, path.length) }
    return `${base_url}/${path}`
}

export class Validation {
    fa?: boolean;
    constructor(p: { fa?: boolean }) {
        this.fa = p.fa
    }
    validate(p: { value: any, label: string, validation: string | string[] }): string | void {
        const { value, label, validation = [] } = p;
        if (validation && !Array.isArray(validation)) { return this.validateUnit({ ...p, validation }) }
        for (let i = 0; i < validation.length; i++) {
            const res = this.validate({ value, label, validation: validation[i] })
            if (res) { return res }
        }
    }
    private validateUnit = (p: { value: any, label: string, validation: string }): string | void => {
        if (p.validation === 'email' && !this.email(p.value)) { return this.fa ? `فرمت ${p.label} صحیح نیست` : `${p.label} format is incorrect` }
        if (p.validation === "irNationalCode" && !this.irNationalCode(p.value)) { return this.fa ? `فرمت ${p.label} صحیح نیست` : `${p.label} format is incorrect` }
        if (p.validation === 'irMobile') { return this.irMobile({ value: p.value, label: typeof p.label === 'string' ? p.label : '' }); }
        const lengthResult = this.length(p);
        if (lengthResult) { return lengthResult }
        const containResult = this.contain(p);
        if (containResult) { return containResult }
        const startResult = this.startEnd({ ...p, type: 'start' });
        if (startResult) { return startResult }
        const endResult = this.startEnd({ ...p, type: 'end' });
        if (endResult) { return endResult }
        const equalResult = this.equal(p);
        if (equalResult) { return equalResult }
        const patternResult = this.pattern(p);
        if (patternResult) { return patternResult }
    }
    IsJustNumber = (str: string) => /^\d+$/.test(str)
    HasNumber = (str: string) => /\d/.test(str)
    HasLetter = (str: string) => /[a-zA-Z]/.test(str)
    HasUppercase = (str: string) => /[A-Z]/.test(str)
    HasLowercase = (str: string) => /[a-z]/.test(str)
    HasSymbol = (str: string) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(str)
    HasSpace = (str: string) => {
        const index = str.indexOf(' ')
        return index !== -1
    }

    getValidationOptions = (
        value: any,
        validation: string,
        type: 'equal' | 'contain' | 'length' | 'start' | 'end' | 'pattern',
        types?: any[]
    ): { not: boolean, targets: string[], operator: string } | undefined => {
        if (types) {
            const valueType = Array.isArray(value) ? 'array' : typeof value;
            if (types.indexOf(valueType) === -1) { return }
        }
        if (typeof validation !== 'string') { return }
        const index = validation.indexOf(type)
        if (index !== 0 && index !== 1) { return }
        const camaIndex = validation.indexOf(',')
        const operatorStr = validation.slice(0, camaIndex);
        const targetStr = validation.slice(camaIndex + 1);
        if (!targetStr) { return }
        const not = operatorStr[0] === '!';
        const targets = targetStr.split('|');
        const operator = operatorStr[operatorStr.length - 1]
        return { not, targets, operator }
    }
    isTargetSpecial = (target: string) => {
        return ['space', 'number', 'letter', 'uppercase', 'lowercase', 'symbol'].indexOf(target) !== -1
    }
    checkContainSpecial = (str: string, target: string) => {
        if (target === 'space' && !this.HasSpace(str)) { return false }
        if (target === 'number' && !this.HasNumber(str)) { return false }
        if (target === 'letter' && !this.HasLetter(str)) { return false }
        if (target === 'uppercase' && !this.HasUppercase(str)) { return false }
        if (target === 'lowercase' && !this.HasLowercase(str)) { return false }
        if (target === 'symbol' && !this.HasSymbol(str)) { return false }
        return true
    }

    private email = (value: string): boolean => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return !!emailRegex.test(value)
    }
    private irNationalCode = (code: string): boolean => {
        if (!/^\d{10}$/.test(code)) return false;
        const check = parseInt(code[9], 10);
        let sum = 0;
        for (let i = 0; i < 9; i++) { sum += parseInt(code[i], 10) * (10 - i); }
        const remainder = sum % 11;
        return (remainder < 2 && check === remainder) || (remainder >= 2 && check === 11 - remainder);
    }
    private irMobile = (p: { value: string, label: string }): string | undefined => {
        if (p.value.indexOf('09') !== 0) { return this.fa ? `${p.label} باید با 09 شروع شود` : `${p.label} should start with 09` }
        if (p.value.length < 11) { return this.fa ? `${p.label} باید 11 رقم باشد` : `${p.label} should be 11 character` }
        if (!this.IsJustNumber(p.value)) { return this.fa ? `${p.label} باید فقط شامل عدد باشد` : `${p.label} should be contain just numbers` }
    }
    private length = (p: { value: string | number | any[], validation: string, label: string }): string | undefined => {
        const options = this.getValidationOptions(p.value, p.validation, 'length', ['string', 'number', 'array'])
        if (!options) { return }
        const { not, targets, operator } = options;
        if (['=', '>', '<'].indexOf(operator) === -1) { return }
        const isMatchUnit = (target: string) => {
            const getValueStr = () => {
                if (Array.isArray(p.value)) { let res = ''; for (let i = 0; i < p.value.length; i++) { res += 'a' } return res }
                if (typeof p.value === 'number') { return p.value.toString() }
                return p.value
            }
            const valueStr = getValueStr()
            let res = true
            if (operator === '=' && valueStr.length !== +target) { res = false }
            if (operator === '>' && valueStr.length <= +target) { res = false }
            if (operator === '<' && valueStr.length >= +target) { res = false }
            return not ? !res : res
        }
        const isMatch = () => {
            for (let i = 0; i < targets.length; i++) {
                if (isMatchUnit(targets[i])) { return true }
            }
            return false
        }
        const getText = () => {
            const operatorStr = ({
                en: {
                    '=': { be: 'should be', not: 'should not be' },
                    '>': { be: 'should be more than', not: 'should not be more than' },
                    '<': { be: 'should be less than', not: 'should not be less than' }
                },
                fa: {
                    '=': { be: 'باید', not: 'نباید' },
                    '>': { be: 'باید بیش از', not: 'نباید بیش از' },
                    '<': { be: 'باید کمتر از', not: 'نباید کمتر از' }
                }
            } as any)[this.fa ? 'fa' : 'en'][operator][not ? 'not' : 'be']
            const entityName = Array.isArray(p.value) ? (this.fa ? 'مورد' : 'item') : (this.fa ? 'کاراکتر' : 'characters')
            const after = this.fa ? ' باشد' : ''
            return `${p.label} ${operatorStr} ${targets.join(this.fa ? ' یا ' : ' or ')} ${entityName}${after}`
        }
        return isMatch() ? undefined : getText()
    }
    private contain = (p: { value: string | any[], validation: string, label: string }): string | undefined => {
        const options = this.getValidationOptions(p.value, p.validation, 'contain', ['string', 'array'])
        if (!options) { return }
        const { not, targets } = options;
        const isMatchUnit = (not: boolean, target: string) => {
            let res = true;
            if (typeof p.value === 'string') {
                if (this.isTargetSpecial(target)) {
                    if (!this.checkContainSpecial(p.value, target)) { res = false }
                }
                else { if (p.value.indexOf(target) === -1) { res = false } }
            }
            else {
                if (p.value.indexOf(target) === -1) { res = false }
            }
            return not ? !res : res
        }
        const isMatch = () => {
            for (let i = 0; i < targets.length; i++) {
                if (isMatchUnit(not, targets[i])) { return true }
            }
            return false
        }
        const getText = () => {
            const operatorStr = {
                en: { be: 'should be contain', not: 'should not be contain' },
                fa: { be: 'باید شامل', not: 'نباید شامل' }
            }[this.fa ? 'fa' : 'en'][not ? 'not' : 'be']
            const after = this.fa ? ' باشد' : ''
            return `${p.label} ${operatorStr} ${targets.join(this.fa ? ' یا ' : ' or ')}${after}`
        }
        return isMatch() ? undefined : getText()
    }
    private startEnd = (p: { value: string, validation: string, label: string, type: 'start' | 'end' }): string | undefined => {
        const type = p.type;
        const options = this.getValidationOptions(p.value, p.validation, type, ['string'])
        if (!options) { return }
        const { not, targets } = options;
        const isMatchUnit = (target: string) => {
            let res = true
            const char = type === "start" ? p.value[0] : p.value[p.value.length - 1]
            if (this.isTargetSpecial(target)) {
                if (!this.checkContainSpecial(char, target)) { res = false }
            }
            else if (p.value.length < target.length) { res = false }
            else if (type === "start") { if (p.value.indexOf(target) !== 0) { res = false } }
            else { if (p.value.slice(-target.length) !== target) { res = false } }
            return not ? !res : res
        }
        const isMatch = () => {
            for (let i = 0; i < targets.length; i++) {
                if (isMatchUnit(targets[i])) { return true }
            }
            return false
        }
        const getText = () => {
            const faOperator = type === 'start' ? 'شروع' : 'تمام'
            if (!this.fa) { return `${p.label} should${not ? ' not' : ''} ${type} with ${targets.join(' or ')}` }
            else { return `${not ? 'نباید' : 'باید'} با ${targets.join(' یا ')} ${faOperator} شود` }
        }
        return isMatch() ? undefined : getText()
    }
    private equal = (p: { value: string | number | boolean | null | undefined, validation: string, label: string }): string | undefined => {
        const options = this.getValidationOptions(p.value, p.validation, 'equal', ['string', 'number', 'booalean', 'undefined', null])
        if (!options) { return }
        const { not, targets } = options;
        const isMatchUnit = (not: boolean, target: string) => {
            let res = true;
            if (p.value !== target) { res = false }
            return not ? !res : res
        }
        const isMatch = () => {
            for (let i = 0; i < targets.length; i++) {
                if (isMatchUnit(not, targets[i])) { return true }
            }
            return false
        }
        const getText = () => {
            const operatorStr = {
                en: { be: 'should be equal', not: 'should not be equal' },
                fa: { be: 'باید برابر', not: 'نباید برابر' }
            }[this.fa ? 'fa' : 'en'][not ? 'not' : 'be']
            const after = this.fa ? ' باشد' : ''
            return `${p.label} ${operatorStr} ${targets.join(this.fa ? ' یا ' : ' or ')}${after}`
        }
        return isMatch() ? undefined : getText()
    }
    getPatternList = (pattern: string) => {
        let patternText = pattern
        const list = []
        while (patternText !== '') {
            if (patternText.indexOf('_n_') === 0) {
                list.push('number');
                patternText = patternText.slice(3)
            }
            else if (patternText.indexOf('_l_') === 0) {
                list.push('letter');
                patternText = patternText.slice(3)
            }
            else if (patternText.indexOf('_s_') === 0) {
                list.push('symbol');
                patternText = patternText.slice(3)
            }
            else if (patternText.indexOf('_[') === 0) {
                const closeIndex = patternText.indexOf(']')
                const listStr = patternText.slice(2, closeIndex);
                const listArray = listStr.split(',');
                list.push(listArray);
                patternText = patternText.slice(closeIndex + 2)
            }
            else if (patternText) {
                list.push(patternText[0]);
                patternText = patternText.slice(1)
            }
        }
        return list
    }
    patternMatch = (text: string, pattern: string): boolean => {
        const list = this.getPatternList(pattern);
        if (text.length !== list.length) { return false }
        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            const pattern = list[i];
            if (pattern === 'number') { if (!this.HasNumber(char)) { return false } }
            else if (pattern === 'letter') { if (!this.HasLetter(char)) { return false } }
            else if (pattern === 'symbol') { if (!this.HasSymbol(char)) { return false } }
            else if (Array.isArray(pattern)) {
                if (pattern.indexOf(char) === -1) { return false }
            }
            else { if (char !== pattern) { return false } }
        }
        return true
    }
    pattern = (p: { value: string, validation: string, label: string }): string | undefined => {
        if (!p.value || !p.validation) { return }
        const options = this.getValidationOptions(p.value, p.validation, 'pattern', ['string'])
        if (!options) { return }
        const { not, targets } = options;

        const isMatchUnit = (not: boolean, target: string) => {
            let res = true;
            if (!!target && !this.patternMatch(p.value, target)) { res = false }
            return not ? !res : res
        }
        const isMatch = () => {
            for (let i = 0; i < targets.length; i++) {
                if (isMatchUnit(not, targets[i])) { return true }
            }
            return false
        }
        const getText = () => {
            if (this.fa) { return `فرمت ${p.label} صحیح نیست` }
            return `${p.label} format is not correct`
        }
        return isMatch() ? undefined : getText()
    }

}
export function getErrorByRequired(p: { value: any, label: string, fa?: boolean, required: boolean }): string | void {
    const isNull = p.value === undefined || p.value === '' || p.value === null
    if (isNull && p.required) { return p.fa ? `${p.label} ضروری است` : `${p.label} is required` }
}
export function AddQueryParamsToUrl(url: string, params: { [key: string]: any }) {
    const queryParts: string[] = [];
    function serialize(obj: any, parentKey = '') {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const fullKey = parentKey ? `${parentKey}.${key}` : key;
                const value = obj[key];

                if (typeof value === 'object' && value !== null) {
                    queryParts.push(`${encodeURIComponent(fullKey)}=${encodeURIComponent(JSON.stringify(value))}`);
                } else {
                    queryParts.push(`${encodeURIComponent(fullKey)}=${encodeURIComponent(value)}`);
                }
            }
        }
    }

    serialize(params);

    if (queryParts.length > 0) {
        url += (url.includes('?') ? '&' : '?') + queryParts.join('&');
    }
    return url;
}
type Coordinates = { lat: number; lng: number };
export async function getUserLocation(): Promise<Coordinates | null> {
    try {
        // مرحله ۱: چک کن API ها موجود هستن
        if (!navigator.permissions || !navigator.geolocation) {
            console.warn("Geolocation or Permissions API not supported.");
            return null;
        }

        // مرحله ۲: درخواست اجازه برای دسترسی به موقعیت
        const permissionStatus = await navigator.permissions.query({ name: "geolocation" });

        if (permissionStatus.state === "denied") {
            console.warn("Location permission denied by user.");
            return null;
        }

        // مرحله ۳: گرفتن لوکیشن
        const position = await new Promise<GeolocationPosition>((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            });
        });

        return {
            lat: position.coords.latitude,
            lng: position.coords.longitude
        };
    } catch (err) {
        console.error("Failed to get location:", err);
        return null;
    }
}
export function IsEqual(a: any, b: any): boolean {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a !== 'object' || a === null || b === null) return false;
    const aKeys = Object.keys(a), bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (const key of aKeys) {
        if (!b.hasOwnProperty(key)) return false;
        if (!IsEqual(a[key], b[key])) return false;
    }
    return true;
}
export type LocationResult = | { success: true; latitude: number; longitude: number; errorMessage: ''; } | { success: false; errorMessage: string; latitude?: never; longitude?: never; };
export async function getCurrentLocation(
    options?: PositionOptions
): Promise<LocationResult> {
    if (typeof navigator === 'undefined' || !navigator.geolocation) { return { success: false, errorMessage: 'Geolocation is not supported in this environment.' }; }
    if (navigator.permissions?.query) {
        try {
            const status = await navigator.permissions.query({ name: 'geolocation' });
            if (status.state === 'denied') { return { success: false, errorMessage: 'Location permission was denied.', }; }
        } catch {/* Safari & friends: intentionally ignored*/ }
    }
    return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
            (position) => { resolve({ success: true, errorMessage: '', latitude: position.coords.latitude, longitude: position.coords.longitude, }); },
            (error) => {
                let message = 'Failed to retrieve location.';
                switch (error.code) {
                    case error.PERMISSION_DENIED: message = 'Location permission was denied by the user.'; break;
                    case error.POSITION_UNAVAILABLE: message = 'Location information is unavailable.'; break;
                    case error.TIMEOUT: message = 'Location request timed out.'; break;
                }
                resolve({ success: false, errorMessage: message, });
            },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 0, ...options }
        );
    });
}
export function Debounce(fn: any, delay?: number) {
    const inst = getSingleton('debounce', () => new DebounceClass())
    inst.execute(fn, delay)
}

class DebounceClass {
    ref: any;
    execute = (fn: any, delay?: number) => {
        clearTimeout(this.ref);
        this.ref = setTimeout(() => fn(), delay || 500);
    }
}

type ElementInput = HTMLElement | Element | { current?: Element | null } | any;
export function useResize(target: ElementInput, callback: (el: HTMLElement) => void) {
    const normalizeElement = (input: ElementInput): HTMLElement | null => {
        if (!input) return null;
        if ("current" in input) return normalizeElement(input.current);
        if (typeof window !== "undefined" && typeof (window as any).jQuery === "function") {
            const jQuery = (window as any).jQuery;
            if (jQuery && input instanceof jQuery) return input[0] ?? null;
        }
        if (Array.isArray(input)) return normalizeElement(input[0]);
        if ("length" in input && typeof input !== "string") return normalizeElement(input[0]);
        if (input instanceof HTMLElement) return input;
        if (input instanceof Element && "clientWidth" in input) return input as HTMLElement;
        return null;
    }
    const observerRef = useRef<ResizeObserver | null>(null);
    const prevSizeRef = useRef<{ width: number; height: number } | null>(null);
    useEffect(() => {
        const el = normalizeElement(target);
        if (!el) return;
        const debouncedCallback = () => {
            Debounce(() => { callback(el); })
        };
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const target = entry.target as HTMLElement;
                const newWidth = target.offsetWidth;
                const newHeight = target.offsetHeight;
                const prev = prevSizeRef.current;
                if (!prev || prev.width !== newWidth || prev.height !== newHeight) {
                    prevSizeRef.current = { width: newWidth, height: newHeight };
                    debouncedCallback();
                }
            }
        });
        observer.observe(el);
        observerRef.current = observer;
        return () => { observer.disconnect(); };
    }, [target, callback]);
}
type AI_Indent = {
    level: number, width: number, rtl: boolean, isLastChild: boolean, isParentLastChild: boolean, row: any, isLeaf: boolean,
    open?: boolean, onToggle?: () => void, toggleIcon?: false | { close?: ReactNode, open?: ReactNode, leaf?: ReactNode }
}
export const Indent: FC<AI_Indent> = (props) => {
    const { width, level, open, rtl, isLastChild, isParentLastChild, isLeaf } = props;
    const [indentPathes, setIndentPathes] = useState<ReactNode>(null)
    useEffect(() => { setIndentPathes(getIndentIcons()) }, [level, isLastChild, isParentLastChild])
    const [toggleIcon, setToggleIcon] = useState<ReactNode>(null)
    useEffect(() => { setToggleIcon(getToggleIcon()) }, [open])
    function getIndentIcon(rowIndex: number) {
        if (!level) { return null }
        let pathes = [];
        if (rowIndex === level - 1) {
            //horizontal line
            pathes.push(<div key='hl' style={{ [rtl ? 'right' : 'left']: width / 2, width: width / 2, height: 0, top: '50%', borderBottom: '1px dotted', position: 'absolute' }}></div>)
            //vertical direct line
            pathes.push(<div key='vdl' style={{ left: width / 2, width: 0, height: isLastChild ? '50%' : '100%', top: 0, borderLeft: '1px dotted', position: 'absolute' }}></div>)
        }
        else {
            //vertical connet line
            if (!isParentLastChild) {
                pathes.push(<div key='vl' style={{ left: width / 2, width: 0, height: '100%', top: 0, borderLeft: '1px dotted', position: 'absolute' }}></div>)
            }
        }
        return (<div className='ai-indent-line' style={{ width, height: '100%' }}>{pathes}</div>)
    }

    const getToggleSvg = (): false | ReactNode => {
        const { toggleIcon = {} } = props;
        if (toggleIcon === false) { return false }
        const getIcon = new GetSvg('em').getIcon;
        if (open === undefined) { return toggleIcon.leaf || getIcon('mdiCircleSmall', 1) }
        if (open) { return toggleIcon.open || getIcon('mdiChevronDown', 1) }
        return toggleIcon.close || getIcon(rtl ? 'mdiChevronLeft' : 'mdiChevronRight', 1)
    }
    const getIndentIcons = () => {
        const list = new Array(level).fill(0)
        return list.map((o, i) => {
            if (o) { }
            return <div key={i} className={`ai-indent`} style={{ width }}>{getIndentIcon(i)}</div>
        })
    }
    const getToggleIcon = () => {
        return (
            <div className="ai-toggle" style={{ width }} onClick={(e) => { e.stopPropagation(); if (props.onToggle) { props.onToggle() } }}>
                <div className={`ai-toggle-icon${isLeaf ? ' ai-leaf-icon' : ''}`}>{toggleSvg}</div>
                {
                    open === true &&
                    <div className='ai-toggle-line ai-indent-line'>
                        <div
                            style={{
                                position: 'absolute',
                                left: width / 2,
                                height: '100%',
                                borderLeft: '1px dotted'
                            }}
                        >
                        </div>
                    </div>
                }
            </div>
        )
    }
    const toggleSvg = getToggleSvg();
    if (toggleSvg === false) { return null }
    return (
        <div className={`ai-indents`}>{indentPathes}{toggleIcon}</div>
    )
}
export class GetSvg {
    private unit: 'rem' | 'em';
    constructor(unit?: 'rem' | 'em') {
        this.unit = unit || 'rem'
    }
    private getStyle = (color?: string) => {
        const fill = color || "currentcolor"
        return { fill }
    }
    private getSvgStyle = (size?: number) => {
        size = size || 1;
        return { width: `${size * 1.5}${this.unit}`, height: `${size * 1.5}${this.unit}` }
    }
    private fixSvgContent = (content: ReactNode, size?: number, p?: { spin?: number, color?: string }) => {
        const { spin } = p || {}
        let res = null;
        if (spin) {
            res = (
                <>
                    <style>{`@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`}</style>
                    <g style={{ animation: `${spin}s linear 0s infinite normal none running spin`, transformOrigin: 'center center' }}>{content}</g>
                </>
            )
        }
        else { res = content }
        return (<svg viewBox="0 0 24 24" role="presentation" style={this.getSvgStyle(size)}>{res}</svg>)
    }
    getIcon = (path: string, size?: number, p?: { spin?: number, color?: string }) => {
        const { color } = p || {}
        const content = (this as any)[path](color)
        return this.fixSvgContent(content, size, p)
    }
    private getFileIconName = (file: File) => {
        const ext = file.name.split(".").pop()?.toLowerCase();
        switch (ext) {
            case "png": case "jpg": case "jpeg": case "gif": case "webp": return "mdiImage";
            case "mp4": case "webm": case "mov": case "avi": return "video";
            case "mp3": case "wav": case "ogg": case "m4a": return "mdiMusic";
            case "pdf": return "mdiFilePdfBox";
            case "doc": case "docx": return "mdiFileWordBox";
            case "xls": case "xlsx": case "csv": return "mdiFileExcelBox";
            case "ppt": case "pptx": return "mdiFilePowerPointBox";
            case "zip": case "rar": case "7z": case "tar": return "mdiZipBox";
            default: return "mdiFile";
        }
    }
    getFileIcon = (file: File, size?: number, p?: { spin?: number, color?: string }) => {
        const path = this.getFileIconName(file);
        return this.getIcon(path, size, p)
    }
    mdiArrowDown = (color?: string) => (<><path d="M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z" style={this.getStyle(color)}></path></>)
    mdiArrowUp = (color?: string) => (<><path d="M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z" style={this.getStyle(color)}></path></>)
    mdiAttachment = (color?: string) => (<><path d="M7.5,18A5.5,5.5 0 0,1 2,12.5A5.5,5.5 0 0,1 7.5,7H18A4,4 0 0,1 22,11A4,4 0 0,1 18,15H9.5A2.5,2.5 0 0,1 7,12.5A2.5,2.5 0 0,1 9.5,10H17V11.5H9.5A1,1 0 0,0 8.5,12.5A1,1 0 0,0 9.5,13.5H18A2.5,2.5 0 0,0 20.5,11A2.5,2.5 0 0,0 18,8.5H7.5A4,4 0 0,0 3.5,12.5A4,4 0 0,0 7.5,16.5H17V18H7.5Z" style={this.getStyle(color)}></path></>)
    mdiChevronDown = (color?: string) => (<><path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" style={this.getStyle(color)}></path></>)
    mdiChevronUp = (color?: string) => (<><path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" style={this.getStyle(color)}></path></>)
    mdiChevronRight = (color?: string) => (<><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" style={this.getStyle(color)}></path></>)
    mdiCircleSmall = (color?: string) => (<><path d="M12,10A2,2 0 0,0 10,12C10,13.11 10.9,14 12,14C13.11,14 14,13.11 14,12A2,2 0 0,0 12,10Z" style={this.getStyle(color)}></path></>)
    mdiCheckBold = (color?: string) => (<><path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" style={this.getStyle(color)}></path></>)
    mdiChevronLeft = (color?: string) => (<><path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" style={this.getStyle(color)}></path></>)
    mdiCircleMedium = (color?: string) => (<><path d="M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z" style={this.getStyle(color)}></path></>)
    mdiClose = (color?: string) => (<><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" style={this.getStyle(color)}></path></>)
    mdiDelete = (color?: string) => (<><path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" style={this.getStyle(color)}></path></>)
    mdiDotsHorizontal = (color?: string) => (<><path d="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z" style={this.getStyle(color)}></path></>)
    mdiEye = (color?: string) => (<><path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" style={this.getStyle(color)}></path></>)
    mdiEyeOff = (color?: string) => (<><path d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z" style={this.getStyle(color)}></path></>)
    mdiFile = (color?: string) => (<><path d="M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z" style={this.getStyle(color)}></path></>)
    mdiFileExcel = (color?: string) => (<><path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z" style={this.getStyle(color)}></path></>)
    mdiFilter = (color?: string) => (<><path d="M14,12V19.88C14.04,20.18 13.94,20.5 13.71,20.71C13.32,21.1 12.69,21.1 12.3,20.71L10.29,18.7C10.06,18.47 9.96,18.16 10,17.87V12H9.97L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L14.03,12H14Z" style={this.getStyle(color)}></path></>)
    mdiImage = (color?: string) => (<><path d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z" style={this.getStyle(color)}></path></>)
    mdiLoading = (color?: string) => <><path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" style={this.getStyle(color)}></path><rect width="24" height="24" fill="transparent"></rect></>
    mdiListBox = (color?: string) => (<><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M7 7H9V9H7V7M7 11H9V13H7V11M7 15H9V17H7V15M17 17H11V15H17V17M17 13H11V11H17V13M17 9H11V7H17V9Z" style={this.getStyle(color)}></path></>)
    mdiMagnify = (color?: string) => (<><path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" style={this.getStyle(color)}></path></>)
    mdiMenu = (color?: string) => (<><path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" style={this.getStyle(color)} /></>)
    mdiMicrophoneOutline = (color?: string) => (<><path d="M17.3,11C17.3,14 14.76,16.1 12,16.1C9.24,16.1 6.7,14 6.7,11H5C5,14.41 7.72,17.23 11,17.72V21H13V17.72C16.28,17.23 19,14.41 19,11M10.8,4.9C10.8,4.24 11.34,3.7 12,3.7C12.66,3.7 13.2,4.24 13.2,4.9L13.19,11.1C13.19,11.76 12.66,12.3 12,12.3C11.34,12.3 10.8,11.76 10.8,11.1M12,14A3,3 0 0,0 15,11V5A3,3 0 0,0 12,2A3,3 0 0,0 9,5V11A3,3 0 0,0 12,14Z" style={this.getStyle(color)}></path></>)
    mdiPlusThick = (color?: string) => (<><path d="M20 14H14V20H10V14H4V10H10V4H14V10H20V14Z" style={this.getStyle(color)}></path></>)
    mdiSaveContent = (color?: string) => (<><path d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z" style={this.getStyle(color)}></path></>)
    mdiSort = (color?: string) => (<><path d="M18 21L14 17H17V7H14L18 3L22 7H19V17H22M2 19V17H12V19M2 13V11H9V13M2 7V5H6V7H2Z" style={this.getStyle(color)}></path></>)
    mdiMusic = (color?: string) => (<><path d="M21,3V15.5A3.5,3.5 0 0,1 17.5,19A3.5,3.5 0 0,1 14,15.5A3.5,3.5 0 0,1 17.5,12C18.04,12 18.55,12.12 19,12.34V6.47L9,8.6V17.5A3.5,3.5 0 0,1 5.5,21A3.5,3.5 0 0,1 2,17.5A3.5,3.5 0 0,1 5.5,14C6.04,14 6.55,14.12 7,14.34V6L21,3Z" style={this.getStyle(color)}></path></>)
    mdiFilePdfBox = (color?: string) => (<><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.5 11.5C9.5 12.3 8.8 13 8 13H7V15H5.5V9H8C8.8 9 9.5 9.7 9.5 10.5V11.5M14.5 13.5C14.5 14.3 13.8 15 13 15H10.5V9H13C13.8 9 14.5 9.7 14.5 10.5V13.5M18.5 10.5H17V11.5H18.5V13H17V15H15.5V9H18.5V10.5M12 10.5H13V13.5H12V10.5M7 10.5H8V11.5H7V10.5Z" style={this.getStyle(color)}></path></>)
    mdiFileWordBox = (color?: string) => (<><path d="M15.5,17H14L12,9.5L10,17H8.5L6.1,7H7.8L9.34,14.5L11.3,7H12.7L14.67,14.5L16.2,7H17.9M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" style={this.getStyle(color)}></path></>)
    mdiFileExcelBox = (color?: string) => (<><path d="M16.2,17H14.2L12,13.2L9.8,17H7.8L11,12L7.8,7H9.8L12,10.8L14.2,7H16.2L13,12M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" style={this.getStyle(color)}></path></>)
    mdiFilePowerPointBox = (color?: string) => (<><path d="M9.8,13.4H12.3C13.8,13.4 14.46,13.12 15.1,12.58C15.74,12.03 16,11.25 16,10.23C16,9.26 15.75,8.5 15.1,7.88C14.45,7.29 13.83,7 12.3,7H8V17H9.8V13.4M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M9.8,12V8.4H12.1C12.76,8.4 13.27,8.65 13.6,9C13.93,9.35 14.1,9.72 14.1,10.24C14.1,10.8 13.92,11.19 13.6,11.5C13.28,11.81 12.9,12 12.22,12H9.8Z" style={this.getStyle(color)}></path></>)
    mdiZipBox = (color?: string) => (<><path d="M14,17H12V15H10V13H12V15H14M14,9H12V11H14V13H12V11H10V9H12V7H10V5H12V7H14M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" style={this.getStyle(color)}></path></>)
    mdiCamera = (color?: string) => (<><path d="M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" style={this.getStyle(color)}></path></>)
    mdiArrowUpDownBold = (color?: string) => (<><path d="M10,8H6L12,2L18,8H14V16H18L12,22L6,16H10V8Z" style={this.getStyle(color)}></path></>)
    mdiSortVariantOff = (color?: string) => (<><path d="M20.84 22.73L11.11 13H3V11H9.11L6.11 8H3V6H4.11L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M15 11H14.2L15 11.8V11M21 8V6H9.2L11.2 8H21M3 18H9V16H3V18Z" style={this.getStyle(color)}></path></>)
    mdiDownload = (color?: string) => (<><path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" style={this.getStyle(color)}></path></>)
    mdiCalculator = (color?: string) => (<><path d="M7,2H17A2,2 0 0,1 19,4V20A2,2 0 0,1 17,22H7A2,2 0 0,1 5,20V4A2,2 0 0,1 7,2M7,4V8H17V4H7M7,10V12H9V10H7M11,10V12H13V10H11M15,10V12H17V10H15M7,14V16H9V14H7M11,14V16H13V14H11M15,14V16H17V14H15M7,18V20H9V18H7M11,18V20H13V18H11M15,18V20H17V18H15Z" style={this.getStyle(color)}></path></>)
}
type I_AIPanel = { header: { text: string, subtext?: ReactNode, before?: ReactNode, after?: ReactNode, attrs?: any }, body: ReactNode }
export const AIPanel: FC<I_AIPanel> = ({ header, body }) => {
    function header_layout() {
        const props = { ...header, attrs: AddToAttrs(header.attrs, { className: 'ai-panel-header' }) }
        return (<AICard {...props} />)
    }
    function body_layout() { return (<div className="ai-panel-body">{body}</div>) }
    return (<div className="ai-panel">{header_layout()} {body_layout()}</div>)
}
type I_AICard = { text: ReactNode, subtext?: ReactNode, onClick?: () => void, before?: ReactNode, after?: ReactNode, attrs?: any, className?: string, style?: any }
export const AICard: FC<I_AICard> = ({ text, subtext, onClick = () => { }, before, after, attrs, className, style }) => {
    const Attrs = AddToAttrs(attrs, { className: ["ai-card", className], style })
    return (
        <div {...Attrs}>
            {before !== undefined && <div className="ai-card-before" onClick={(e) => e.stopPropagation()}>{before}</div>}
            <div className="ai-card-body" onClick={onClick}>
                <div className="ai-card-text">{text}</div>
                {subtext !== undefined && <div className="ai-card-subtext">{subtext}</div>}
            </div>
            {after !== undefined && <div className="ai-card-after" onClick={(e) => e.stopPropagation()}>{after}</div>}
        </div>
    )
}
type I_AIApp = {
    appName?: string,
    appId: string,
    attrs?: any,
    rtl?: boolean,
    nav?: AI_Nav,
    body?: (activeNavOption: any) => ReactNode,
    header?: (activeNavOption: any) => ReactNode | false,
}
type AI_Nav = {
    value?: string, onChange?: (newValue: string) => void,
    options: any[],
    option?: {
        value?: (option: any) => string,
        text?: (option: any) => ReactNode,
        before?: (option: any) => ReactNode,
        after?: (option: any) => ReactNode,
        show?: (option: any) => boolean,
        active?: (option: any) => boolean,
        onClick?: (option: any) => void,
        render?: (option: any) => ReactNode,
        attrs?: (option: any) => any,
        className?: (option: any) => string | undefined,
        style?: (option: any) => any
    },
    className?: string,
    style?: any,
    attrs?: any,
    rtl?: boolean,
    indent?: number,
    header?: ReactNode,
    footer?: ReactNode,
    minimize?: boolean,
    cache?: boolean,
}
function getOptionValue(p: { optionProp: any, optionOrg: any, key: string, open?: boolean, def?: any }): any {
    const { optionOrg, key, open, def, optionProp = {} } = p;
    if ((optionProp as any)[key]) { return (optionProp as any)[key](optionOrg, !!open) }
    else if (typeof optionOrg === 'object' && optionOrg[key] !== undefined) { return optionOrg[key] }
    return def
}
export const AIApp: FC<I_AIApp> = (props) => {
    const navHook = useNav(props.appId, props.nav)
    useEffect(() => {
        const value = props.nav?.value
        if (value !== undefined) { navHook.changeActiveNavOption(value) }
    }, [props.nav?.value])
    function header_layout() {
        if (!props.header) { return null }
        const header = props.header(navHook.activeNavOption)
        return header === false ? null : header
    }
    function getNavContent(): ReactNode {
        if (!props.nav || !navHook.activeNavOption) { return null }
        if (typeof navHook.activeNavOption === 'object' && navHook.activeNavOption.render) { return navHook.activeNavOption.render() }
        if (props.nav.option?.render) { return props.nav.option.render(navHook.activeNavOption) }
        return null
    }
    function sideNav_layout() {
        if (!props.nav) { return null }
        return <div className="ai-app-side"><Sidenav {...props.nav} onChange={(v) => navHook.changeActiveNavOption(v)} value={activeNavValue} /></div>
    }
    function body_layout() {
        const content = getNavContent()
        return (
            <div className='ai-app-content'>
                {sideNav_layout()}
                <div className="ai-app-center">
                    {header_layout()}
                    <div className="ai-app-body">{content} {!!props.body && props.body(navHook.activeNavOption)}</div>
                </div>
            </div>
        )
    }
    const activeNavValue = getOptionValue({ optionProp: props.nav?.option || {}, optionOrg: navHook.activeNavOption, key: 'value' })
    const attrs = AddToAttrs(props.attrs, { className: 'ai-app' })
    return (<div {...attrs}>{body_layout()}</div>)
}
const useNav = (appId: string, nav?: I_AIApp["nav"]) => {
    const StorageRef = useRef<Storage>(new Storage('aiapp' + appId))
    const snRes = useRef<any>(undefined)
    const [activeNavOption, setActiveNavOption] = useState<any>(getActiveNavOption)
    function changeActiveNavOption(value: any) {
        const optionOrg = getByValue(value);
        if (nav?.cache) { StorageRef.current.save('navitemvalue', value) }
        setActiveNavOption(optionOrg)
    }

    function getActiveNavOption() {
        if (!nav) { return }
        const value = nav.cache ? StorageRef.current.load('navitemvalue', nav.value) : nav.value
        const res = getByValue(value)
        return res
    }
    function getByValue(value: string) {
        if (!nav || !value) { return }
        snRes.current = undefined;
        getByValue_req(nav.options, value, 0);
        return snRes.current;
    }
    function getByValue_req(options: any[], v: string, level: number) {
        if (snRes.current) { return; }
        const optionProp = nav?.option
        for (let i = 0; i < options.length; i++) {
            if (snRes.current) { return; }
            let optionOrg = options[i];
            const show = getOptionValue({ optionProp, optionOrg, key: 'show', def: true })
            if (!show) { continue }
            const value = getOptionValue({ optionProp, optionOrg, key: 'value' })
            if (value === v) { snRes.current = optionOrg; break; }
            const subOptions = getOptionValue({ optionProp, optionOrg, key: 'options', def: [] })
            if (subOptions.length) {
                getByValue_req(subOptions, v, level + 1);
            }
        }
    }
    return { activeNavOption, changeActiveNavOption, getByValue }
}

export const AIBottomMenu: FC<AI_Nav> = (props) => {
    const { options, option: optionProp = {} } = props
    function item_layout(optionOrg: any) {
        const show = getOptionValue({ optionProp, key: 'value', optionOrg, def: true })
        if (show === false) { return null }
        const value = getOptionValue({ optionProp, key: 'value', optionOrg })
        const text = getOptionValue({ optionProp, key: 'text', optionOrg })
        const before = getOptionValue({ optionProp, key: 'before', optionOrg })
        const after = getOptionValue({ optionProp, key: 'after', optionOrg })
        const attrs = getOptionValue({ optionProp, key: 'attrs', optionOrg })
        const className = getOptionValue({ optionProp, key: 'className', optionOrg })
        const style = getOptionValue({ optionProp, key: 'style', optionOrg })
        const active = (props.value !== undefined && props.value === value) || getOptionValue({ optionProp, key: 'active', optionOrg });
        const Attrs = AddToAttrs(attrs, {
            className: ['ai-bottom-menu-item', active ? 'active' : undefined, className], style,
            attrs: {
                onClick: () => {
                    if (optionProp.onClick) { optionProp.onClick(optionOrg) }
                    if (props.onChange) { props.onChange(value) }
                }
            }
        })
        return (
            <div key={value} {...Attrs}>
                {!!before && before}
                <div className="ai-bottom-menu-item-body">{text !== undefined && text}</div>
                {!!after && after}
            </div>
        )
    }
    return (<div className="ai-bottom-menu">{options.map((o) => item_layout(o))}</div>)
}
export const Sidenav: FC<AI_Nav> = (props) => {
    let { rtl = false, header, value, option: optionProp = {}, options = [], footer } = props;
    const [minimize, setMinimize] = useState(!!props.minimize)
    const [icons] = useState<GetSvg>(new GetSvg())
    function getAfter(optionOrg: any, detail: AI_optionDetail) {
        const open = detail.isOpen();
        const after = getOptionValue({ optionProp, optionOrg, key: 'after', open });
        const options = getOptionValue({ optionProp, optionOrg, key: 'options', open }) || [];
        const icon = icons.getIcon(open ? 'mdiChevronDown' : (rtl ? 'mdiChevronRight' : 'mdiChevronLeft'), 0.7);
        return (<div className={`ai-sidenav-item-after`}>{!!after && after} {!!options.length && <div className="ai-sidenav-toggle">{icon}</div>}</div>)
    }
    function getBefore(optionOrg: any, detail: AI_optionDetail) {
        const open = detail.isOpen();
        let before = getOptionValue({ optionProp, optionOrg, key: 'before', open });
        if (detail.level > 0 && !before) { before = icons.getIcon('mdiCircleMedium', 0.6) }
        if (!before) { return null }
        return (<div className={`ai-sidenav-item-before`}>{before}</div>)
    }
    const defaultOption: AI_optionProp = {
        text: (optionOrg) => getOptionValue({ optionOrg, optionProp, key: 'text' }),
        value: (optionOrg) => getOptionValue({ optionOrg, optionProp, key: 'value' }),
        after: (optionOrg, detail) => getAfter(optionOrg, detail),
        before: (option, detail) => getBefore(option, detail),
        onClick: (optionOrg, details) => {
            const subOptions = getOptionValue({ optionProp, optionOrg, key: 'options', def: [] });
            if (!!subOptions.length) { details.toggle() }
            else {
                if (typeof optionOrg === 'object' && optionOrg.onClick) { optionOrg.onClick(optionOrg) }
                else if (optionProp.onClick) { optionProp.onClick(optionOrg) }
                if (props.onChange) { props.onChange(details.value) }
            }
        },
        show: (optionOrg) => getOptionValue({ optionProp, optionOrg, key: 'show', def: true }),
        childs: (optionOrg) => getOptionValue({ optionProp, optionOrg, key: 'options' }),
        toggleIcon: () => false
    }
    // let activeNavOption: any;
    const isActive = (optionOrg: any) => {
        if (value !== undefined) {
            const optionValue = getOptionValue({ optionProp, optionOrg, key: 'value' })
            return optionValue === value
        }
        const res =  getOptionValue({ optionProp, optionOrg, key: 'active' })
        return res
    }
    const finalOptions: AI_optionProp = {
        ...defaultOption,
        className: (option, { level }) => {
            const active = isActive(option)
            const cls = getOptionValue({ optionProp, optionOrg: option, key: 'className' })
            if (active) {
                // activeNavOption = option;
            }
            return `ai-sidenav-${level === 0 ? 'item' : 'sub-item'}${active ? ' active' : ''}${cls ? ' ' + cls : ''}`
        }
    }
    const attrs = AddToAttrs(props.attrs, { className: ['ai-sidenav', props.className, !!minimize ? 'ai-sidenav-minimize' : undefined] })
    const tree = (
        <div className="ai-sidenav-body">
            <AITree {...attrs} className={'ai-sidenav-tree'} size={48} value={[...options]} option={finalOptions} indent={0} />
        </div>
    )
    return (
        <div {...attrs}>
            {!!header && header !== null && <div className="ai-sidenav-header">{header}</div>}
            {
                !!props.minimize &&
                <div className="ai-sidenav-minimize-button" onClick={() => setMinimize(!minimize)}>
                    <div className="ai-sidenav-minimize-icon">{icons.getIcon('mdiMenu', 1)}</div>
                </div>
            }
            {tree}
            {!!footer && footer !== null && <div className="ai-sidenav-header">{footer}</div>}

        </div>
    )
}
type I_useSideContext = { rootProps: any }
const useSideContext = createContext<I_useSideContext>({} as any)
const UseSideProvider: FC<{ children: ReactNode, value: I_useSideContext }> = ({ children, value }) => {
    return (<useSideContext.Provider value={value}>{children}</useSideContext.Provider>)
}
const useSideConsumer = () => {
    return useContext(useSideContext)
}
export const useSide = <T = any,>(
    p: {
        value?: string, onChange?: (newValue: string) => void,
        options: any[],
        option?: {
            value?: (option: T) => string,
            text?: (option: T) => ReactNode,
            before?: (option: T) => ReactNode,
            after?: (option: T) => ReactNode,
            show?: (option: T) => boolean,
            active?: (option: T) => boolean,
            onClick?: (option: T) => void,
            render?: (option: T) => ReactNode,
            attrs?: (option: T) => any,
            className?: (option: T) => string | undefined,
            style?: (option: T) => any
        },
        className?: string,
        style?: any,
        attrs?: any,
        rtl?: boolean,
        indent?: number,
        header?: ReactNode,
        footer?: ReactNode,
        minimize?: boolean,
        cache?: boolean,
    }
) => {
    const popup = usePopup({ rtl: p.rtl })
    const render = (<UseSideProvider value={{ rootProps: p }}>{popup.render()}</UseSideProvider>)
    const open = () => popup.addModal({ id: 'sidemenu', position: p.rtl ? 'right' : 'left', body: <UseSide /> })
    const close = () => popup.removeModal('sidemenu')
    return { render, open, close }
}
const UseSide: FC = () => {
    const { rootProps } = useSideConsumer()
    return <Sidenav {...{ ...rootProps, type: 'side', value: rootProps.value }} />
}
export type I_MonthCells = {
    year: number, month: number, cellContent: (date: number[], weekDayIndex: number) => ReactNode, weekDayContent?: (v: number) => ReactNode,
    changeMonth: (month: number) => void
}
export const MonthCells: FC<I_MonthCells> = ({ year, month, cellContent, weekDayContent }) => {
    const [DATE] = useState<AIODate>(new AIODate())
    function getDateInfo() {
        const res = {
            monthDaysLength: DATE.getMonthDaysLength([year, month]),
            firstDayIndex: DATE.getWeekDay([year, month, 1]).index,
            monthString: DATE.getMonths(true)[month - 1]
        }
        console.log(res, year, month)
        return res
    }
    const gtc = Math.floor(100 / 7);
    const gridTemplateColumns: string = `${gtc}% ${gtc}% ${gtc}% ${gtc}% ${gtc}% ${gtc}% ${gtc}%`;
    function weekDays_layout() {
        if (!weekDayContent) { return null }
        return (
            <div className="ai-month-grid" style={{ gridTemplateColumns }}>
                {DATE.getWeekDays(true).map((o: string, i: number) => <div key={o} className={`ai-month-weekday`}>{weekDayContent(i)}</div>)}
            </div>
        )
    }
    function spaces_layout() {
        return new Array(dateInfo.firstDayIndex).fill(0).map((o, i) => {
            if (o) { }
            return <div key={i} className=""></div>
        })
    }
    function cells_layout() { return GetArray(dateInfo.monthDaysLength).map((day: number) => cell_layout(day + 1)) }
    function cell_layout(day: number) {
        const date = [year, month, day];
        const weekDayIndex: number = DATE.getWeekDay(date).index;
        return (<div key={day} className="ai-month-cell">{cellContent(date, weekDayIndex)}</div>)
    }
    const dateInfo = getDateInfo()
    return (
        <div className="ai-month">
            <div className="ai-month-body">
                {weekDays_layout()}
                <div className="ai-month-grid" style={{ gridTemplateColumns }}>{spaces_layout()} {cells_layout()}</div>
            </div>
        </div>
    )
}
const PrismCode: FC<{ code: string, language?: 'js' | 'css', style?: any }> = ({ code, language = 'js', style = {} }) => {
    useEffect(() => { Prism.highlightAll() }, [])
    return (
        <div className="aio-doc-code" style={style}>
            <pre style={{ height: '100%', overflow: 'auto' }}>
                <code className={`language-${language}`}>{code}</code>
            </pre>
        </div>
    );
}
export function Code(code: string, language?: 'js' | 'css', style?: any) {
    return <PrismCode code={code} language={language} style={style} />
}
export type I_node = {
    v?: I_node[], h?: I_node[], html?: ReactNode, content?: any, attrs?: any, className?: string, style?: any, show?: boolean,
    flex?: number, size?: number, scroll?: boolean, tag?: 'fieldset' | 'section' | 'div' | 'p' | 'form', legend?: ReactNode, id?: string, isStatic?: boolean,
    align?: 'v' | 'h' | 'vh' | 'hv', hide_xs?: boolean, hide_sm?: boolean, hide_md?: boolean, hide_lg?: boolean, show_xs?: boolean, show_sm?: boolean, show_md?: boolean, show_lg?: boolean
}
export const NodeAttrs = (p: { node: I_node, parentNode?: I_node, isRoot?: boolean }) => {
    const baseClassName = 'rvd'
    const NodeStyle = () => {
        const res: any = { flex: p.node.flex };
        if (p.parentNode && (p.parentNode.h || p.parentNode.v)) {
            res[p.parentNode.v ? 'height' : 'width'] = p.node.size
        }
        return { ...res, ...p.node.style }
    }
    function VisibilityClassNames(): string[] {
        let hide_xs, hide_sm, hide_md, hide_lg, classNames = [];
        if (p.node.show_xs) { hide_xs = false; hide_sm = true; hide_md = true; hide_lg = true; }
        if (p.node.hide_xs) { hide_xs = true; }
        if (p.node.show_sm) { hide_xs = true; hide_sm = false; hide_md = true; hide_lg = true; }
        if (p.node.hide_sm) { hide_sm = true; }
        if (p.node.show_md) { hide_xs = true; hide_sm = true; hide_md = false; hide_lg = true; }
        if (p.node.hide_md) { hide_md = true; }
        if (p.node.show_lg) { hide_xs = true; hide_sm = true; hide_md = true; hide_lg = false; }
        if (p.node.hide_lg) { hide_lg = true; }
        if (hide_xs) { classNames.push(`${baseClassName}-hide-xs`) }
        if (hide_sm) { classNames.push(`${baseClassName}-hide-sm`) }
        if (hide_md) { classNames.push(`${baseClassName}-hide-md`) }
        if (hide_lg) { classNames.push(`${baseClassName}-hide-lg`) }
        return classNames;
    }
    const NodeClassNames = (): (string | undefined)[] => {
        let nodeClassName, scrollClassName, alignClassName, rootClassName = p.isRoot ? baseClassName : undefined, visibilityClassNames = VisibilityClassNames();
        if (p.node.v) {
            nodeClassName = `${baseClassName}-v`
            scrollClassName = `${baseClassName}-scroll-v`
            if (p.node.align === 'v') { alignClassName = `${baseClassName}-justify-center` }
            else if (p.node.align === 'h') { alignClassName = `${baseClassName}-items-center` }
            else if (p.node.align === 'vh') { alignClassName = `${baseClassName}-justify-center ai-form-items-center` }
            else if (p.node.align === 'hv') { alignClassName = `${baseClassName}-justify-center ai-form-items-center` }
        }
        else if (p.node.h) {
            nodeClassName = `${baseClassName}-h`
            scrollClassName = `${baseClassName}-scroll-h`
            if (p.node.align === 'v') { alignClassName = `${baseClassName}-items-center` }
            else if (p.node.align === 'h') { alignClassName = `${baseClassName}-justify-center` }
            else if (p.node.align === 'vh') { alignClassName = `${baseClassName}-justify-center ai-form-items-center` }
            else if (p.node.align === 'hv') { alignClassName = `${baseClassName}-justify-center ai-form-items-center` }
        }
        else if (p.node.html) {
            nodeClassName = `${baseClassName}-html`
            if (p.node.align === 'v') { alignClassName = `${baseClassName}-items-center` }
            else if (p.node.align === 'h') { alignClassName = `${baseClassName}-justify-center` }
            else if (p.node.align === 'vh') { alignClassName = `${baseClassName}-justify-center ai-form-items-center` }
            else if (p.node.align === 'hv') { alignClassName = `${baseClassName}-justify-center ai-form-items-center` }
        }
        return [nodeClassName, rootClassName, p.node.className, scrollClassName, alignClassName, ...visibilityClassNames]
    }
    return AddToAttrs(p.node.attrs, { className: NodeClassNames(), style: NodeStyle() })
}
export const Node: FC<{
    node: I_node, parentNode?: I_node, level: number, index: number, updateNode?: (p: { node: I_node, level: number, parentNode?: I_node }) => I_node
}> = ({ node, level, index, parentNode, updateNode }) => {
    const [dom, setDom] = useState<ReactNode>(null)
    let { show = true, isStatic } = updateNode ? updateNode({ node, level, parentNode }) : node;
    const getContent = (): ReactNode => {
        if (!show) { return null }
        if (Array.isArray(node.h) || Array.isArray(node.v)) {
            return <NodeGroup node={node} level={level} index={index} parentNode={parentNode} />
        }
        if (node.html !== undefined) {
            const attrs = NodeAttrs({ node, isRoot: level === 0, parentNode })
            return (<div {...attrs}>{node.html}</div>)
        }
        return node.content
    }
    useEffect(() => {
        if (isStatic) { setDom(getContent()) }
    }, [isStatic])
    return isStatic ? <>{dom}</> : <>{getContent()}</>
}
const NodeGroup: FC<{
    node: I_node, parentNode?: I_node, level: number, index: number
}> = ({ node, level, parentNode }) => {
    let { tag = 'div', legend } = node;
    const content = (<>
        {!!legend && tag === 'fieldset' && <legend>{legend}</legend>}
        {
            (node as any)[node.v ? 'v' : 'h'].map((o: I_node, i: number) => {
                return (
                    <Node
                        node={o} parentNode={node}
                        key={`level-${level + 1}-index-${i}`}
                        level={level + 1} index={i}
                    />
                )
            })
        }
    </>)
    const attrs = NodeAttrs({ node, isRoot: level === 0, parentNode })
    if (level === 0) { return (<form {...attrs}>{content}</form>) }
    if (tag === 'section') { return (<section {...attrs}>{content}</section>) }
    if (tag === 'fieldset') { return (<fieldset {...attrs}>{content}</fieldset>) }
    if (tag === 'p') { return (<p {...attrs}>{content}</p>) }
    if (tag === 'form') { return (<p {...attrs}>{content}</p>) }
    return (<div {...attrs}>{content}</div>)
}
export function DragList<T>({ data, onChange, renderItem, listAttrs }: {
    data: T[]; listAttrs?: any, onChange: (newList: T[]) => void;
    renderItem: (item: T, index: number) => { inner: React.ReactNode; attrs: any };
}) {
    const [internalData, setInternalData] = useState(data);
    const containerRef = useRef<HTMLDivElement>(null);
    const { getDragAttrs, getDropAttrs } = useDrag(
        (drag, drop, reOrder) => {
            const fromIndex = drag.index;
            const toIndex = drop.index;
            const updated = reOrder(internalData, fromIndex, toIndex);
            setInternalData(updated);
            onChange(updated);
        },
        ''
    );
    return (
        <div {...listAttrs} ref={containerRef}>
            {internalData.map((item, index) => {
                const dragAttrs = getDragAttrs({ index });
                const dropAttrs = getDropAttrs({ index });
                const { inner, attrs } = renderItem(item, index);
                const Attrs = { ...attrs, ...dragAttrs, ...dropAttrs };
                return (<div key={index} {...Attrs}>{inner}</div>);
            })}
        </div>
    );
}

export const AIOSwiper: FC<{
    options: any[],
    selectedIndex?: number,
    changeSelectedIndex?: (index: number) => void,
    option: {
        text?: (option: any, index: number) => ReactNode,
        className?: (option: any, index: number) => string | undefined,
        style?: (option: any, index: number) => any,
        attrs?: (option: any, index: number) => any,
        onClick?: (option: any, index: number, e: any) => void,
    },
    className?: string,
    style?: any,
    attrs?: any,
    id?: string,
    showDots?: boolean,
    autoTime?: number,
    duration?: number,
    easing?: number
}> = (props) => {
    const ref = useRef<any>(createRef<HTMLDivElement>());
    const optionsRef = useRef<any[]>(props.options)
    optionsRef.current = props.options
    const leftRef = useRef<number>(0);
    const [selectedIndex, setSelectedIndex] = useState<number>(props.selectedIndex || 0);
    const selectedIndexRef = useRef<number>(selectedIndex);
    selectedIndexRef.current = selectedIndex;
    const mousedownIndexRef = useRef<number>(selectedIndexRef.current);
    const widthRef = useRef<number>(0);
    const isMovingRef = useRef<boolean>(false)
    const lastReportedIndexRef = useRef<number | undefined>(undefined)
    const getLeft = () => leftRef.current;
    const setLeft = (left: number) => leftRef.current = left
    const getIndexByLeft = (left: number) => {
        const options = optionsRef.current;
        let index = Math.abs(Math.round(left / widthRef.current))
        if (index > options.length - 1) { index = options.length - 1 }
        if (index < 0) { index = 0 }
        return index
    }
    const nextIndex = () => {
        let fromIndex = selectedIndexRef.current, toIndex = fromIndex + 1
        if (toIndex > props.options.length - 1) { toIndex = 0 }
        const from = getLeftByIndex(fromIndex);
        const to = getLeftByIndex(toIndex);
        transition(from, to)
    }
    useEffect(() => { if (props.autoTime) { setInterval(() => nextIndex(), props.autoTime) } }, [])
    const getLeftByIndex = (index?: number): number => {
        const width = widthRef.current
        const length = optionsRef.current.length;
        const max = 0;
        const min = (length - 1) * width * -1
        let left: number = (index || 0) * width * -1
        if (left > max) { left = max }
        if (left < min) { left = min }
        return left
    }
    useEffect(() => {
        if (props.selectedIndex !== undefined) {
            transition(getLeft(), getLeftByIndex(props.selectedIndex))
        }
    }, [props.selectedIndex])
    const getWidth = () => $(ref.current).width() || 0
    useResize(ref, () => {
        widthRef.current = getWidth();
        changeLeft(getLeftByIndex(selectedIndexRef.current))
    })
    const transition = (from: number, to: number) => {
        const obj = { v: from }
        const { easing = 13 } = props
        anime({
            v: to, targets: obj, duration: props.duration || 200,
            easing: [
                'linear', 'easeInQuad', 'easeInCubic', 'easeInQuart', 'easeInQuint', 'easeInSine', 'easeInExpo', 'easeInCirc', 'easeInBack', 'easeOutQuad', 'easeOutCubic', 'easeOutQuart', 'easeOutQuint', 'easeOutSine', 'easeOutExpo',
                'easeOutCirc', 'easeOutBack', 'easeInBounce', 'easeInOutQuad', 'easeInOutCubic', 'easeInOutQuart', 'easeInOutQuint', 'easeInOutSine', 'easeInOutExpo', 'easeInOutCirc', 'easeInOutBack', 'easeInOutBounce',
                'easeOutBounce', 'easeOutInQuad', 'easeOutInCubic', 'easeOutInQuart', 'easeOutInQuint', 'easeOutInSine', 'easeOutInExpo', 'easeOutInCirc', 'easeOutInBack', 'easeOutInBounce'
            ][easing],
            update: (p: any) => changeLeft(p.animatables[0].target.v)
        });
    }
    const changeLeft = (newLeft: number) => {
        setLeft(newLeft);
        const index = getIndexByLeft(newLeft)
        if (index !== lastReportedIndexRef.current) {
            lastReportedIndexRef.current = index;
            setSelectedIndex(index);
            if (props.changeSelectedIndex) { props.changeSelectedIndex(index) }
        }
        $(ref.current).find('.swiper-items').css('transform', `translateX(${newLeft}px)`);
    }
    const getLimit = () => {
        const options = optionsRef.current
        const min = (options.length - 1) * -widthRef.current
        const max = 0;
        const dragMin = min - widthRef.current / 2
        const dragMax = max + widthRef.current / 2
        return { min, max, dragMin, dragMax }
    }
    useEffect(() => { widthRef.current = getWidth(); }, [])
    useEffect(() => {
        new Swip({
            dom: () => $(ref.current).find('.swiper-items'),
            start: () => {
                mousedownIndexRef.current = selectedIndexRef.current
                return [getLeft(), 0]
            },
            move: (p) => {
                let { dragMax, dragMin } = getLimit();
                let newLeft = p.change.x
                const isMoving = Math.abs(p.change.dx) > 5
                isMovingRef.current = isMoving
                if (newLeft < dragMin) { newLeft = dragMin; }
                else if (newLeft > dragMax) { newLeft = dragMax; }
                setLeft(newLeft)
                $(ref.current).find('.swiper-items').css('transform', `translateX(${newLeft}px)`);
            },
            end: (p) => {
                setTimeout(() => isMovingRef.current = false, 5)
                const dx = p.change.dx
                const dir = Math.sign(dx);
                let newIndex = mousedownIndexRef.current;
                if (Math.abs(dx) > widthRef.current / 6) { newIndex = newIndex - dir }
                if (newIndex < 0) { newIndex = 0; }
                else if (newIndex > props.options.length - 1) { newIndex = props.options.length - 1; }
                transition(getLeft(), getLeftByIndex(newIndex))
            }
        })
    }, [ref]);
    const getValueByOption = (o: any, index: number, key: 'text' | 'className' | 'style' | 'attrs', def?: any) => {
        const fn = props.option[key] || (() => def)
        const value = fn(o, index);
        return value === undefined ? def : value
    }
    const getOptionDetails = (o: any, index: number) => {
        const text = getValueByOption(o, index, 'text', o)
        const className = getValueByOption(o, index, 'className')
        const style = getValueByOption(o, index, 'style')
        const attrs = getValueByOption(o, index, 'attrs')
        const Attrs = AddToAttrs(attrs, { className: ['swiper-item', className], style })
        return { text, attrs: Attrs }
    }
    const optionClick = (option: any, index: number, e: any) => { if (!isMovingRef.current && props.option.onClick) { props.option.onClick(option, index, e) } }
    const attrs = AddToAttrs(props.attrs, { className: ['swiper', props.className], style: props.style, attrs: { ref } })
    return (
        <div {...attrs}>
            <div className="swiper-items" draggable={false}>
                {
                    optionsRef.current.map((item, index) => {
                        const { text, attrs } = getOptionDetails(item, index)
                        return (<div key={index} {...attrs} onClick={(e) => optionClick(item, index, e)}>{text}</div>)
                    })
                }
            </div>
            {props.showDots !== false && <Dots onChange={(index) => transition(getLeft(), getLeftByIndex(index))} length={optionsRef.current.length} value={selectedIndexRef.current} />}
        </div>
    )
}
export const Dots: FC<{ value: number, length: number, onChange: (index: number) => void, attrs?: any, className?: string, style?: any }> = ({ value, length, onChange, attrs, className, style }) => {
    const Attrs = AddToAttrs(attrs, { className: ['swiper-dots', className], style, attrs: { draggable: false } })
    return (
        <div {...Attrs}>
            {GetArray(length).map((o) => {
                return <div onClick={(e) => { e.stopPropagation(); onChange(o) }} className={`swiper-dot${o === value ? ' swiper-dot-active' : ''}`}></div>
            })}
        </div>
    )
}

type I_emojiPackKey = 'arrowUp' | 'arrowDown' | 'arrowLeft' | 'arrowRight' | 'arrowDownRight' | 'arrowUpLeft' | 'arrowDownLeft' | 'arrowLeftRight' | 'arrowUpDown' | 'back' | 'banned' | 'bell' | 'bookmark' | 'calendar' | 'check' | 'checkbox' | 'closebox' | 'close' | 'cool' | 'delete' | 'edit' | 'eject' | 'end' | 'error' | 'fire' | 'forbidden' | 'forward' | 'idea' | 'info' | 'key' | 'lock_with_key' | 'locked' | 'mute' | 'new' | 'ok' | 'on' | 'pause' | 'play' | 'playPause' | 'record' | 'reload' | 'repeat' | 'repeatPne' | 'restricted' | 'rewind' | 'save' | 'search' | 'settings' | 'shield' | 'shuffle' | 'star' | 'stop' | 'stopbox' | 'soon' | 'speaker' | 'success' | 'target' | 'top' | 'unlocked' | 'up' | 'vs' | 'warning'
export const emojiPack: { [key in I_emojiPackKey]: any } = {
    arrowUp: "⬆️",
    arrowDown: "⬇️",
    arrowLeft: "⬅️",
    arrowRight: "➡️",
    arrowDownRight: "↘️",
    arrowUpLeft: "↖️",
    arrowDownLeft: "↙️",
    arrowLeftRight: "↔️",
    arrowUpDown: "↕️",
    back: "🔙",
    banned: "🚫",
    bell: "🔔",
    bookmark: "🔖",
    calendar: "📅",
    check: "✔️",
    checkbox: "☑️",
    closebox: "❎",
    close: "✖️",
    cool: "🆒",
    delete: "🗑️",
    edit: "✏️",
    eject: "⏏️",
    end: "🔚",
    error: "❌",
    fire: "🔥",
    forbidden: "⛔",
    forward: "⏩",
    idea: "💡",
    info: "ℹ️",
    key: "🔑",
    lock_with_key: "🔐",
    locked: "🔒",
    mute: "🔇",
    new: "🆕",
    ok: "🆗",
    on: "🔛",
    pause: "⏸️",
    play: "▶️",
    playPause: "⏯️",
    record: "⏺️",
    reload: "🔄",
    repeat: "🔁",
    repeatPne: "🔂",
    restricted: "🔞",
    rewind: "⏪",
    save: "💾",
    search: "🔍",
    settings: "⚙️",
    shield: "🛡️",
    shuffle: "🔀",
    star: "⭐",
    stop: "🛑",
    stopbox: "⏹️",
    soon: "🔜",
    speaker: "🔊",
    success: "✅",
    target: "🎯",
    top: "🔝",
    unlocked: "🔓",
    up: "🆙",
    vs: "🆚",
    warning: "⚠️"
};

export function PriceToText(num: number) {
    if (num === 0) return "صفر";

    const yekan = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
    const dahgan = ["", "ده", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"];
    const sadgan = ["", "یکصد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"];
    const dahYek = ["ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"];

    const parts = [];

    function convertThreeDigits(n: number) {
        let str = "";
        const sad = Math.floor(n / 100);
        const dah = Math.floor((n % 100) / 10);
        const yek = n % 10;

        if (sad) str += sadgan[sad];

        if (dah === 1) {
            str += (str ? " و " : "") + dahYek[yek];
        } else {
            if (dah) str += (str ? " و " : "") + dahgan[dah];
            if (yek) str += (str ? " و " : "") + yekan[yek];
        }
        return str;
    }

    const units = ["", "هزار", "میلیون", "میلیارد", "تریلیون"];
    let i = 0;

    while (num > 0) {
        const chunk = num % 1000;
        if (chunk) {
            const chunkText = convertThreeDigits(chunk);
            parts.unshift(chunkText + (units[i] ? " " + units[i] : ""));
        }
        num = Math.floor(num / 1000);
        i++;
    }

    return parts.join(" و ");
}
export const Append = (p: { id: string, html: ReactNode, containerSelector: string }) => {
    const { containerSelector, id, html = null } = p;
    if (!$(`#${id}`).length) { $(containerSelector).append(`<div id="${id}"></div>`) }
    const root = ReactDOM.createRoot(document.getElementById(id) as HTMLElement);
    root.render(html);
}


export const GenerateId = <T extends string | number>(type: 'string' | 'number'): T => {
    const num: number = GetRandomNumber(10000000, 99999999);
    return (type === 'string' ? ('id' + num) : num) as any
}

type I_DragAndDrop<T> = {
    data: T[];
    getContent: (row: T, p: { index: number; id: any; dragging?: boolean }) => ReactNode;
    getId: (row: T, p: { index: number }) => any;
    onChange: (newData: T[], fromIndex: number, toIndex: number) => void;
    direction?: "vertical" | "horizontal";
    handle?: string;
};

export const DragAndDrop = <T,>({ data, getContent, getId, onChange, direction = "vertical", handle }: I_DragAndDrop<T>) => {
    const listRef = useRef<HTMLDivElement>(null);
    const dataRef = useRef<T[]>(data);
    dataRef.current = data;
    useEffect(() => {
        if (!listRef.current) return;
        const sortable = new Sortable(listRef.current, {
            animation: 150,
            handle,
            direction: direction === "vertical" ? "vertical" : "horizontal",
            onEnd: (evt: any) => {
                const { oldIndex, newIndex } = evt;
                if (oldIndex != null && newIndex != null && oldIndex !== newIndex) {
                    const newData = [...dataRef.current];
                    const [moved] = newData.splice(oldIndex, 1);
                    newData.splice(newIndex, 0, moved);
                    onChange(newData, oldIndex, newIndex);
                }
            },
            ghostClass: "dragging-ghost",
        });
        return () => { sortable.destroy(); };
    }, [direction, onChange]);

    return (
        <div ref={listRef} style={{ display: direction === "vertical" ? "block" : "flex", gap: "8px" }}>
            {dataRef.current.map((row, index) => {
                const id = getId(row, { index });
                return (<div key={id} data-id={id} style={{ cursor: "grab", userSelect: "none" }}>{getContent(row, { index, id })}</div>);
            })}
        </div>
    );
};


export const useDataFilter = <F, D,>(p: {
    key?: string,
    initialFilter: F,
    initialData: D,
    fetchData: (filter: F) => Promise<D>
}) => {
    const [filter, setFilter] = useState<F>(getFilter)
    function getFilter() {
        if (p.key) {
            const storage = new Storage(p.key + '_filters');
            return storage.load('filter', p.initialFilter)
        }
        else { return p.initialFilter }
    }
    const [data, setData] = useState<D>(p.initialData)
    const fetchData = async (newFilter?: F) => {
        const res = await p.fetchData(newFilter || filter);
        if (res) { setData(res) }
    }
    const saveFilterInStorage = (filter: F) => {
        const storage = new Storage(p.key + '_filters');
        storage.save('filter', filter)
    }
    const changeFilter = async (p: { [key in keyof F]?: any }) => {
        const newFilter = { ...filter, ...p }
        saveFilterInStorage(newFilter)
        await fetchData(newFilter)
        setFilter(newFilter);
    }
    const changeData = (data: D) => {
        setData(data)
    }
    useEffect(() => { fetchData() }, [])
    return { changeFilter, filter, data, changeData }
}


const singletons = new Map<string, any>();

export function getSingleton<T>(
    key: string,
    factory: () => T
): T {
    if (!singletons.has(key)) {
        singletons.set(key, factory());
    }
    return singletons.get(key);
}
export type I_sentinelFetchItems<T> = (info: { pageNumber: number, pageSize: number, fromIndex: number, toIndex: number }) => Promise<{ items: T[], hasMore: boolean } | false>
export function useInfiniteData<T>(p: {
    loader?: ReactNode,
    pageSize: number,
    fetchItems: I_sentinelFetchItems<T>,
    onChange?: (v: T[], fromIndex: number, toIndex: number) => void
}
): { sentinel: ReactNode, loading: boolean, pageNumber: number, pageSize: number, fromIndex: number, toIndex: number, items: T[] } {
    const { fetchItems, loader = <p style={{ textAlign: "center" }}>⏳ در حال لود...</p>, pageSize, onChange } = p
    const [items, setItems] = useState<T[]>([])
    const [hasMore, setHasMore] = useState<boolean>(true)
    const sentinelRef = useRef<HTMLDivElement | null>(null);
    const loadingRef = useRef(false);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const fromIndex = (pageNumber - 1) * pageSize;
    const toIndex = fromIndex + pageSize;
    useEffect(() => {
        if (!hasMore) return;
        const sentinel = sentinelRef.current;
        if (!sentinel) return;
        const observer = new IntersectionObserver(async (entries) => {
            if (entries[0].isIntersecting && !loadingRef.current) {
                loadingRef.current = true;
                setLoading(true);
                // try {
                //     const success = await callback({ pageNumber, pageSize, fromIndex, toIndex });
                //     if (success) { setPageNumber(prev => prev + 1); }
                // }
                // finally { setLoading(false); loadingRef.current = false; }
                try {
                    const res = await fetchItems({ pageNumber, pageSize, fromIndex, toIndex });
                    if (res) {
                        const { hasMore, items } = res
                        setPageNumber(prev => prev + 1);
                        setItems((prev) => {
                            const newItems = [...prev, ...items]
                            if (onChange) { onChange(newItems, fromIndex, toIndex) }
                            return newItems
                        });
                        setHasMore(hasMore)
                    }
                }
                finally { setLoading(false); loadingRef.current = false; }
            }
        }, { root: null, rootMargin: '50px', threshold: 0.1 });
        observer.observe(sentinel);
        return () => observer.disconnect();
    }, [hasMore, pageNumber, pageSize]);
    return {
        loading, pageNumber, pageSize, fromIndex, toIndex, items,
        sentinel: (<>{!!loading && loader}<div ref={sentinelRef} style={{ height: 4 }} /></>),
    };
}
export type I_logItem = {
    tags?: string[],
    id?: string,
    message: string,
    status?: 'error' | 'success' | 'warning' | 'info',
    data?: any,
    date?: number
}
const LogsContext = createContext<{ logsHook: ReturnType<typeof useLogs> }>({} as any)
export const LogsProvider: FC<{ children: ReactNode, initialLogs?: I_logItem[], storageKey: string }> = ({ children, initialLogs, storageKey }) => {
    const logsHook = useLogs(storageKey, initialLogs)
    return <LogsContext.Provider value={{ logsHook }}>{children}</LogsContext.Provider>
}
export const useLogsProvider = () => useContext(LogsContext)
export const useLogs = (key: string, initialLogs?: I_logItem[]) => {
    const storage = new Storage(key)
    const [logs, setLogs] = useState<I_logItem[]>(storage.load('logs', [], new Date().getTime() + 3 * 60 * 60 * 1000))
    useEffect(() => { if (initialLogs) { add(initialLogs) } }, [])
    const ref = useRef<I_logItem[]>(logs)
    ref.current = logs;
    const changeLogs = (logs: I_logItem[]) => {
        storage.save('logs', logs, new Date().getTime() + 3 * 60 * 60 * 1000)
        setLogs(logs)
    }
    const getMessage = (message: string) => {
        if (message.length > 100) {
            const start = message.slice(0, 50)
            const end = message.slice(51, 100)
            return `${start} ... ${end}`
        }
        return message
    }
    const add = (logItems: I_logItem[]) => {
        const DATE = new AIODate();
        const logs = ref.current
        let newLogs = [...logs, ...logItems.map((o) => ({ ...o, date: DATE.getTime(DATE.getToday()) }))];
        newLogs = newLogs.reverse()
        const dic: any = {}
        const res: I_logItem[] = []
        for (let i = 0; i < newLogs.length; i++) {
            const log = newLogs[i];
            if (log.id) {
                dic[log.id] = dic[log.id] || []
                if (dic[log.id].length < 3) { res.push({ ...log, message: getMessage(log.message) }) }
                dic[log.id].push(log.id)
            }
            else {
                res.push({ ...log, message: getMessage(log.message) })
            }
        }
        changeLogs(res.reverse())
    }
    const remove = (index: number) => changeLogs(ref.current.filter((_, i) => i !== index))
    const open = () => {
        Append({
            containerSelector: 'body',
            id: 'aio-apis-logs-container',
            html: <LogsModal logs={ref.current} remove={(index: number) => remove(index)} />
        })
    }
    const clear = () => changeLogs([])
    return { logs, remove, add, open, clear }
}
const LogsModal: FC<{ remove: ReturnType<typeof useLogs>["remove"], logs: I_logItem[] }> = ({ remove, logs }) => {
    return (
        <div className="aio-apis-logs" style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', position: 'fixed', left: 0, top: 0, background: '#fff', direction: 'ltr' }}>
            <div className="aio-apis-logs-header" style={{ padding: 12, display: 'flex', gap: 12 }}>
                <div className="msf" style={{ flex: 1 }}></div>
                <button className='aio-apis-logs-close' style={{ width: 72, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }} onClick={()=>{}}>Close</button>
            </div>
            <div className='aio-apis-logs-items' style={{ padding: 12, flex: 1, overflowY: 'auto', gap: 12, display: 'flex', flexDirection: 'column' }}>
                {logs.map((log, i) => <LogItem key={i} log={log} onRemove={() => remove(i)} />)}
            </div>

        </div>
    )
}
const LogItem: FC<{ log: I_logItem, onRemove: () => void }> = ({ log, onRemove }) => {
    const DATE = new AIODate();
    const getColor = (status?: 'error' | 'success' | 'warning' | 'info') => {
        if (status === 'success') { return 'green' }
        if (status === 'error') { return 'red' }
        if (status === 'warning') { return 'orange' }
        if (status === 'info') { return '#0069ff' }
        return '#666'

    }
    return (
        <div style={{ border: `3px solid ${getColor(log.status)}`, padding: 12, borderRadius: 6, display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div style={{ flex: 1 }}>{(log.tags || []).toString()}</div>
                <div style={{ width: 24, height: 24 }} onClick={() => onRemove()}>
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                    </svg>
                </div>
            </div>
            {!!log.message && log.message}
            {!!log.date && <div>{DATE.getDateByPattern(log.date, '{weekDay} {day} {monthString} {year} ساعت {hour} و {minute} دقیقه', true)}</div>}
            {!!log.id && <div>{log.id}</div>}
            {!!log.data && <>{Code(JSON.stringify(log.data, null, 4))}</>}
        </div>
    )
}

type I_keyboardLang = 'en' | 'fa'
type I_KeyboardContext = {
    state: I_keyboardState, theme: I_keyboardTheme, config: I_keyboardConfig, isTouch: boolean,
    keyDown: (key: I_keyboardKey) => void,
    changeState: (obj: Partial<I_keyboardState>) => void,
    getChar: (key: I_keyboardKey) => string | undefined
    getHotKey: (key: I_keyboardKey) => string | undefined
}
const KeyboardContext = createContext<I_KeyboardContext>({} as any)
const KeyboardProvider: FC<{ children: ReactNode, value: I_KeyboardContext }> = ({ children, value }) => {
    return <KeyboardContext.Provider value={value}>{children}</KeyboardContext.Provider>
}
const useKeyboardProvider = () => useContext(KeyboardContext)
type I_keyboardConfig = {
    gap?: number, keyHeight?: number, title?: string
}
type I_keyboardState = {
    caps: boolean, sym: boolean, init: boolean, value: string, lang: I_keyboardLang, hotKeyMode: boolean, keyDownObject?: I_keyboardKey
}
type I_keyboardKey = {
    text: ReactNode,
    sym?: string,
    caps?: string,
    id?: string,
    flex?: number,
    hotKey?: 'caps' | 'sym',
    isChar?: boolean,
    langs?: { [key in I_keyboardLang]?: Partial<I_keyboardKey> }
}
type I_keyboardTheme = {
    background: string, keyColor: string, keyActiveColor: string, keyBackground: string, screenBackground: string, screenColor: string,
    titleColor: string, highlight: string, keyBoxShadow?: string,
}

export const useKeyboard = (props: { config?: I_keyboardConfig, containerSelector: string }) => {
    const open = (p: { onSubmit: (v: string) => void, lang?: I_keyboardLang, value?: string }) => {
        Append({
            containerSelector: props.containerSelector,
            id: 'keyboard',
            html: (
                <Keyboard
                    config={props.config || {}}
                    lang={p.lang || 'en'}
                    onSubmit={p.onSubmit}
                    value={p.value}
                />
            )
        })
    }
    return { open }
}
const Keyboard: FC<{
    value?: string,
    onSubmit: (v: string) => void,
    theme?: Partial<I_keyboardTheme>,
    config: I_keyboardConfig,
    style?: any,
    backdropAttrs?: any,
    lang: I_keyboardLang
}> = (p) => {
    const [state, setState] = useState<I_keyboardState>(getState)
    function getState(): I_keyboardState {
        console.log('initial')
        return {
            caps: false, sym: false, init: true, value: p.value || '', lang: 'en', hotKeyMode: false, keyDownObject: undefined
        }
    }
    const stateRef = useRef<I_keyboardState>(state)
    stateRef.current = state
    const changeState = (obj: Partial<I_keyboardState>) => {
        const newState = { ...stateRef.current, ...obj }
        setState(newState)
    }
    const [theme] = useState<I_keyboardTheme>(getTheme)
    function getTheme() {
        return {
            background: '#c9ced4', keyColor: '#28292b', keyActiveColor: '#1d5ee4', keyBackground: '#fff', screenBackground: '#eee', screenColor: '#666',
            titleColor: '#000', highlight: '#7fb9ef', keyBoxShadow: undefined,
            ...p.theme
        }
    }
    const timeoutRef = useRef<any>(undefined)
    const isTouchRef = useRef<boolean>('ontouchstart' in document.documentElement)
    const hotKeyModeRef = useRef<boolean>(false)
    const isTouch = isTouchRef.current;
    const getChar = (key: I_keyboardKey) => {
        let fixedKey = key
        if (state.lang !== 'en') {
            if (key.langs && key.langs[state.lang]) {
                fixedKey = { ...fixedKey, ...key.langs[state.lang] }
            }
        }
        if (hotKeyModeRef.current && fixedKey.hotKey) { return fixedKey[fixedKey.hotKey]; }
        if (state.sym && fixedKey.sym) { return fixedKey.sym; }
        if (state.caps && fixedKey.caps) { return fixedKey.caps; }
        if (fixedKey.isChar !== false && typeof fixedKey.text === 'string') { return fixedKey.text }
    }
    const getHotKey = (key: I_keyboardKey) => {
        let fixedKey = key
        if (state.lang !== 'en') {
            if (key.langs && key.langs[state.lang]) {
                fixedKey = { ...fixedKey, ...key.langs[state.lang] }
            }
        }
        if (fixedKey.hotKey) { return fixedKey[fixedKey.hotKey] }
    }
    const keyUp = () => {
        const state = stateRef.current;
        if (!state.keyDownObject) { return }
        const key = state.keyDownObject
        let newState = { ...state }
        clearTimeout(timeoutRef.current)
        $(window).unbind(isTouch ? 'touchend' : 'mouseup', keyUp);
        if (key.id === 'caps') { newState = { ...newState, caps: !state.caps } }
        else if (key.id === 'backspace') {
            if (state.init) { newState = { ...newState, value: '' } }
            else if (state.value.length > 0) { newState = { ...newState, value: state.value.slice(0, state.value.length - 1) } }
        }
        else if (key.id === 'sym') { newState = { ...newState, sym: !state.sym } }
        else if (key.id === 'space') {
            if (state.init) { newState = { ...newState, value: '' } }
            else if (state.value.length > 0 && state.value[state.value.length - 1] !== ' ') {
                newState = { ...newState, value: state.value + ' ' };
            }
        }
        else if (key.id === 'enter') { p.onSubmit(state.value); newState = { ...newState, value: '' }; }
        else {
            const char = getChar(key)
            if (!char) { return }
            let newValue = newState.value
            if (state.init) { newValue = char }
            else { newValue += char }
            hotKeyModeRef.current = false
            newState = { ...newState, hotKeyMode: false, value: newValue }
        }
        newState = { ...newState, keyDownObject: undefined, init: key.id === 'inter' }
        changeState(newState)
    }
    const keyDown = (key: I_keyboardKey) => {
        $(window).bind(isTouch ? 'touchend' : 'mouseup', $.proxy(keyUp, this));
        changeState({ keyDownObject: key })
        timeoutRef.current = setTimeout(() => {
            hotKeyModeRef.current = true
            changeState({ hotKeyMode: true })
            keyUp()
        }, 600)
    }
    const getStyle = () => {
        const { style = {} } = p;
        var { background } = theme;
        return { background, direction: 'ltr', ...style };
    }
    console.log(state)
    const dic = getDic(theme, state);
    return (
        <KeyboardProvider value={{ state, keyDown, theme, config: p.config, isTouch, changeState, getChar, getHotKey }}>
            <div className={"keyboard" + (state.caps ? ' caps' : '')} style={getStyle()}>
                <div {...p.backdropAttrs}></div>
                <KeyboardTitle />
                <KeyboardHeader />
                {
                    dic.map((row, i) => {
                        return <KeyboardRow key={i} row={row} index={i} />
                    })
                }
            </div>
        </KeyboardProvider>
    );
}
const KeyboardTitle: FC = () => {
    const { theme, config, changeState, state } = useKeyboardProvider();
    const { keyHeight = 36, title = '' } = config
    const getStyle = () => ({ height: keyHeight + 'px', color: theme.titleColor })
    return (
        <div className='keyboard-title' style={getStyle()}>
            <span>{title}</span>
            <svg onClick={() => changeState({ lang: state.lang === 'en' ? 'fa' : 'en' })} style={{ width: "24px", height: "24px", background: "#000000" }} width={24} height={24}>
                <path fill="transparent" stroke="#ffffff" d="M5 20 L12 3 L19 20" strokeLinejoin="round" strokeLinecap="round" strokeWidth={3}></path>
                <path fill="transparent" stroke="#ffffff" d="M8 14 L16 14" strokeLinejoin="round" strokeLinecap="round" strokeWidth={3}></path>
            </svg>
        </div>
    );
}
const KeyboardHeader: FC = () => {
    const { theme, config, isTouch, state, changeState } = useKeyboardProvider();
    const { keyHeight = 36, gap = 2 } = config
    const getLCDStyle = () => {
        var { screenBackground } = theme;
        return {
            background: screenBackground,
            minHeight: (keyHeight - 2 * gap) + 'px',
            maxHeight: (keyHeight * 3) + 'px',
        }
    }
    const { highlight, screenColor } = theme;
    const lcdProps = {
        className: 'keyboard-lcd', style: getLCDStyle(),
        [isTouch ? 'onTouchStart' : 'onMouseDown']: () => changeState({ init: !state.init })
    };
    const markProps = {
        style: {
            background: state.init ? highlight : 'none',
            color: state.init ? '#fff' : screenColor
        }
    }

    return (
        <div className='keyboard-header'>
            <div {...lcdProps}>
                <mark {...markProps}>{state.value}</mark>
            </div>
        </div>
    );
}
const KeyboardRow: FC<{ row: I_row, index: number }> = ({ row, index }) => {
    const keys = row.items.map((item, i) => <KeyboardKey key={index + '/' + i} item={item} />);
    return (
        <div key={index} className='keyboard-row' style={row.style}>
            {keys}
        </div>
    );
}
const KeyboardKey: FC<{ item: I_keyboardKey }> = ({ item }) => {
    const { config, theme, state, keyDown, getChar, isTouch, getHotKey } = useKeyboardProvider();
    const { keyHeight = 36, gap = 2 } = config
    const getColor = () => {
        var { keyColor, keyActiveColor } = theme;
        if (item.id === 'sym') { return state.sym ? keyActiveColor : keyColor; }
        else { return keyColor; }
    }
    const getStyle = () => {
        const { flex = 1 } = item;
        return { height: keyHeight + 'px', flex, padding: gap + 'px', }
    }
    const getKeyStyle = (shadow?: boolean) => {
        var { keyBackground, keyColor, keyBoxShadow } = theme;
        return {
            color: shadow ? keyBackground : getColor(),
            background: shadow ? keyColor : keyBackground,
            boxShadow: keyBoxShadow,
        }
    }
    const containerProps = {
        className: "key-container", style: getStyle(),
        [isTouch ? 'onTouchStart' : 'onMouseDown']: () => keyDown(item)
    };
    const keyProps = { className: 'keyboard-key', id: item.id, style: getKeyStyle() };
    const hotKey = getHotKey(item);
    return (
        <div {...containerProps}>
            <div {...keyProps}>
                {!!hotKey && !state.sym && <span>{hotKey}</span>}
                {getChar(item) || item.text}
                {
                    !!state.keyDownObject && state.keyDownObject.id === item.id && state.keyDownObject.isChar !== false &&
                    <div className='keyboard-key key-shadow' style={getKeyStyle(true)}>{getChar(item)}</div>
                }
            </div>
        </div>
    );
}
type I_row = {
    items: I_keyboardKey[],
    style?: any
}
function getDic(theme: I_keyboardTheme, state: I_keyboardState) {
    const { keyColor, keyBackground, keyActiveColor } = theme;
    var capsColor = state.caps ? keyActiveColor : keyColor;

    const dic: I_row[] = [
        {
            items: [
                { id: '1', text: '1', sym: '{', hotKey: 'sym' },
                { id: '2', text: '2', sym: '}', hotKey: 'sym' },
                { id: '3', text: '3', sym: '|', hotKey: 'sym' },
                { id: '4', text: '4', sym: '[', hotKey: 'sym' },
                { id: '5', text: '5', sym: ']', hotKey: 'sym' },
                { id: '6', text: '6', sym: '\\', hotKey: 'sym' },
                { id: '7', text: '7', sym: '<', hotKey: 'sym' },
                { id: '8', text: '8', sym: '>', hotKey: 'sym' },
                { id: '9', text: '9', sym: '-', hotKey: 'sym' },
                { id: '0', text: '0', sym: '+', hotKey: 'sym' },
            ]
        },

        {
            items: [
                { id: 'q', text: 'q', caps: 'Q', sym: '+', hotKey: 'caps', langs: { fa: { text: 'ص', caps: 'ض', hotKey: 'caps' } } },
                { id: 'w', text: 'w', caps: 'W', sym: '`', hotKey: 'caps', langs: { fa: { text: 'ث', hotKey: undefined } } },
                { id: 'e', text: 'e', caps: 'E', sym: '÷', hotKey: 'caps', langs: { fa: { text: 'ق', hotKey: undefined } } },
                { id: 'r', text: 'r', caps: 'R', sym: '=', hotKey: 'caps', langs: { fa: { text: 'ف', hotKey: undefined } } },
                { id: 't', text: 't', caps: 'T', sym: '/', hotKey: 'caps', langs: { fa: { text: 'ع', caps: 'غ', hotKey: 'caps' } } },
                { id: 'y', text: 'y', caps: 'Y', sym: '_', hotKey: 'caps', langs: { fa: { text: 'ه', hotKey: undefined } } },
                { id: 'u', text: 'u', caps: 'U', sym: '€', hotKey: 'caps', langs: { fa: { text: 'خ', hotKey: undefined } } },
                { id: 'i', text: 'i', caps: 'I', sym: '£', hotKey: 'caps', langs: { fa: { text: 'ح', hotKey: undefined } } },
                { id: 'o', text: 'o', caps: 'O', sym: '¥', hotKey: 'caps', langs: { fa: { text: 'ج', hotKey: undefined } } },
                { id: 'p', text: 'p', caps: 'P', sym: '*', hotKey: 'caps', langs: { fa: { text: 'چ', hotKey: undefined } } },
            ]
        },
        {
            style: { padding: '0 5%' },
            items: [
                { id: 'a', text: 'a', caps: 'A', sym: '!', hotKey: 'caps', langs: { fa: { text: 'ش', hotKey: undefined } } },
                { id: 's', text: 's', caps: 'S', sym: '@', hotKey: 'caps', langs: { fa: { text: 'س', hotKey: undefined } } },
                { id: 'd', text: 'd', caps: 'D', sym: '#', hotKey: 'caps', langs: { fa: { text: 'ی', caps: 'ئ', hotKey: 'caps' } } },
                { id: 'f', text: 'f', caps: 'F', sym: '$', hotKey: 'caps', langs: { fa: { text: 'ب', hotKey: undefined } } },
                { id: 'g', text: 'g', caps: 'G', sym: '%', hotKey: 'caps', langs: { fa: { text: 'ا', caps: 'آ', hotKey: 'caps' } } },
                { id: 'h', text: 'h', caps: 'H', sym: '^', hotKey: 'caps', langs: { fa: { text: 'ت', hotKey: undefined } } },
                { id: 'j', text: 'j', caps: 'J', sym: '&', hotKey: 'caps', langs: { fa: { text: 'ن', hotKey: undefined } } },
                { id: 'k', text: 'k', caps: 'K', sym: '(', hotKey: 'caps', langs: { fa: { text: 'م', hotKey: undefined } } },
                { id: 'l', text: 'l', caps: 'L', sym: ')', hotKey: 'caps', langs: { fa: { text: 'پ', hotKey: undefined } } },
            ]
        },
        {
            items: [
                {
                    text: (
                        <svg style={{ width: "20px", height: "14px" }} width={20} height={14}>
                            <path fill={capsColor} d="M12 7 L12 14 L8 14 L8 7"></path><path fill={capsColor} d="M17 7 L10 0 L3 7"></path>
                        </svg>
                    ),
                    id: 'caps', isChar: false, flex: 1.5,
                },
                { id: 'z', text: 'z', caps: 'Z', sym: '-', hotKey: 'caps', langs: { fa: { text: 'ط', caps: 'ظ', hotKey: 'caps' } } },
                { id: 'x', text: 'x', caps: 'X', sym: '\'', hotKey: 'caps', langs: { fa: { text: 'ز', caps: 'ژ', hotKey: 'caps' } } },
                { id: 'c', text: 'c', caps: 'C', sym: '\"', hotKey: 'caps', langs: { fa: { text: 'ر', hotKey: undefined } } },
                { id: 'v', text: 'v', caps: 'V', sym: ':', hotKey: 'caps', langs: { fa: { text: 'د', caps: 'ذ', hotKey: 'caps' } } },
                { id: 'b', text: 'b', caps: 'B', sym: ';', hotKey: 'caps', langs: { fa: { text: 'و', hotKey: undefined } } },
                { id: 'n', text: 'n', caps: 'N', sym: '~', hotKey: 'caps', langs: { fa: { text: 'ک', hotKey: undefined } } },
                { id: 'm', text: 'm', caps: 'M', sym: '?', hotKey: 'caps', langs: { fa: { text: 'گ', caps: 'ء', hotKey: 'caps' } } },
                {
                    text: (
                        <svg style={{ width: "20px", height: "12px" }} width={20} height={12}>
                            <path fill={keyColor} d="M5 0 L0 6 L5 12 L20 12 L20 0 L5 0"></path>
                            <path stroke={keyBackground} d="M10 4 L14 8"></path><path stroke={keyBackground} d="M14 4 L10 8"></path>
                        </svg>
                    ),
                    id: 'backspace', isChar: false, flex: 1.5
                },
            ]
        },
        {
            items: [
                { text: '!#1', id: 'sym', flex: 1.5 },
                { id: ',', text: ',' },
                { text: state.lang, id: 'space', flex: 5 },
                { id: '.', text: '.' },
                {
                    text: (
                        <svg style={{ width: "20px", height: "14px" }} width={20} height={14}>
                            <path stroke={keyColor} fill='none' d="M18 2 L18 8 L6 8" strokeWidth={4}></path>
                            <path stroke={keyColor} d="M6 8 L6 11 L2 8 L6 5 L6 8" strokeWidth={2}></path>
                        </svg>
                    ),
                    id: 'enter', isChar: false, flex: 1.5
                },
            ]
        }
    ]
    return dic
}

export function PreventScrollReload({ children }: { children?: React.ReactNode }) {
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = divRef.current;
        if (!el) return;

        let startY = 0;

        const handleTouchStart = (e: TouchEvent) => {
            startY = e.touches[0].clientY;
        };

        const handleTouchMove = (e: TouchEvent) => {
            const currentY = e.touches[0].clientY;
            const diff = currentY - startY;

            // فقط اگر حرکت به سمت پایین بود، رفتار پیش‌فرض رو لغو می‌کنیم
            if (diff > 0) {
                e.preventDefault();
            }
        };

        // باید passive:false باشه تا preventDefault کار کنه
        el.addEventListener("touchstart", handleTouchStart, { passive: false });
        el.addEventListener("touchmove", handleTouchMove, { passive: false });

        return () => {
            el.removeEventListener("touchstart", handleTouchStart);
            el.removeEventListener("touchmove", handleTouchMove);
        };
    }, []);

    return (
        <div
            ref={divRef}
            style={{
            }}
        >
            {children || "محتوای شما اینجاست"}
        </div>
    );
}

export const useCustomMemo = () => {
    const depsRef = useRef<any>(undefined);
    const jsxRef = useRef<ReactNode>(null);
    function isEqual(a: any, b: any): boolean {
        const stack: Array<[any, any]> = [[a, b]];
        const visited = new WeakMap<object, object>();

        while (stack.length) {
            const [x, y] = stack.pop()!;

            // strict equal
            if (x === y) continue;

            // null / undefined
            if (x == null || y == null) return false;

            // type mismatch
            const tx = typeof x;
            const ty = typeof y;

            if (tx !== ty) return false;

            // primitive
            if (tx !== "object") return false;

            // circular refs
            const cached = visited.get(x);
            if (cached === y) continue;

            visited.set(x, y);

            // array
            const xArr = Array.isArray(x);
            const yArr = Array.isArray(y);

            if (xArr || yArr) {
                if (!xArr || !yArr) return false;
                if (x.length !== y.length) return false;

                for (let i = 0; i < x.length; i++) {
                    stack.push([x[i], y[i]]);
                }

                continue;
            }

            // date
            if (x instanceof Date || y instanceof Date) {
                if (!(x instanceof Date && y instanceof Date)) {
                    return false;
                }

                if (x.getTime() !== y.getTime()) {
                    return false;
                }

                continue;
            }

            // regexp
            if (x instanceof RegExp || y instanceof RegExp) {
                if (!(x instanceof RegExp && y instanceof RegExp)) {
                    return false;
                }

                if (x.toString() !== y.toString()) {
                    return false;
                }

                continue;
            }

            // object keys
            const keysX = Object.keys(x);
            const keysY = Object.keys(y);

            if (keysX.length !== keysY.length) return false;

            for (let i = 0; i < keysX.length; i++) {
                const key = keysX[i];

                if (!Object.prototype.hasOwnProperty.call(y, key)) {
                    return false;
                }

                stack.push([x[key], y[key]]);
            }
        }

        return true;
    }
    const render = (deps: any, getContent: () => ReactNode) => {
        if (depsRef.current) {
            const eq = isEqual(deps, depsRef.current)
            if (eq) {
                return <>{jsxRef.current}</>;
            }
        }
        const jsx = getContent();
        depsRef.current = deps;
        jsxRef.current = jsx;
        return <>{jsx}</>;
    }
    return { render }
}

export const Arm: FC<{
    size: number;
    angle: number;
    contentAngle?: number | 'fix';
    showLine?: boolean;
    content: ReactNode
    attrs?: any,
    lineBorder?: string
}> = ({ size, angle, contentAngle, showLine, content, attrs, lineBorder = '1px dashed #888' }) => {
    const lineStyle: any = { borderBottom: showLine ? lineBorder : undefined, width: size }
    const pointStyle = { transform: contentAngle === "fix" ? `rotate(${-angle}deg)` : `rotate(${contentAngle || 0}deg)` }
    return (
        <div {...AddToAttrs(attrs, { className: 'arm-center', style: { transform: `rotate(${angle}deg)` } })}>
            <div className='arm-line' style={lineStyle}>
                <div className='arm-point' style={pointStyle}>{content}</div>
            </div>
        </div>
    )
}